export const translations = {
  fr: {
    // Common
    save: 'Sauvegarder',
    load: 'Charger',
    delete: 'Supprimer',
    close: 'Fermer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',

    // Nav
    nav_dashboard: 'Tableau de bord',
    nav_fleet: 'Flotte',
    nav_hr: 'RH',
    nav_fonctions_support: 'Fonctions support',
    nav_depot: 'Dépôt',
    nav_agenda: 'Agenda',
    nav_finance: 'Finances',
    nav_achievements: 'Succès',
    nav_challenges: 'Challenges',
    nav_atouts: 'Phases & Atouts',
    nav_save: 'Sauvegarder',
    nav_quit: 'Quitter',

    // Dashboard
    day: 'Jour',
    month: 'Mois',
    year: 'An',
    treasury: 'Trésorerie',
    reputation: 'Réputation',
    daily_result: 'Résultat du jour',
    working_day: 'Jour ouvré',
    weekend: 'Week-end',
    next_day: 'Jour suivant',
    resolve_events: 'Résoudre les événements',
    fast_forward: 'Avance rapide en cours...',
    available_contracts: 'Contrats disponibles',
    active_contracts: 'Contrats en cours',
    monthly_revenue: 'Revenus du mois',
    monthly_expenses: 'Charges du mois',
    alerts: 'Alertes',
    treasury_evolution: 'Évolution trésorerie',
    market_ranking: 'Classement du marché',
    no_contracts: 'Aucun contrat disponible. Attendez la prochaine vague.',
    accept: 'Accepter',
    active: 'Actif',
    remaining: 'restants',
    per_day: '/jour',
    special: 'SPÉCIAL',
    data_after_days: 'Les données apparaîtront après quelques jours',

    // Fleet
    fleet_title: 'Flotte',
    my_vehicles: 'Mes véhicules',
    buy_vehicle: 'Acheter',
    sell_vehicle: 'Vendre',
    repair: 'Réparer',
    assign_driver: 'Assigner',
    insurance: 'Assurance véhicule',
    insurance_claims: 'Sinistres déclarés',
    file_claim: 'Déclarer un sinistre',
    max_claims: 'Maximum de sinistres atteint. Couverture refusée.',
    coverage: 'Couverture actuelle',
    total_vehicles: 'Total véhicules',
    on_mission: 'En mission',
    fleet_value: 'Valeur flotte',
    broken_count: 'En panne',
    my_fleet: 'Ma flotte',
    buy_tab: 'Acheter',
    leasing_tab: 'Leasing',
    available_status: 'Disponible',
    active_status: 'En mission',
    maintenance_status: 'En entretien',
    broken_status: 'En panne',
    km_traveled: 'Km parcourus',
    active_days: 'Jours actifs',
    revenue_generated: 'Revenus générés',
    sell_confirm_title: 'Vendre ce véhicule ?',
    sell_confirm_text: 'Vous allez vendre le',
    estimated_resale: 'Prix de revente estimé',
    of_new_price: 'du prix neuf de',
    driver_released: 'Le chauffeur assigné sera libéré.',
    assign_a_driver: 'Assigner un chauffeur',
    wear: 'Usure',
    wear_critical: 'Usure critique — risque de panne !',
    hide_stats: 'Masquer les stats',
    show_stats: 'Voir les stats',
    no_vehicle: 'Aucun véhicule. Achetez votre premier véhicule !',
    already_owned: 'Déjà possédé',
    insufficient_funds: 'Fonds insuffisants',
    locked: 'Verrouillé',
    models: 'modèles',
    license_required: 'Permis {license} requis',
    leasing_title: 'Leasing véhicule',
    leasing_description: 'Louez un véhicule sans payer le prix d\'achat. Déposez 10% à la signature et payez des mensualités fixes. En fin de contrat, le véhicule est restitué (ou rachetable à valeur résiduelle de 25%).',
    chosen_duration: 'Durée choisie',
    current_payments: 'Mensualités en cours',
    months_remaining: 'mois restants',
    buyout: 'Racheter',
    sign_lease: 'Signer le leasing',
    insufficient_deposit: 'Dépôt insuffisant',
    new_price: 'neuf',
    deposit: 'Dépôt',
    buyout_possible: 'Rachat possible',
    declare_claim: 'Déclarer un sinistre',
    premium: 'Prime',
    claim_number: 'Sinistre',
    reimbursement: 'Remboursement',
    franchise: 'Franchise',
    used_vehicle: 'Occasion',
    purchase_at: 'achat',

    // HR
    hr_title: 'Ressources Humaines',
    team: 'Mon équipe',
    recruit: 'Recruter',
    hire: 'Recruter',
    fire: 'Licencier',
    train: 'Former',
    bonus: 'Prime',
    rest: 'Repos',
    headcount: 'Effectif',
    in_training: 'En formation',
    payroll: 'Masse salariale',
    team_tab: 'Équipe',
    recruit_tab: 'Recruter chauffeur(s)',
    training_label: 'Formation',
    active_hr_status: 'Actif',
    resting_status: 'Repos',
    available_hr_status: 'Disponible',
    // 07/02/2026 — P0 fix : statuts manquants dans le badge HR (le composant
    // affichait « Disponible » par défaut pour vacation/sick/striking/returning).
    holiday_hr_status: 'En congés',
    sick_hr_status: 'Arrêt maladie',
    striking_hr_status: 'En grève',
    returning_hr_status: 'Retour de mission',
    fatigue: 'Fatigue',
    satisfaction: 'Satisfaction',
    fatigue_high: 'Fatigue élevée',
    satisfaction_low: 'Satisfaction basse',
    details: 'Détails',
    hide: 'Masquer',
    no_driver: 'Aucun chauffeur. Recrutez votre premier chauffeur !',
    recruit_now: 'Recruter maintenant',
    no_candidate: 'Aucun candidat disponible. Progressez pour débloquer plus de profils.',
    locked_profiles_section: 'Profils verrouillés',
    locked_profiles_hint: 'Ces profils existent sur le marché mais ne sont pas encore accessibles — remplissez la condition affichée pour les débloquer.',
    experience: 'Expérience',
    accident_risk: 'Risque accident',
    strength: 'Point fort',
    weakness: 'Point faible',
    trainings_done: 'Formations suivies',
    remove: 'Retirer',
    level: 'Niv.',
    years_exp: 'ans exp.',
    available_trainings: 'Formations disponibles',
    acquired: 'Acquis',
    done: 'Fait',
    training_days: 'j',

    // Depot
    depot_title: 'Dépôt',
    depot_plan: 'Plan du dépôt',
    upgrade: 'Améliorer',
    active_zones: 'Zones actives',
    parked_vehicles: 'Véh. stationnés',
    vehicles_on_mission: 'Véh. en mission',
    depot_charges: 'Charges dépôt',
    build: 'Construire',
    zone_operational: 'Zone opérationnelle',
    upgrades_label: 'Améliorations',
    activate: 'Activer',
    not_built: 'Non construit',
    level_label: 'Niveau',
    route_label: 'ROUTE D42 — ZONE INDUSTRIELLE',
    entrance: 'ENTREE',
    garage_label: 'GARAGE',
    loading_dock: 'QUAI CHARGEMENT',
    warehouse_label: 'ENTREPOT',
    cold_zone: 'ZONE FRIGO',
    diesel_station: 'STATION DIESEL',
    vehicles_label: 'VEHICULES',
    parked: 'garés',
    on_mission_depot: 'en mission',
    broken_depot: 'en panne',
    zones_active_label: 'ZONES ACTIVES',

    // Finance
    finance_title: 'Finances',
    income: 'Revenus',
    expenses: 'Dépenses',
    net_result: 'Résultat net',
    loan: 'Emprunt',
    revenue_per_month: 'Revenus/mois',
    charges_per_month: 'Charges/mois',
    overview: 'Vue générale',
    income_statement: 'Compte de résultat',
    credits_tab: 'Crédits',
    treasury_chart: 'Évolution de la trésorerie',
    revenue_vs_expenses: 'Revenus vs Dépenses (30 derniers jours)',
    monthly_summary: 'Bilan mensuel',
    products: 'Produits',
    revenue_contracts: 'Chiffre d\'affaires (contrats)',
    total_products: 'Total produits',
    charges: 'Charges',
    total_charges: 'Total charges',
    net_monthly_result: 'Résultat net mensuel',
    margin: 'Marge',
    charges_breakdown: 'Répartition des charges',
    no_active_charge: 'Aucune charge active',
    total_debt: 'Dette totale',
    monthly_payments: 'Mensualités',
    num_credits: 'Nb crédits',
    active_credits: 'Crédits en cours',
    no_credit: 'Aucun crédit en cours',
    credit_number: 'Crédit',
    months_left: 'mois restants',
    capital: 'Capital',
    monthly_payment: 'Mensualité',
    remaining_due: 'Restant dû',
    rate: 'Taux',
    amortization_table: 'Tableau d\'amortissement constant',
    total_interest_cost: 'Coût total intérêts',
    total_repaid: 'Total remboursé',
    month_col: 'Mois',
    payment_col: 'Mensualité',
    capital_col: 'Capital',
    interest_col: 'Intérêts',
    remaining_col: 'Restant',
    credit_simulator: 'Simulateur de crédit',
    amount: 'Montant',
    duration: 'Durée',
    estimated_payment: 'Mensualité estimée (amort. constant)',
    annual_rate: 'Taux : 5,5% annuel',
    total_cost: 'Coût total',
    take_loan: 'Contracter ce crédit',
    insufficient_data: 'Données insuffisantes',
    statement_month: 'Compte de résultat (Mois {month}, Année {year})',

    // Challenges
    challenges_title: 'Challenges',
    start_challenge: 'Lancer ce challenge',
    abandon_challenge: 'Abandonner ce challenge',
    challenge_won: 'Challenge réussi !',
    challenge_failed: 'Challenge échoué',
    time_remaining: 'restants',
    completed: 'REUSSI',
    in_progress: 'EN COURS',
    current_value: 'Actuel',
    max_value: 'max',
    ok_status: 'OK',
    failed_status: 'ECHOUE',

    // Difficulty
    easy: 'Facile',
    normal: 'Normal',
    hard: 'Difficile',

    // Audio
    sound_effects: 'Effets sonores',
    music: 'Musique',
    volume: 'Volume',

    // Create Company
    company_name: 'Nom de votre société',
    choose_name: 'Choisissez un nom pour votre entreprise de transport.',
    logo: 'Logo de votre société',
    starting_city: 'Ville de départ',
    difficulty_level: 'Niveau de difficulté',
    initial_specialty: 'Spécialité initiale',
    launch: 'Lancer ma société',
    resume_game: 'Reprendre une partie',
    characters: 'caractères',

    // Settings
    language: 'Langue',
    french: 'Français',
    english: 'English',

    // Monthly Report
    monthly_report: 'Bilan mensuel',
    best_driver: 'Meilleur chauffeur',
    vehicles_active: 'Véhicules actifs',
    contracts_completed: 'Contrats terminés',

    // Misc
    quit_confirm: 'Quitter la partie ? Pensez à sauvegarder avant.',
    phase: 'Phase',
    loading: 'Chargement...',
    // --- i18n audit additions (2026-02) ---
    create_company_to_unlock: 'Créez votre entreprise pour commencer à débloquer des succès.',
    license_too_short: 'Clé de licence trop courte',
    invalid_key: 'Clé invalide',
    waiting_room_title: "Salle d'attente",
    waiting_room_opens: 'Votre session ouvrira le',
    waiting_room_auto: "L'accès se déverrouillera automatiquement — gardez cette page ouverte.",
    waiting_room_entering: "C'est l'heure ! Ouverture de la simulation…",
    waiting_days: 'Jours',
    waiting_hours: 'Heures',
    waiting_minutes: 'Minutes',
    waiting_seconds: 'Secondes',
    waiting_change_key: 'Utiliser une autre clé',
    app_subtitle: 'HYPER SOCIÉTÉ DE TRANSPORT',
    no_advisor_selected: 'Aucun guide sélectionné',
    presentation_mode_title: 'Mode présentation plein écran (F11)',
    exit_presentation_title: 'Quitter le mode présentation (Échap)',
    presentation_label: 'Présentation',
    advisor_label: 'Conseiller',
    advisor_active: 'Conseiller actif',
    active_status_short: 'ACTIF',
    quit: 'Quitter',
    exit_presentation: 'Quitter présentation',
    operations_group: 'Opérations',
    finance_group: 'Finance',
    strategy_group: 'Stratégie',
    dashboard_title: 'Tableau de bord',
    pilot_console: 'Console Pilote',
    system_operational: 'SYSTÈME · OPÉRATIONNEL',
    date_label: 'Date',
    current_balance: 'Solde courant',
    daily_delta: 'Δ Quotidien',
    net_last_day: 'Net dernier jour',
    advance_5days: 'Avancer de 5 jours',
    advance_week: 'Avancer d\'une semaine',
    go_to: 'Allez dans',
    and_recruit_driver: 'et recrutez un chauffeur',
    to_accept_contracts: 'Pour accepter des contrats :',
    assign_driver_hint: 'Assignez un chauffeur à un véhicule disponible dans la page Flotte.',
    aerial_view_site: 'Vue aérienne — Site HST',
    click_on_zone: 'Cliquez sur une zone',
    repair_all_fleet: 'Réparer toute la flotte',
    available_treasury: 'Trésorerie disponible',
    market_competition_title: 'Marché & Concurrence',
    active_on_your_market: 'actifs sur votre marché',
    your_revenue: 'Votre CA',
    total_daily_per_driver: 'Total journalier par chauffeur',
    no_competitive_event: 'Aucun événement concurrentiel pour le moment',
    competitor_recent_event: 'Évènements récents',
    fiscality_title: 'Fiscalité',
    vat_to_pay: 'À reverser',
    vat_credit: 'Crédit TVA',
    is_estimated: 'IS estimé',
    regime_label: 'Régime',
    deadlines: 'Échéances',
    vat_declaration: 'Déclaration TVA',
    next_payment: 'Prochaine échéance',
    cfe_label: 'CFE — Cotisation foncière',
    cvae_label: 'CVAE — Cotisation sur valeur ajoutée',
    axle_tax: 'Taxe à l\'essieu',
    optimizations: 'Optimisations fiscales',
    international_tax: 'Fiscalité internationale',
    status_compliant: 'Conforme',
    status_late: 'En retard',
    limited_credit: 'Crédit limité',
    granted_amount: 'Montant accordé',
    total_interests: 'Intérêts totaux',
    apply: 'Faire une demande',
    bank_rating_score: 'Note de fiabilité',
    bank_proposal: 'Proposition',
    bank_advisor_name: 'Conseiller bancaire',
    holder_name_required: 'Nom du titulaire *',
    owner_field_label: 'Propriétaire / Assignation (champ libre)',
    ip_limit_label: 'Limite d\'IP (0 = illimité)',
    ip_limit_help: 'Nombre maximum d\'adresses IP distinctes autorisées. 0 = pas de limite.',
    contact_name: 'Nom du contact',
    contact_email_required: 'Email du contact *',
    duration_months_label: 'Durée (en mois)',
    notes_internal: 'Notes internes',
    generate_license: 'Générer une licence',
    search_placeholder: 'Rechercher par nom, email, propriétaire ou clé...',
    no_license_found: 'Aucune licence trouvée',
    expired: 'Expirée',
    expires_soon: 'Expire bientôt',
    copy_key: 'Copier la clé',
    revoke: 'Révoquer',
    extend: 'Prolonger',
    stats_total: 'Total licences',
    stats_active: 'Actives',
    stats_expired: 'Expirées',
    stats_unused: 'Non utilisées',
    hst_subtitle: 'Hyper Société de Transport',
    import_logo_or_select: 'Importez votre logo ou sélectionnez un modèle.',
    logo_imported_ok: 'Logo importé avec succès',
    preset_logos: 'Modèles prédéfinis',
    upload_logo: 'Importer un logo',
    remove_custom_logo: 'Retirer le logo importé',
    starting_city_hint: 'Le siège de votre société sera basé dans cette ville.',
    difficulty_hint: 'Ajustez le défi à votre niveau.',
    specialty_hint: 'Votre orientation métier dès le départ.',
    advisor_hint: 'Qui vous accompagnera dans votre aventure ?',
    advisor_skip: 'Continuer sans guide',
    unlocked: 'Débloqué :',
    vehicle_compat: 'Compatibilité véhicules',
    no_vehicle_fleet: 'Aucun véhicule dans la flotte',
    training_impact: 'Impact des formations',
    team_total_xp: 'XP total équipe',
    driver_of_month: 'Chauffeur du mois',
    team_overview: 'Vue d\'ensemble équipe',
    spec_compatible: 'Spécialités compatibles',
    monthly_revenue_label: 'Revenus du mois',
    monthly_expenses_label: 'Dépenses du mois',
    net_result_label: 'Résultat net',
    active_vehicles_label: 'Véhicules actifs',
    reputation_label: 'Réputation',
    driver_of_month_label: 'Chauffeur du mois',
    monthly_report_close: 'Continuer',
    estimated_cost: 'Coût estimé',
    impact_duration: 'Durée impact',
    market_ranking_title: 'Classement du marché',
    your_position: 'Votre position',
    new_unlocks: 'Nouveaux déblocages',
    lets_go: 'C\'est parti !',
    selected_city: 'Ville sélectionnée',
    saved: 'Sauvegardé !',
    choose_guide: 'Choisissez votre guide',
    capacity_under_used: 'Capacité sous-exploitée',
    choose_vehicle_driver: 'Choisissez un véhicule et son chauffeur',
    no_vehicle_available: 'Aucun véhicule disponible',
    all_vehicles_busy: 'Tous vos véhicules sont en mission ou n\'ont pas de chauffeur assigné.',
    license_activation: 'Activation de licence',
    enter_key_hint: 'Saisissez votre clé pour accéder au jeu',
    license_key: 'Clé de licence',
    verifying: 'Vérification...',
    activate_license: 'Activer la licence',
    contact_admin_no_key: 'Contactez votre administrateur si vous n\'avez pas de clé de licence.',

    // ---- LicenseGate (Tier A i18n migration 29/05/2026) ----
    master_login_not_master_key: "Cette clé n'est pas une licence Responsable Pédagogique.",
    master_login_disabled_or_expired: "Cette licence a été désactivée ou a expiré.",
    master_login_invalid_key: "Clé Responsable Pédagogique invalide.",
    master_space_title: 'Espace Responsable Pédagogique',
    master_space_subtitle: 'Supervision de cohorte',
    mode_apprentice: 'Apprenant',
    mode_master: 'Responsable',
    master_key_label: 'Clé Responsable Pédagogique',
    access_supervision: 'Accéder à la supervision',
    master_supervision_only_note: 'La licence master permet uniquement la supervision — vous ne pouvez pas jouer avec.',
    demo_cta_banner: 'Voir la démo (2 min) — sans licence',

    // ---- Demo + DemoContactForm (Tier A) ----
    demo_subtitle: 'Démo express · 2 min',
    demo_stat_treasury: 'Trésorerie',
    demo_stat_vehicles: 'Véhicules',
    demo_stat_drivers: 'Chauffeurs',
    demo_stat_contracts: 'Contrats',
    demo_stat_reputation: 'Réputation',
    demo_stat_achievements: 'Badges',
    demo_contact_intro: 'Pour aller plus loin avec votre cohorte, laissez-nous votre email — nous revenons vers vous sous 24 h ouvrées.',
    demo_step_label: 'Étape',
    demo_already_have_license: "J'ai déjà une licence",
    demo_control_pause: 'Pause',
    demo_control_resume: 'Reprendre',
    demo_control_skip: 'Suivant',
    demo_control_restart: 'Recommencer',

    // ---- Achievements (Tier B) ----
    achievements_unlocked_pct: 'débloquées',

    // ---- HR (Tier B) ----
    hr_tab_departure: 'Départ',
    hr_dislikes_unlock_note: "dans Fonctions Support pour révéler ce que chaque chauffeur",
    hr_dislikes_unlock_word: "déteste",
    hr_insights_hint_prefix: 'Embauchez',
    hr_insights_hint_role: 'Nadia Cheikh — Responsable RH',
    hr_insights_hint_mid: 'dans Fonctions Support pour révéler ce que chaque chauffeur',
    hr_insights_hint_likes: 'aime',
    hr_insights_hint_or: 'ou',
    hr_insights_hint_dislikes: 'déteste',
    hr_insights_hint_suffix: 'en mission, et voir leur humeur en temps réel.',

    // ---- DAFCommentary (Tier C) ----
    daf_avis_title: 'Avis stratégique du DAF',
    daf_refresh: 'Rafraîchir',
    daf_loading_caption: 'Le DAF étudie le dossier…',
    daf_retry: 'Réessayer',
    daf_default_error: 'Impossible de générer le rapport.',
    daf_default_no_weakness: 'Aucune faiblesse identifiée',

    // ---- CreateCompany (Tier A) ----
    cc_legal_status_step: 'Statut juridique',
    cc_company_tagline: 'Hyper Société de Transport',
    cc_city_rent: 'Loyer QG ≈ {{rent}} €/mois',
    cc_city_rent_free: 'exonéré les {{days}} premiers jours',
    driver_lumery_duo_badge: 'Bonus fratrie : −10 % de fatigue (frères au même dépôt)',
    cc_city_zone_bonus: 'Zone locale — bonus −10 % carburant dans un rayon 200 km',
    cc_diff_revenues: 'Revenus',
    cc_diff_charges: 'Charges',
    cc_diff_capital: 'Capital',
    cc_name_placeholder: 'Ex : Transports Durand',
    cc_save_day_label: 'Jour',
    cc_save_phase_label: 'Phase',
    cc_save_vehicles_short: 'veh.',
    cc_save_drivers_short: 'chauff.',
    spec_messagerie_name: 'Messagerie',
    spec_messagerie_desc: 'Colis, express, e-commerce. Revenus stables, véhicules légers.',
    spec_messagerie_revenue: '1 500 - 3 000 €/mois',
    spec_vrac_name: 'Vrac / Palettes',
    spec_vrac_desc: 'Palettes, matériaux, distribution GMS. Volumes importants.',
    spec_vrac_revenue: '2 000 - 4 000 €/mois',
    spec_frigo_name: 'Frigorifique',
    spec_frigo_desc: 'Alimentaire, pharma, chaîne du froid. Marge élevée.',
    spec_frigo_revenue: '2 500 - 5 000 €/mois',

    // ---- HQOfficePanel (Tier C) ----
    hq_locked_title: 'Siège social — Verrouillé',
    hq_unlocked_title: 'Siège social — Bureaux dédiés',
    // ---- Compte à rebours siège social (18/06/2026) ----
    hq_deadline_title: 'Siège social requis — J-{{days}}',
    hq_deadline_body: "Vos 3 fonctions support ont besoin de vraies conditions de travail. Investissez dans le « Siège social / Bureau dédié » (ci-dessous, famille Administratif) avant l'échéance, sinon votre dernière recrue démissionnera.",
    hq_resigned_title: 'Une fonction support a démissionné — siège social manquant',
    hq_resigned_body: "Impossible de recruter une 3e fonction support tant que l'investissement « Siège social / Bureau dédié » n'est pas réalisé.",
    hq_hire_blocked_toast: "Recrutement bloqué : investissez d'abord dans le « Siège social / Bureau dédié » avant de réembaucher une 3e fonction support.",
    hq_locked_body: "Vos équipes support s'entassent dans la cabane du dépôt. Dès {threshold} fonctions support recrutées, vous aurez 45 jours pour investir dans le « Siège social / Bureau dédié » (onglet Fonctions support) — sous peine de démission de votre dernière recrue.",
    hq_locked_more_to_hire: 'Plus que {count} à recruter',
    hq_locked_unlock_imminent: 'Déblocage imminent',
    hq_unlocked_body: "Aménagement progressif via les propositions reçues dans la Messagerie. Chaque équipement améliore la satisfaction de toute l'équipe (chauffeurs + support).",
    hq_upgrades_installed: 'équipements installés',
    hq_equipment_section: 'Équipements',
    hq_upgrade_pending_mail: 'À recevoir par mail',
    hq_kpi_support: 'Effectif support',
    hq_kpi_monthly: 'Charge mensuelle',
    hq_kpi_satisfaction: 'Bonus satisfaction',

    // ---- HireNegotiationModal (Tier C) - quick wins on visible bits ----
    hn_subtitle: 'Négociation salariale',
    hn_band_refus_label: 'Refus probable',
    hn_band_refus_detail: 'Le candidat va partir et sera indisponible 45 à 90 jours.',
    hn_band_rancune_label: 'Accepte à contrecœur',
    hn_band_rancune_detail: 'Le candidat acceptera mais commencera avec -10 satisfaction (rancune).',
    hn_band_ok_label: 'Offre équitable',
    hn_band_ok_detail: 'Le candidat accepte au juste prix, satisfaction normale.',
    hn_band_genereuse_label: 'Offre généreuse',
    hn_band_genereuse_detail: 'Le candidat est enchanté, +10 satisfaction de départ.',
    hn_offer_rejected: 'Offre refusée',
    hn_offer_accepted: 'Offre acceptée',
    hn_close: 'Fermer',
    hn_profile: 'Profil',
    hn_expected: 'Demande',
    hn_your_offer: 'Votre offre',
    hn_per_month_gross: '/mois brut',
    hn_target: 'Cible',
    hn_contract_type: 'Type de contrat',
    hn_propose_at: 'Faire une proposition à',
    hn_per_month: '/mois',
    hn_expected_at_least: 'attendait au moins',
    hn_and_refused: 'et a refusé votre offre de',
    hn_unavailable_until: "Indisponible jusqu'au jour",
    hn_joins_team_for: "rejoint l'équipe pour",
    hn_gross_per_month: 'brut/mois',
    hn_resentment: 'rancune',
    hn_cdi_full_time: 'Salarié à temps plein, charges patronales incluses dans le coût indiqué.',
    hn_no_freelance_note: 'Statut auto-entrepreneur (sous-traitance) non disponible : vous êtes le dirigeant, vous recrutez des chauffeurs salariés — vous ne pouvez pas conduire vous-même.',

    // ---- Fiscalite (Tier B) - page header + tab labels ----
    fisc_title: 'Fiscalité',
    fisc_kpi_tva_net: 'TVA nette',
    fisc_kpi_tva_to_pay: 'À reverser',
    fisc_kpi_tva_credit: 'Crédit TVA',
    fisc_kpi_is_estimated: 'IS estimé (annuel)',
    fisc_kpi_is_annual_basis: 'Sur bénéfice annualisé',
    fisc_kpi_is_paid: 'Payé',
    fisc_kpi_is_damped_hint: 'Estimation lissée (échantillon < 3 mois)',
    fisc_kpi_is_damped_tooltip: 'Extrapolation lissée : les mois 1-2 utilisent un plancher × 4 (au lieu de × 12 / × 6) pour éviter des projections instables sur un échantillon trop court.',
    ao_aggression_title: 'Concurrence renforcée',
    ao_aggression_days_left: 'j restants',
    ao_aggression_body: 'Suite au dernier article d\'Actu Transport, vos concurrents sont plus agressifs : probabilité de contre-offre boostée et remise client +4 pts (12 % au lieu de 8 %). Défendez vos marges.',
    fisc_kpi_regime: 'Régime',
    fisc_kpi_tva_monthly: 'TVA mensuelle',
    fisc_kpi_tva_quarterly: 'TVA trimestrielle',
    fisc_kpi_deadlines: 'Échéances',
    fisc_kpi_pending_count: 'en attente',
    fisc_kpi_none: 'Aucune',
    fisc_month: 'Mois',
    fisc_year: 'An',
    fisc_tab_overview: 'Vue d\'ensemble',
    fisc_tab_tva: 'TVA',
    fisc_tab_is: 'Impôt Sociétés',
    fisc_tab_local: 'Taxes locales',
    fisc_tab_regime: 'Régime & Optimisation',
    fisc_tab_statut: 'Statut Juridique',
    fisc_tab_intl: 'International',

    // ---- FonctionsSupport (Tier B) - visible labels ----
    fs_title: 'Fonctions support',
    fs_intro: 'Recrutez des profils stratégiques (hors chauffeurs) pour débloquer des bonus, réduire vos coûts et accélérer votre croissance.',
    fs_hired: 'Recruté',
    fs_salary: 'Salaire',
    fs_unlocks_prefix: 'Débloque',
    fs_fire: 'Renvoyer',
    fs_recruit: 'Recruter',
    fs_locked: 'Verrouillé',
    fs_treasury_short: 'Trésorerie insuffisante pour 1 mois de salaire',
    fs_tool: 'Outil',
    fs_cost: 'Coût',
    fs_deactivate: 'Désactiver',
    fs_activate: 'Activer',
    fs_kpi_hired_count: 'Salariés support',
    fs_kpi_payroll: 'Masse salariale',
    fs_kpi_revenue_bonus: 'Bonus revenus cumulé',
    fs_kpi_families_coverage: 'Familles couvertes',
    fs_entry_singular: 'entrée',
    fs_entry_plural: 'entrées',

    // ---- CompetitionAnalysis (Tier B) ----
    ca_family_marketing: 'Marketing',
    ca_family_commerce: 'Commerce',
    ca_family_admin: 'Administration / Exploitation',
    ca_family_finance: 'Comptabilité / Finance',
    ca_locked_title: "Cellule d'analyse concurrentielle",
    ca_locked_body: "Pour débloquer l'analyse approfondie de vos concurrents et envisager des opérations de fusion-acquisition, vous devez d'abord recruter au moins un membre dans chacune des 4 fonctions suivantes :",
    ca_locked_tip: "Astuce apprenant : ces 4 fonctions support sont le socle d'une équipe de direction capable de mener un projet de M&A. Recrutez-les depuis l'onglet Support.",
    ca_unlocked_title: 'Analyse concurrentielle',
    ca_unlocked_subtitle: 'Synthèse fournie par votre cellule Marketing + Commerce + Exploitation + DAF.',
    ca_owned_depots: 'Dépôts détenus',
    ca_kpi_ca: 'CA / mois',
    ca_kpi_fleet: 'Flotte',
    ca_kpi_drivers: 'Chauffeurs',
    ca_kpi_reputation: 'Réputation',
    ca_stat_equity: 'Capitaux propres',
    ca_stat_margin: 'Marge nette',
    ca_stat_debt: 'Dette nette',
    ca_health_label: 'Note santé globale',
    ca_weakness_label: 'Faiblesse exploitable',
    ca_daf_price_label: 'Prix proposé par le DAF',
    ca_already_acquired: 'Acquis · ce dépôt est désormais à vous',
    ca_start_acquisition: 'Initier une opération de rachat',
    ca_reco_default_label: 'Cible correcte',
    ca_locked_already: 'Concurrent déjà racheté',
    ca_locked_pending: 'Une opération M&A est déjà en cours',
    ca_locked_cooldown_prefix: 'LOI précédemment refusée — ré-essayer dans',
    ca_locked_cooldown_suffix: 'j',
    ca_locked_quota: 'Quota de dépôts atteint (3/3)',

    // ---- PhaseNotification (Tier C) ----
    phase_2_title: 'Phase Régionale',
    phase_2_subtitle: "Votre société s'étend !",
    phase_2_desc: "Vous avez débloqué l'accès aux zones régionales. De nouvelles routes, de nouveaux contrats et des véhicules plus gros vous attendent.",
    phase_2_u1: 'Contrats régionaux (vrac, palettes, BTP)',
    phase_2_u2: 'Véhicules Tier 2 — Porteurs 7T-12T',
    phase_2_u3: 'Chauffeurs confirmés (permis C)',
    phase_2_u4: 'Nouvelles zones : Grand Est, Normandie, Bretagne',
    phase_3_title: 'Phase Nationale',
    phase_3_subtitle: 'Votre réseau couvre la France !',
    phase_3_desc: 'Les axes nationaux sont à votre portée. Semi-remorques, longues distances et contrats lucratifs deviennent accessibles.',
    phase_3_u1: 'Contrats nationaux longue distance',
    phase_3_u2: 'Semi-remorques Tier 3 — VOLVAX, SCANEX, DAFORA',
    phase_3_u3: 'Chauffeurs expérimentés (permis CE)',
    phase_3_u4: 'Axes Paris-Lyon-Marseille-Bordeaux-Lille',
    phase_4_title: 'Phase Européenne',
    phase_4_subtitle: "L'Europe est à vous !",
    phase_4_desc: "L'export EU est maintenant accessible. Contrats internationaux prestige, véhicules spécialisés et marges exceptionnelles.",
    phase_4_u1: 'Contrats Export EU — Espagne, Allemagne, Italie, Benelux',
    phase_4_u2: 'Véhicules Tier 4-5 — Spécialisés et prestige',
    phase_4_u3: 'Chauffeurs seniors et experts multilingues',
    phase_4_u4: 'SCANEX R 650 V8 Prestige et VOLVAX Electric',
    phase_new_phase_label: 'Nouvelle phase',

    // ---- Demo scene script (Tier A i18n migration 29/05/2026) ----
    demo_scene_intro_narrator: 'Bienvenue dans HST. En 2 minutes, vous allez piloter une véritable société de transport.',
    demo_scene_intro_cta: 'Commencer',
    demo_scene_hire_narrator: "Premier réflexe : recruter un·e chauffeur·e. Sophie Martin a 5 ans d'expérience — elle s'occupera des contrats prioritaires.",
    demo_scene_hire_experience: "5 ans d'expérience",
    demo_scene_hire_specialty: 'Frigo',
    demo_scene_hire_cta: 'Embaucher Sophie (2 400 € / mois)',
    demo_scene_contract_narrator: "Carrefour cherche un transporteur. 28 jours, 850 € HT par jour. Vous flairez l'affaire.",
    demo_scene_contract_kind: 'Frais',
    demo_scene_contract_cta: 'Accepter le contrat',
    demo_scene_ff_narrator: "Trois jours s'écoulent. Sophie roule, Carrefour paie, votre trésorerie respire.",
    demo_scene_ff_cta: 'Avancer le temps ×3',
    demo_scene_event_narrator: "Imprévu — panne moteur sur votre Mercedes Actros. Décision rapide : payer 1 200 € ou attendre l'assurance ?",
    demo_scene_event_title: 'Panne moteur Actros',
    demo_scene_event_impact: '-1 jour de mission',
    demo_scene_event_cta: 'Réparer immédiatement (1 200 €)',
    demo_scene_capex_narrator: "Tristan Midal — votre DAF — calcule : acheter ce Renault Master vous fait économiser 6 200 € d'IS sur 5 ans.",
    demo_scene_capex_vehicle: 'Renault Master Frigo',
    demo_scene_capex_cta: 'Investir (45 000 €)',
    demo_scene_support_narrator: 'Nadia Cheikh, Responsable RH, vous propose ses services. Elle débloque le Tableau de Bord RH avancé.',
    demo_scene_support_role: 'Responsable RH',
    demo_scene_support_u1: 'Tableau RH avancé',
    demo_scene_support_u2: 'Détection chauffeurs à risque',
    demo_scene_support_u3: 'Coaching équipe',
    demo_scene_support_cta: 'Embaucher Nadia',
    demo_scene_ach_narrator: 'Vos premières décisions paient — un badge se débloque. Le système de carrière vous suit pendant toute la partie.',
    demo_scene_ach_title: 'Premiers pas en tant que dirigeant',
    demo_scene_ach_description: '5 décisions stratégiques en moins de 5 jours',
    demo_scene_ach_cta: 'Voir mon profil carrière',
    demo_scene_recap_narrator: 'Vous venez de voir 8 mécaniques fondamentales. HST en propose plus de 40 — fiscalité, M&A, banque, événements aléatoires, supervision pédagogique…',
    demo_scene_recap_f1: 'Gestion RH (chauffeurs + support)',
    demo_scene_recap_f2: 'Contrats clients & négociation',
    demo_scene_recap_f3: 'Trésorerie & comptes annuels',
    demo_scene_recap_f4: 'Événements aléatoires (pannes, grèves, audits)',
    demo_scene_recap_f5: 'Investissement CAPEX & amortissements',
    demo_scene_recap_f6: 'Fiscalité PME (TVA, IS, CFE)',
    demo_scene_recap_f7: 'Banque & crédits + scoring',
    demo_scene_recap_f8: 'M&A et expansion multi-dépôts',
    demo_scene_contact_narrator: "Pour aller plus loin avec votre cohorte, laissez-nous un email — nous revenons vers vous sous 24h ouvrées.",

    // ---- Demo scene visual labels (shared) ----
    demo_scene_header_recruitment: 'Recrutement chauffeur',
    demo_scene_header_contract: 'Proposition de contrat',
    demo_scene_header_time: 'Avancement temporel',
    demo_scene_header_event: 'Événement imprévu',
    demo_scene_header_capex: 'Investissement CAPEX — conseil DAF',
    demo_scene_header_support: 'Recrutement fonction support',
    demo_scene_header_recap: 'Vous avez voyagé',
    demo_scene_hire_signing: 'CDI',
    demo_scene_hire_monthly_salary: 'Salaire mensuel',
    demo_scene_hire_recruit: 'Embauche',
    demo_scene_contract_client: 'Client',
    demo_scene_contract_daily_rate: 'Taux journalier',
    demo_scene_contract_total_ht: 'CA total HT',
    demo_scene_capex_price: "Prix d'achat",
    demo_scene_capex_annual_is_saved: 'IS économisé / an',
    demo_scene_capex_total_is_saved: 'IS économisé total',
    demo_scene_capex_net_cost: 'Coût net après IS',
    demo_scene_event_cost: 'Coût de réparation',
    demo_scene_support_monthly_cost: 'Coût mensuel',
    demo_scene_ach_unlocked: 'Achievement débloqué',
    demo_scene_recap_intro: 'Vous avez vu',
    demo_scene_recap_outro: 'Et plus de 40 mécaniques avancées attendent votre cohorte.',
    demo_subtitle_hero: 'Simulateur pédagogique professionnel — gestion d\'une entreprise de transport routier.',
    demo_ff_subtitle: 'Sophie roule · revenu net',
    demo_ff_per_day: '€ / jour',
    load_save: 'Charger',
    step: 'Étape',
    step_name: 'Nom',
    step_logo: 'Logo',
    step_city: 'Ville',
    step_difficulty: 'Difficulté',
    step_specialty: 'Spécialité',
    step_guide: 'Guide',
    company_name_question: 'Nom de votre société',
    name_hint: 'Choisissez un nom pour votre entreprise de transport.',
    company_logo: 'Logo de votre société',
    launch_game: 'Lancer la partie',
    min_3: '(min. 3)',
    difficulty_choice: 'Difficulté',
    pick_difficulty: 'Ajustez le défi à votre niveau.',
    pick_specialty: 'Votre orientation métier dès le départ.',
    pick_guide: 'Qui vous accompagnera dans votre aventure ?',
    pick_city: 'Le siège de votre société sera basé dans cette ville.',
    pick_logo: 'Importez votre logo ou sélectionnez un modèle.',
    continue_without_guide: 'Continuer sans guide',
    saved_at: 'Sauvegarde du',
    delete_save: 'Supprimer la sauvegarde',
    upload_your_logo: 'Importer votre logo',
    upload_format_hint: 'PNG, JPG, SVG — max 500 Ko',
    or_pick_template: 'ou choisissez un modèle',
    image_too_heavy: 'Image trop lourde (max 500 Ko)',
    city_pick_hint: 'Sélectionnez une ville ou cliquez directement sur la carte.',
    logo_classic: 'Classique',
    logo_plus: 'Plus',
    logo_triangle: 'Triangle',
    logo_circle: 'Cercle',
    logo_bar: 'Barre',
    logo_x: 'X',
    logo_truck: 'Camion',
    logo_wheel: 'Roue',
    logo_package: 'Colis',
    logo_pallet: 'Palette',
    logo_container: 'Container',
    logo_compass: 'Boussole',
    logo_road: 'Route',
    logo_network: 'Réseau',
    advisor_intro: 'Un professeur vous accompagnera tout au long de votre aventure. Vous pourrez en changer dans les paramètres.',
    guide_selected: 'Guide sélectionné',
    advisor_disable_hint: 'Conseil désactivable à tout moment dans les paramètres',
    years_old: 'ans',
    bank_title: 'Banque',
    active_loans: 'crédit(s) actif(s)',
    per_month: 'par mois',
    placements_label: 'Placements',
    placement_count: 'placement(s)',
    loyalty: 'Fidélité',
    new_client: 'Nouveau client',
    loans_repaid: 'crédit(s) remboursé(s)',
    advisors_tab: 'Conseillers',
    request_loan_tab: 'Demander un crédit',
    my_loans_tab: 'Mes crédits',
    bank_selected: 'Banque sélectionnée',
    placement_available: 'Placement dispo',
    total_borrowed: 'Emprunté total',
    loans_active_count: 'Crédits actifs',
    first_time_setup: 'First-time setup',
    sme_transport_tag: 'PME transport',
    products_available: 'produits disponibles',
    invest: 'Placer',
    market_title: 'Marché & Concurrence',
    ranking: 'Classement',
    on_5_companies: 'sur 5 entreprises',
    competitors_label: 'Concurrents',
    active_on_market: 'actifs sur votre marché',
    export_contracts: 'Contrats export',
    daily_relocation_fee: 'frais déplacement',
    your_revenue_kpi: 'Votre CA',
    reputation_short: 'Réputation',
    regional_ranking_tab: 'Classement régional',
    export_costs_tab: 'Coûts export',
    events_tab: 'Événements',
    regional_ranking_subtitle: 'Classement régional — CA mensuel',
    vehicles_short: 'véh.',
    drivers_short: 'chauff.',
    rep_short: 'rép.',
    your_company: 'Votre entreprise',
    you: 'vous',
    per_month_short: '/m',
    no_event_active: 'Aucun événement concurrentiel pour le moment',
    available_contracts_title: 'Contrats disponibles',
    contracts_col_name: 'Nom',
    contracts_col_client: 'Client',
    contracts_col_category: 'Catégorie',
    contracts_col_freq: 'Type',
    contracts_col_tier: 'Tier',
    contracts_col_price: 'Prix',
    contracts_col_duration: 'Durée',
    contracts_col_margin: 'Marge',
    contracts_col_actions: 'Actions',
    go_to_hr_step: 'Allez dans **RH** et recrutez un chauffeur',
    assign_driver_step: 'Allez dans **Flotte** et assignez-le à un véhicule',
    come_back_step: 'Revenez ici pour accepter un contrat',
    nav_fiscality: 'Fiscalité',
    nav_strategy: 'Stratégie',
    nav_messagerie: 'Messagerie',
    nav_bank: 'Banque',
    nav_capitaux: 'Capitaux',
    nav_market: 'Marché',
    nav_appels_offres: "Appels d'Offres",
    nav_clients: 'Clients',
    nav_competition: 'Concurrence',
    freq_ponctuel: 'ponctuel',
    freq_regulier: 'régulier',
    cat_messagerie: 'Messagerie / Colis',
    cat_vrac: 'Vrac / Palettes',
    cat_frigo: 'Frigorifique',
    cat_express: 'Express',
    cat_btp: 'BTP / Chantier',
    cat_premium: 'Premium / VIP',
    cat_dangerous: 'Matières dangereuses',
    cat_lourd: 'Lourd / Convoi exceptionnel',
    cat_international: 'International',

    // Contract cancellation
    cancel_contract: 'Résilier',
    cancel_contract_title: 'Résilier ce contrat ?',
    cancel_contract_warning: 'La résiliation entraîne une pénalité de 25 % du chiffre d\'affaires restant, libère le véhicule et fait chuter votre réputation de 5 points.',
    cancel_contract_remaining_revenue: 'CA restant',
    cancel_contract_penalty: 'Pénalité (25 %)',
    cancel_contract_rep_loss: 'Impact réputation',
    cancel_contract_confirm: 'Confirmer la résiliation',
    keep_contract: 'Garder le contrat',
    contract_cancelled_toast: 'Contrat résilié. Pénalité prélevée.',

    // Early loan repayment
    early_repay: 'Solder le crédit',
    early_repay_title: 'Solder ce crédit ?',
    early_repay_intro: 'Vous remboursez immédiatement la totalité du capital restant dû. Une indemnité de 3 % (plafonnée à 6 mois d\'intérêts au taux contractuel) s\'applique conformément au Code de la consommation.',
    early_repay_remaining: 'Capital restant dû',
    early_repay_indemnity: 'Indemnité (3 %)',
    early_repay_total: 'Total à régler',
    early_repay_confirm: 'Confirmer le remboursement',
    early_repay_insufficient: 'Trésorerie insuffisante pour solder ce crédit.',
    loan_repaid_toast: 'Crédit soldé. Bravo !',

    // Lease buyout (new formula)
    buyout_lease_title: 'Solder ce leasing ?',
    buyout_lease_intro: 'Vous rachetez ce véhicule par anticipation. Le solde regroupe les mensualités restantes + valeur résiduelle + 5 % de pénalité contractuelle.',
    buyout_lease_monthly_left: 'Mensualités restantes',
    buyout_lease_residual: 'Valeur résiduelle',
    buyout_lease_penalty: 'Pénalité (5 %)',
    buyout_lease_total: 'Solde total',
    buyout_lease_confirm: 'Solder et garder le véhicule',
    buyout_lease_insufficient: 'Trésorerie insuffisante pour solder ce leasing.',
    months_remaining: 'mois restants',
    months: 'mois',

    // Contract assignment (free choice)
    select_vehicle: 'Choisir un véhicule',
    select_driver: 'Choisir un chauffeur',
    no_vehicle_meets_criteria: 'Aucun véhicule ne correspond aux critères de ce contrat.',
    no_driver_available_label: 'Aucun chauffeur disponible.',
    requires_tier: 'Tier {{tier}} minimum',
    requires_license: 'Permis {{license}} requis',
    requires_specialty: 'Spécialité {{specialty}} requise',
    requires_vehicle_model: 'Modèle {{model}} requis',
    incompatible_short: 'Incompatible',
    compatible_short: 'Compatible',
    on_mission_short: 'En mission',
    in_training_short: 'En formation',
    specialty_match_bonus: '+15 % bonus spécialité',
    perfect_match: 'Combinaison idéale',

    // Driver training restriction
    cannot_train_on_mission: 'Impossible : ce chauffeur est en mission. Libérez-le pour suivre une formation.',
    cannot_fire_on_mission: 'Impossible : ce chauffeur est en mission. Résiliez d\'abord le contrat.',
    days_remaining_short: 'jours restants',

    // Lease confirmation + early break
    confirm_lease_title: 'Confirmer le leasing',
    confirm_lease_intro: 'Vous engagez la société sur la durée totale du leasing. Un acompte sera prélevé immédiatement.',
    confirm_lease_deposit: 'Acompte (10 %)',
    confirm_lease_monthly: 'Mensualité',
    confirm_lease_duration: 'Durée',
    confirm_lease_residual: 'Valeur résiduelle',
    confirm_lease_total_engagement: 'Engagement total',
    confirm_lease_confirm: 'Signer le leasing',
    break_lease: 'Rompre le leasing',
    break_lease_title: 'Rompre ce leasing ?',
    break_lease_intro: 'Vous rendez le véhicule au loueur avant terme. Une indemnité de rupture s\'applique : 30 % des mensualités restantes + 1 000 € de frais de remise en état. Le véhicule quitte définitivement votre flotte.',
    break_lease_penalty_label: 'Pénalité (30 % × mensualités restantes)',
    break_lease_admin_fee: 'Frais de remise en état',
    break_lease_total: 'Total à régler',
    break_lease_confirm: 'Confirmer la rupture',
    break_lease_insufficient: 'Trésorerie insuffisante pour rompre ce leasing.',

    // i18n migration — FonctionsSupport
    support_functions_title: 'Fonctions support',
    support_functions_intro: 'Recrutez des profils stratégiques (hors chauffeurs) pour débloquer des bonus, réduire vos coûts et accélérer votre croissance.',
    support_hired_count_label: 'Salariés support',
    support_payroll_label: 'Masse salariale',
    support_revenue_bonus_label: 'Bonus revenus cumulé',
    support_families_label: 'Familles couvertes',
    support_hired_badge: 'Recruté',
    support_salary_label: 'Salaire',
    support_age_suffix: 'ans',
    support_unlocks_label: 'Débloque',
    support_fire_btn: 'Renvoyer',
    support_hire_btn: 'Recruter',
    support_locked_btn: 'Verrouillé',
    support_low_treasury_full: 'Trésorerie insuffisante pour 1 mois de salaire',
    support_low_treasury_short: 'Trésorerie insuffisante',
    support_tool_label: 'Outil',
    support_cost_label: 'Coût',
    support_deactivate_btn: 'Désactiver',
    support_activate_btn: 'Activer',
    support_entries_singular: 'entrée',
    support_entries_plural: 'entrées',

    // i18n migration — CompetitionAnalysis
    comp_family_marketing: 'Marketing',
    comp_family_commerce: 'Commerce',
    comp_family_admin: 'Administration / Exploitation',
    comp_family_finance: 'Comptabilité / Finance',
    comp_locked_title: 'Cellule d\'analyse concurrentielle',
    comp_locked_intro: 'Pour débloquer l\'analyse approfondie de vos concurrents et envisager des opérations de fusion-acquisition, vous devez d\'abord recruter au moins un membre dans chacune des 4 fonctions suivantes :',
    comp_locked_tip: 'Astuce apprenant : ces 4 fonctions support sont le socle d\'une équipe de direction capable de mener un projet de M&A. Recrutez-les depuis l\'onglet Support.',
    comp_analysis_title: 'Analyse concurrentielle',
    comp_analysis_subtitle: 'Synthèse fournie par votre cellule Marketing + Commerce + Exploitation + DAF.',
    comp_owned_depots: 'Dépôts détenus',
    comp_reco_fair: 'Cible correcte',
    comp_already_acquired_reason: 'Concurrent déjà racheté',
    comp_ma_in_progress: 'Une opération M&A est déjà en cours',
    comp_loi_cooldown: 'LOI précédemment refusée — ré-essayer dans {{days}}j',
    comp_depot_quota_reached: 'Quota de dépôts atteint (3/3)',
    comp_kpi_ca: 'CA / mois',
    comp_kpi_fleet: 'Flotte',
    comp_kpi_drivers: 'Chauffeurs',
    comp_kpi_reputation: 'Réputation',
    comp_stat_equity: 'Capitaux propres',
    comp_stat_net_margin: 'Marge nette',
    comp_stat_net_debt: 'Dette nette',
    comp_health_score: 'Note santé globale',
    comp_exploitable_weakness: 'Faiblesse exploitable',
    comp_asking_price_label: 'Prix proposé par le DAF',
    comp_already_acquired_badge: 'Acquis · ce dépôt est désormais à vous',
    comp_initiate_acquisition: 'Initier une opération de rachat',

    // i18n migration — EventPopup
    event_days_singular: 'jour',
    event_days_plural: 'jours',
    event_reputation_label: 'Réputation',
    event_pts_suffix: 'pts',
    event_treasury_after: 'Trésorerie après',
    event_estimated_agios: 'Agios estimés',
    event_per_day_suffix: '/jour',
    event_contact_bank_tip: 'Il faudra sûrement contacter la banque pour envisager un crédit.',
    event_crisis_comm_label: 'Communication de crise (Aïcha)',
    event_crisis_comm_desc: 'Coup de fil aux journalistes, narratif maîtrisé. La perte de réputation maximale est **divisée par 2**, et la notoriété gagne **+2 points**.',
    event_postpone_title: 'Plus tard — je consulte ma flotte',
    event_postpone_desc: 'Mettre cette offre en attente. Un rappel restera affiché pour la reprendre quand vous serez prêt.',

    // i18n migration — FiscalAuditModal
    fiscal_audit_admin_control: 'Contrôle administratif',
    fiscal_audit_items_examined: 'Éléments examinés',
    fiscal_audit_urssaf_item_1: 'Cotisations sociales chauffeurs',
    fiscal_audit_urssaf_item_2: 'Contrats de travail & temps de service',
    fiscal_audit_urssaf_item_3: 'Politique salariale & ancienneté',
    fiscal_audit_customs_item_1: 'Documents douaniers transfrontaliers',
    fiscal_audit_customs_item_2: 'Conformité ADR / Frigorifique',
    fiscal_audit_customs_item_3: 'Certifications & traçabilité',
    fiscal_audit_compliance_tip: 'Vos investissements en **assurance Premium**, **certification qualité** et **fonctions support** améliorent votre score de conformité.',
    fiscal_audit_cooperate_btn: 'Coopérer avec le contrôle',
    fiscal_audit_result_label: 'Résultat du contrôle',
    fiscal_audit_outcome_clean: 'Conforme',
    fiscal_audit_outcome_minor: 'Redressement mineur',
    fiscal_audit_outcome_major: 'Redressement important',
    fiscal_audit_compliance_score: 'Score de conformité',
    fiscal_audit_no_redress: 'Aucun redressement',
    fiscal_audit_clean_body: 'Votre dossier est conforme. **+2 réputation** auprès de l\'administration.',
    fiscal_audit_financial_penalty: 'Pénalité financière',
    fiscal_audit_redress_label: 'Redressement',
    fiscal_audit_reputation_label: 'Réputation',
    fiscal_audit_strengthen_tip: 'Pensez à renforcer vos certifications & assurances pour réduire le risque.',

    // i18n migration — DepotTabs
    depot_tabs_brand_hst: 'Siège HST',
    depot_tabs_brand_transnord: 'TransNord',
    depot_tabs_brand_logistar: 'LogiStar',
    depot_tabs_brand_ecoroute: 'ÉcoRoute',
    depot_tabs_brand_independent: 'Indépendant',
    depot_tabs_quota_reached: 'Quota atteint (3/3)',
    depot_tabs_open_btn: 'Ouvrir un dépôt',
    depot_tabs_default_name: 'Dépôt',
    depot_tabs_modal_title: 'Ouvrir un nouveau dépôt',
    depot_tabs_open_cost_label: 'Coût d\'ouverture',
    depot_tabs_open_cost_suffix: '(acquisition foncière + équipements de base).',
    depot_tabs_name_label: 'Nom du dépôt',
    depot_tabs_treasury_label: 'Trésorerie',
    depot_tabs_after_open_label: 'après ouverture',
    depot_tabs_open_short: 'Ouvrir',
    depot_tabs_err_insufficient: 'Trésorerie insuffisante : il vous manque {{amount}} €.',
    depot_tabs_err_max: 'Vous avez déjà atteint la limite de 3 dépôts.',
    depot_tabs_err_generic: 'Ouverture impossible.',
    depot_tabs_err_no_city: 'Choisissez une ville d\'implantation.',
    depot_tabs_err_city_taken: 'Vous êtes déjà implanté dans cette ville.',
    depot_tabs_err_max_intl: 'Limite atteinte : 2 implantations internationales maximum.',
    depot_tabs_err_phase: 'Ville accessible à partir de la phase {{phase}}.',
    depot_tabs_city_label: 'Ville d\'implantation',
    depot_tabs_rent_label: 'Loyer',
    depot_tabs_subsidy_label: 'd\'aide régionale',
    depot_tabs_aid_note: 'Aide à l\'implantation : loyer −50 % pendant 6 mois + subvention régionale de 30 % du coût d\'ouverture.',
    depot_map_title: 'Réseau logistique — carte des implantations',
    depot_map_legend_hq: 'Siège',
    depot_map_legend_opened: 'Ouvert',
    depot_map_legend_acquired: 'Racheté',
    depot_map_legend_target: 'Cible M&A',
    depot_map_kind_hq: 'Quartier général',
    depot_map_kind_opened: 'Dépôt ouvert',
    depot_map_kind_acquired: 'Dépôt racheté',
    depot_map_stat_radius: 'Rayon d\'action',
    depot_map_stat_rent: 'Loyer',
    depot_map_stat_vehicles: 'Camions',
    depot_map_stat_contracts: 'Contrats servis',
    depot_map_rent_free: 'Exonéré',
    depot_map_upgrades_title: 'Évolutions possibles',
    depot_map_manage_cta: 'Gérer ce dépôt',
    depot_map_legend_prospect: 'Ville libre',
    depot_map_prospect_kind: 'Prospection',
    depot_map_prospect_title: 'Implantation possible',
    depot_map_prospect_radius: 'Rayon d\'action',
    depot_map_prospect_rent: 'Loyer estimé',
    depot_map_prospect_inrange: 'Contrats en zone',
    depot_map_prospect_unlocked: 'Contrats débloqués',
    depot_map_prospect_cost: 'Coût d\'ouverture (net d\'aide)',
    depot_map_prospect_open_btn: 'Ouvrir un dépôt ici',
    depot_map_prospect_locked: 'Ville débloquée en phase {{phase}}.',
    depot_map_prospect_quota_fr: 'Quota de dépôts créés en France atteint (3).',
    depot_map_prospect_quota_intl: 'Quota d\'implantations internationales atteint (2).',
    depot_map_prospect_hint: '◇ Survolez une ville libre pour prévisualiser son rayon de 250 km, cliquez pour prospecter.',
    depot_upg_phase_req: 'Phase {{phase}} requise',
    depot_upg_detail_benefit: 'Atout',
    depot_upg_detail_condition: 'Condition',
    depot_upg_detail_none: 'Aucune — disponible immédiatement',
    depot_upg_detail_rent_note: 'Site agrandi : loyer +5 % de la base ville.',
    depot_upg_radius_name: 'Extension logistique (+100 km)',
    depot_upg_radius_desc: 'Plateforme relais et accords transporteurs : rayon d\'action porté à 350 km.',
    depot_upg_quai_name: 'Quai de chargement',
    depot_upg_quai_desc: 'Rotation accélérée : capacité du dépôt +3 camions.',
    depot_upg_frigo_name: 'Zone frigo locale',
    depot_upg_frigo_desc: 'Quai froid certifié : débloque les contrats frigorifiques T3+ pour tout le réseau.',
    depot_upg_atelier_name: 'Atelier mécanique',
    depot_upg_atelier_desc: 'Entretien en interne : −10 % de maintenance pour les véhicules rattachés à ce dépôt.',
    depot_upg_solar_name: 'Panneaux photovoltaïques',
    depot_upg_solar_desc: 'Toiture solaire en autoconsommation : loyer du site −20 %.',
    depot_upg_borne_name: 'Borne de recharge électrique',
    depot_upg_borne_desc: 'Recharge rapide sur site : −15 % de carburant/énergie pour les véhicules rattachés à ce dépôt.',

    // i18n migration — PhaseNotification
    phase_new_phase_label: 'Nouvelle phase',
    phase_2_title: 'Phase Régionale',
    phase_2_subtitle: 'Votre société s\'étend !',
    phase_2_description: 'Vous avez débloqué l\'accès aux zones régionales. De nouvelles routes, de nouveaux contrats et des véhicules plus gros vous attendent.',
    phase_2_unlock_1: 'Contrats régionaux (vrac, palettes, BTP)',
    phase_2_unlock_2: 'Véhicules Tier 2 — Porteurs 7T-12T',
    phase_2_unlock_3: 'Chauffeurs confirmés (permis C)',
    phase_2_unlock_4: 'Nouvelles zones : Grand Est, Normandie, Bretagne',
    phase_2_condition: 'CA ≥ 30 000 €/mois · 2 mois d\'activité · 3 véhicules',
    phase_3_title: 'Phase Nationale',
    phase_3_subtitle: 'Votre réseau couvre la France !',
    phase_3_description: 'Les axes nationaux sont à votre portée. Semi-remorques, longues distances et contrats lucratifs deviennent accessibles.',
    phase_3_unlock_1: 'Contrats nationaux longue distance',
    phase_3_unlock_2: 'Semi-remorques Tier 3 — VOLVAX, SCANEX, DAFORA',
    phase_3_unlock_3: 'Chauffeurs expérimentés (permis CE)',
    phase_3_unlock_4: 'Axes Paris-Lyon-Marseille-Bordeaux-Lille',
    phase_3_condition: 'CA ≥ 60 000 €/mois · 5 mois · 5 véhicules · 2 dépôts',
    phase_4_title: 'Phase Européenne',
    phase_4_subtitle: 'L\'Europe est à vous !',
    phase_4_description: 'L\'export EU est maintenant accessible. Contrats internationaux prestige, véhicules spécialisés et marges exceptionnelles.',
    phase_4_unlock_1: 'Contrats Export EU — Espagne, Allemagne, Italie, Benelux',
    phase_4_unlock_2: 'Véhicules Tier 4-5 — Spécialisés et prestige',
    phase_4_unlock_3: 'Chauffeurs seniors et experts multilingues',
    phase_4_unlock_4: 'SCANEX R 650 V8 Prestige et VOLVAX Electric',
    phase_4_condition: 'CA ≥ 200 000 €/mois · 7 mois · 8 véhicules · 2 dépôts · 1 commercial',

    // i18n migration — Depot zones
    depot_zone_garage_name: 'Garage / Box',
    depot_zone_garage_desc: 'Stationnement et réparations véhicules',
    depot_zone_garage_capacity: '2 véhicules',
    depot_zone_quai_name: 'Quai de chargement',
    depot_zone_quai_desc: 'Zone de chargement/déchargement rapide',
    depot_zone_quai_capacity: '1 quai',
    depot_zone_entrepot_name: 'Entrepôt dédié',
    depot_zone_entrepot_desc: 'Stockage des marchandises clients',
    depot_zone_entrepot_capacity: '200 m²',
    depot_zone_frigo_name: 'Zone frigorifique',
    depot_zone_frigo_desc: 'Stockage sous température contrôlée',
    depot_zone_frigo_capacity: '50 m²',
    depot_zone_pompe_name: 'Pompe carburant',
    depot_zone_pompe_desc: 'Station diesel dédiée, réduction coûts',
    depot_zone_pompe_capacity: '2 000L',
    // 04/02/2026 — Phase F4 : nouvelles zones spécialisées (doc Analyse flotte)
    depot_zone_point_eau_name: "Point d'eau",
    depot_zone_point_eau_desc: 'Abreuvement et soins, requis pour la bétaillère',
    depot_zone_point_eau_capacity: '1 point',
    depot_zone_zone_adr_name: 'Zone ADR sécurisée',
    depot_zone_zone_adr_desc: 'Stockage et lavage citernes matières dangereuses',
    depot_zone_zone_adr_capacity: '300 m² sécurisés',
    depot_zone_borne_recharge_name: 'Borne de recharge',
    depot_zone_borne_recharge_desc: 'Borne rapide DC 150 kW, requise pour les électriques',
    depot_zone_borne_recharge_capacity: '2 véhicules',
    depot_zone_atelier_name: 'Atelier mécanique',
    depot_zone_atelier_desc: 'Atelier interne, -20% coût d\'entretien flotte',
    depot_zone_atelier_capacity: '1 atelier',
    depot_upg_inv_depot_01_label: 'Agrandissement x2',
    depot_upg_inv_depot_01_desc: '4 places au lieu de 2',
    depot_upg_inv_depot_03_label: 'Achat terrain + entrepôt',
    depot_upg_inv_depot_03_desc: 'Propriétaire, +30% marge',
    depot_upg_inv_depot_06_label: 'Extension logistique (+100 km)',
    depot_upg_inv_depot_06_desc: 'Rayon de couverture du QG étendu de 100 km',
    depot_upg_inv_depot_07_label: 'Quai renforcé (BTP lourd)',
    depot_upg_inv_depot_07_desc: 'Quai dédié au transport d\'engins TP et benne 44 T',
    depot_upg_inv_depot_08_label: 'Hangar haute hauteur (T3+)',
    depot_upg_inv_depot_08_desc: 'Hauteur sous portail 4,5 m — débloque les semi-remorques Tier 3+',
    depot_upg_inv_depot_solar_label: 'Panneaux photovoltaïques (QG)',
    depot_upg_inv_depot_solar_desc: 'Autoconsommation toiture atelier — loyer QG −20 % (Phase 4 requise)',
    depot_upg_inv_energy_01_label: 'Cuve carburant 2 000L',
    depot_upg_inv_energy_01_desc: '-8% coût fuel',
    depot_productivity_title: 'Score de productivité du dépôt',
    depot_productivity_subtitle: 'Cumul des bonus actifs sur l\'ensemble des investissements possibles',
    depot_no_bonus_yet: 'Aucun bonus actif pour le moment. Activez vos zones pour gagner en productivité.',
    depot_non_hq_info: '**Dépôt {{name}}.** Cette installation est déjà équipée (garage, entrepôt, quai, frigo, pompe). Vous y stationnez {{vehicleCount}} véhicule(s) et {{driverCount}} chauffeur(s) y sont rattachés. Les améliorations physiques restent réservées au siège HST.',
    per_month_short: '/mois',

    // i18n migration — Marche
    market_intel_unlock_tip: 'Recrutez Sherazade Fetitou (Marketing senior) + un commercial pour débloquer',
    months_short: 'mois',
    notoriety_short: 'Notoriété',
    regional_ranking_tab: 'Classement régional',
    competitors_label: 'Concurrents',
    market_intel_tab: 'Veille concurrents',
    events_tab: 'Événements',
    market_intel_title: 'Veille concurrentielle stratégique',
    market_intel_monthly_challenges: 'Défis ce mois :',
    market_intel_intro: 'Vos équipes Marketing + Commercial ont identifié les contrats détenus par vos concurrents. Choisissez vos cibles puis lancez un démarchage avec l\'argument adapté au client.',
    market_intel_pending_label: 'Démarchages en cours / résultats',
    market_intel_argument_label: 'argument',
    market_intel_in_progress: 'En cours · J-{{days}}',
    market_intel_capture: 'Capter ({{prob}}%)',
    market_intel_failure: 'Échec ({{prob}}%)',
    market_intel_empty: 'Aucun contrat concurrent identifié pour le moment.',
    market_intel_competitor_label: 'Concurrent :',
    market_intel_loyalty_label: 'Fidélité',
    market_intel_primary_arg: 'Argument primaire :',
    market_intel_secondary_arg: 'secondaire :',
    market_intel_low_treasury_800: 'Trésorerie insuffisante (800 € requis)',
    market_intel_low_treasury_1600: 'Trésorerie insuffisante (1 600 € requis)',
    market_intel_monthly_quota_reached: 'Quota mensuel atteint (3 défis)',
    market_intel_launch_challenge: 'Lancer un démarchage',
    market_intel_challenge_btn: 'Challenger',
    market_intel_history_title: 'Historique des démarchages',
    market_intel_intensity_intensive: 'intensive',
    market_intel_intensity_standard: 'standard',
    market_intel_chance: 'chance',
    market_intel_won: 'Gagné',
    market_intel_lost: 'Perdu',
    market_intel_success_rate: 'Taux de réussite :',
    market_intel_alert_low_treasury: 'Trésorerie insuffisante',
    challenge_modal_title: 'Démarchage stratégique',
    challenge_modal_intro: 'Choisissez l\'argument à mettre en avant pour convaincre **{{client}}** de rompre son contrat avec **{{competitor}}**.',
    challenge_modal_profile: 'Profil client',
    challenge_modal_sensitive_to: 'Sensible à',
    challenge_modal_and: 'et',
    challenge_intensity_standard: 'Standard',
    challenge_intensity_standard_desc: '800 € · taux nominal',
    challenge_intensity_intensive: 'Intensive',
    challenge_intensity_intensive_desc: '1 600 € · +20 % chance',
    argument_strongest: '+ fort',
    argument_medium: 'moyen',
    challenge_cost_intensive: 'Coût démarchage : 1 600 € · +20 % succès · 4 jours · 3 défis/mois max.',
    challenge_cost_standard: 'Coût démarchage : 800 € · 4 jours · 3 défis/mois max.',
    event_cost_label: 'Coût :',
    market_competition_history_title: 'Historique concurrentiel',
    market_competitor_activity_title: 'Activité concurrents',

    // i18n migration — ContractAssignModal
    contract_equipment_label: 'Équipement',
    contract_international_label: 'Contrat international',
    contract_incoterm_label: 'Incoterm',
    contract_risk_transfer: 'Transfert risques :',
    contract_your_charge: 'À votre charge :',
    contract_vat_applicable: 'TVA applicable',
    contract_invoice_mention: 'Mention obligatoire facture :',
    contract_customs_fees: 'Frais douaniers :',
    contract_customs_fees_detail: 'DAU + transit + EUR1',
    contract_ht_deducted: 'HT (déduits du résultat)',
    contract_why_this_choice: 'Pourquoi ce choix ?',
    contract_equipment_required: 'Équipement {{value}} requis',
    contract_driver_level: 'Niv. {{level}}',
    contract_driver_specialty_required: 'Spécialité {{value}} requise (formation)',
    contract_estimated_gross_margin: 'Marge brute estimée',
    contract_avoid_deficit: 'À éviter — contrat déficitaire',
    contract_margin_market_cap_hint: 'Au-delà de {{cap}} % de marge brute, le client renégociera le tarif (marché sous tension)',
    contract_fuel_short: 'carbu',
    contract_maintenance_short: 'maint',
    contract_salary_short: 'salaire',
    contract_insurance_short: 'assur',
    contract_toll_short: 'péages',
    contract_permit_missing_warning: '**{{name}}** n\'a pas le permis **{{required}}** requis pour conduire ce véhicule. Permis détenus : {{owned}}. Formez-le ou choisissez un autre chauffeur.',

    // i18n migration — Strategie
    strat_title: 'Tableau de bord stratégique',
    strat_subtitle: '— pilote ta boîte en mode CEO',
    strat_kpi_revenue: 'CA mensuel courant',
    strat_kpi_net_result: 'Résultat du mois',
    strat_kpi_runway: 'Cash runway',
    strat_treasury_hint: 'Trésorerie {{value}}',
    strat_kpi_avg_margin: 'Marge brute moy. / contrat',
    strat_locked_value: '— verrouillé',
    strat_unlock_with_tms: 'Débloqué avec TMS + commercial',
    strat_kpi_fleet_use: 'Taux occupation flotte',
    strat_fleet_hint: '{{active}}/{{total}} véhicules',
    strat_kpi_driver_satisfaction: 'Satisfaction chauffeurs',
    strat_drivers_count_hint: '{{count}} chauffeur·s',
    strat_kpi_churn: 'Churn 12 mois',
    strat_resignations_hint: '{{count}} démission·s',
    strat_kpi_depot_prod: 'Productivité dépôt',
    strat_kpi_cost_per_km: 'Coût moyen par km',
    strat_fuel_maintenance_hint: 'Carburant + entretien',
    strat_buy_vehicle_hint: 'Achetez un véhicule',
    strat_kpi_challenge_rate: 'Réussite démarchage',
    strat_challenge_hint: '{{wins}}/{{total}} défis',
    strat_kpi_compliance: 'Score conformité',
    strat_audit_high_risk: 'Risque audit élevé',
    strat_kpi_audits: 'Audits subis',
    strat_clean_short: 'clean',
    strat_redresses_hint: 'Redressements {{value}}',
    strat_kpi_equity: 'Capitaux propres',
    strat_solvency_hint: 'Solvabilité {{pct}} %',
    strat_kpi_fleet_net: 'Patrimoine flotte',
    strat_fleet_breakdown_hint: '{{count}} camion·s · {{mortgaged}} hyp.',
    strat_kpi_debt_ratio: 'Endettement / Actif',
    strat_passif_hint: 'Passif {{value}}',
    strat_kpi_actif_total: 'Actif total',
    strat_actif_breakdown_hint: 'Cash {{cash}} · Flotte {{fleet}}',
    strat_rep_noto_title: 'Évolution Réputation & Notoriété',
    strat_rep_noto_measures: '{{count}} mesures · hebdo',
    strat_day_label: 'Jour {{day}}',
    strat_active_missions_title: 'Carte des missions actives',
    strat_contracts_count: '{{count}} contrat·s',
    strat_alerts_title: 'Alertes & points d\'attention',
    strat_alert_runway: 'Cash runway critique : moins de 3 mois.',
    strat_alert_satisfaction: 'Satisfaction chauffeurs très basse : risque attrition élevé.',
    strat_alert_compliance: 'Score conformité faible : un contrôle pourrait coûter cher.',
    strat_alert_resolution_prefix: 'Résolution active du Conseil :',
    strat_alert_resolution_until: '(jusqu\'à J{{day}}).',
    strat_compat_title: 'Matrice de compatibilité équipe × missions',
    strat_compat_lock_msg: 'Embauche **Nadia Cheikh — Responsable RH** dans Fonctions Support pour voir quels chauffeurs sont fait pour quelles missions, et anticiper les démissions avant qu\'il ne soit trop tard.',

    // i18n migration — Capitaux
    cap_title: 'Capitaux & Patrimoine',
    cap_subtitle_at_day: '— bilan simplifié au jour {{day}}',
    cap_total_actif: 'ACTIF TOTAL',
    cap_actif_hint: 'Trésorerie + placements + flotte',
    cap_total_passif: 'PASSIF TOTAL',
    cap_passif_hint: 'Crédits + engagements leasing + dette fiscale',
    cap_equity_label: 'CAPITAUX PROPRES',
    cap_equity_hint: 'Solvabilité {{solvency}} % · Endettement {{debt}} %',
    cap_fleet_label: 'PATRIMOINE FLOTTE',
    cap_fleet_hint: '{{count}} camion·s · {{mortgaged}} hypothéqué·s',
    cap_risk_signals: 'Signaux de risque',
    cap_alert_equity_minor: 'Capitaux propres légèrement négatifs — situation de démarrage normale, à surveiller dès que le CA s\'installe.',
    cap_alert_equity_critical: 'Capitaux propres négatifs — la société est en cessation de paiements imminente.',
    cap_alert_solvency_low: 'Solvabilité faible ({{pct}} %) — recapitaliser via remboursement anticipé ou cession d\'actif.',
    cap_alert_debt_high: 'Ratio d\'endettement très élevé ({{pct}} %) — limitez les nouveaux crédits.',
    cap_equity_chart_title: 'Évolution des Capitaux propres',
    cap_chart_monthly_closes: '{{count}} clôture·s mensuelle·s',
    cap_chart_waiting: 'En attente du 1er bilan mensuel',
    cap_chart_grows_text: 'Le graphique s\'enrichit à chaque **clôture mensuelle** (tous les 30 jours).',
    cap_chart_day_info: 'Jour actuel : {{day}} · prochaine clôture : J{{next}}.',
    cap_chart_equity_name: 'Capitaux propres',
    cap_chart_actif_name: 'Actif total',
    cap_chart_passif_name: 'Passif total',
    cap_chart_fleet_name: 'Patrimoine flotte',
    cap_actif_panel: 'Actif',
    cap_passif_panel: 'Passif',
    cap_row_treasury: 'Trésorerie',
    cap_row_treasury_hint: 'Compte courant',
    cap_row_placements: 'Placements bancaires',
    cap_row_placements_hint: '{{count}} placement·s',
    cap_row_fleet_resale: 'Flotte (valeur de revente)',
    cap_row_fleet_owned_hint: '{{count}} camion·s possédés',
    cap_row_credits: 'Crédits bancaires',
    cap_row_credits_hint: '{{count}} crédit·s actif·s',
    cap_row_lease: 'Engagements leasing',
    cap_row_lease_hint: '{{count}} contrat·s en cours',
    cap_row_tax_debt: 'Dette fiscale',
    cap_row_tax_hint: 'TVA en attente {{tva}} · Provision IS {{is}}',
    cap_row_tva_provisioned: 'Provision TVA',
    cap_row_tva_provisioned_hint: 'Cash mis de côté pour la prochaine échéance TVA',
    cap_row_is_provisioned: 'Provision IS',
    cap_row_is_provisioned_hint: "Cash mis de côté pour l'impôt sur les sociétés à venir",
    cap_row_fiscal_reserve: 'Réserve fiscale (placement)',
    cap_row_fiscal_reserve_hint: 'Placement rémunéré 3 % servant de tampon avant échéances',
    cap_row_tva_pending: 'dont TVA en attente',
    cap_row_tva_pending_hint: 'TVA collectée − TVA déductible à reverser',
    cap_row_is_provision_due: 'dont IS à provisionner',
    cap_row_is_provision_due_hint: '~25 % du résultat annuel projeté',
    // 17/06/2026 (Lot 6 Phase 1) — Diplomatie / relations concurrentielles
    relation_tier_enemy: 'Ennemi juré',
    relation_tier_rival: 'Rival',
    relation_tier_neutral: 'Neutre',
    relation_tier_peer: 'Collègue',
    relation_tier_ally: 'Allié',
    relation_with_us: 'Relation avec votre société',
    cap_fleet_detail_title: 'Patrimoine flotte — détail par camion',
    cap_fleet_breakdown: 'Valeur brute {{gross}} − Dette hyp. {{debt}}',
    cap_fleet_empty: 'Aucun camion en propriété. Achète ou rachète un véhicule en leasing pour constituer un patrimoine.',
    cap_th_truck: 'Camion',
    cap_th_tier: 'Tier',
    cap_th_resale: 'Valeur revente',
    cap_th_mortgage_debt: 'Dette hypothèque',
    cap_th_net_value: 'Valeur nette',
    cap_th_status: 'Statut',
    cap_status_mortgaged: 'Hypothéqué · {{months}} mois',
    cap_status_free: 'Libre',
    cap_lease_engagements_title: 'Engagements leasing',
    cap_lease_total_remaining: 'Total restant',
    cap_th_months_left: 'Mois restants',
    cap_th_monthly: 'Mensualité',
    cap_th_residual: 'Valeur résiduelle',
    cap_th_total_engagement: 'Engagement total',
    cap_pedagogical_footer: '**Capitaux propres = Actif − Passif.** Représente la richesse nette de l\'entreprise. Un ratio de **solvabilité ≥ 30 %** est sain pour une PME du transport ; au-delà de **60 % d\'endettement**, les banques deviennent réticentes et le risque augmente. La **valeur de revente flotte** reflète l\'amortissement (usure + âge), pas la valeur d\'achat. Les véhicules en leasing ne sont pas comptés à l\'actif (ils appartiennent encore au loueur), mais l\'engagement résiduel (mensualités + valeur résiduelle) figure au passif.',

    // i18n migration — AcquisitionModal
    acq_header_prefix: 'Acquisition',
    acq_stage_label: 'Étape {{current}}/5',
    acq_abandon_btn: 'Abandonner',
    acq_dd_title: 'Rapport d\'audit du DAF',
    acq_dd_ca: 'CA mensuel',
    acq_dd_net_margin: 'Marge nette',
    acq_dd_equity: 'Capitaux propres',
    acq_dd_net_debt: 'Dette nette',
    acq_dd_fleet: 'Flotte',
    acq_dd_drivers: 'Chauffeurs',
    acq_dd_lever_title: 'Levier de négociation identifié',
    acq_dd_lever_bonus: 'Bonus négociation : +{{pct}} % de chance d\'accord.',
    acq_loi_rep_line: 'Votre réputation actuelle : **{{reputation}}/100** · Notoriété : **{{notoriety}}/100**',
    acq_loi_chance: 'Chance d\'acceptation de la LOI : **{{pct}} %**',
    acq_loi_refusal_warning: 'Si la LOI est refusée, vous ne pourrez plus retenter ce rachat pendant 90 jours.',
    acq_neg_asking_price: 'Prix demandé par le DAF',
    acq_neg_choose_strategy: 'Choisissez votre stratégie',
    acq_neg_accept_label: 'Accepter le prix DAF',
    acq_neg_accept_sub: '100 % succès — pas de remise',
    acq_neg_negotiate_label: 'Négocier −15 %',
    acq_neg_negotiate_sub: 'Risque modéré — selon réputation',
    acq_neg_aggressive_label: 'Offre agressive −25 %',
    acq_neg_aggressive_sub: 'Risque élevé — selon réputation',
    acq_neg_success_label: 'Succès : {{pct}} %',
    acq_anti_our_ca: 'Votre CA mensuel',
    acq_anti_target_ca: 'CA mensuel de la cible',
    acq_anti_combined_share: 'Part de marché combinée',
    acq_anti_low: 'Concentration faible — autorisation quasi-automatique.',
    acq_anti_medium: 'Concentration modérée — l\'autorité examinera attentivement le dossier.',
    acq_anti_high: 'Concentration élevée — risque de refus significatif (30 %).',
    acq_anti_dominant: 'Concentration dominante — refus très probable (60 %).',
    acq_anti_refusal_fee: 'Frais d\'instruction en cas de refus : 5 000 € (à votre charge).',
    acq_closing_final_terms: 'Conditions définitives',
    acq_closing_neg_accepted: '✓ Négociation acceptée (-{{pct}} %)',
    acq_closing_neg_refused: '✗ Négociation refusée — prix demandé conservé',
    acq_closing_you_get_title: 'Vous récupérez après closing :',
    acq_closing_get_fleet: '{{count}} véhicules d\'occasion',
    acq_closing_get_drivers: 'Jusqu\'à {{count}} chauffeurs (certains pourraient ne pas suivre)',
    acq_closing_get_depot: '1 dépôt entièrement équipé (devient votre Dépôt 2 ou 3)',
    acq_closing_get_contracts: '{{count}} contrats actifs en cours',
    acq_closing_treasury_line: 'Trésorerie actuelle : **{{before}} €** → après closing : **{{after}} €**',
    acq_closing_insufficient: '⚠ Trésorerie insuffisante. Augmentez votre trésorerie ou souscrivez un crédit avant de signer.',
    acq_closing_postpone_btn: 'Reporter la signature',
    acq_closing_sign_btn: 'Signer le closing — {{price}} €',
    acq_success_label: 'Closing finalisé',
    acq_success_welcome: 'Bienvenue chez {{name}} !',
    acq_success_finalized: 'Acquisition réalisée pour **{{price}} €**',
    acq_success_new_depot: 'Nouveau dépôt',
    acq_success_vehicles_inherited: 'Véhicules récupérés',
    acq_success_contracts_inherited: '{{count}} contrat(s) client repris',
    acq_success_drivers_followed: 'Chauffeurs ayant suivi',
    acq_success_drivers_left: '{{count}} chauffeur·s parti·s ailleurs',
    acq_success_reputation: 'Réputation',
    acq_success_notoriety: 'Notoriété',
    acq_success_access_depot_btn: 'Excellent — accéder au nouveau dépôt',

    // i18n migration — SupervisionView
    sup_title: 'Supervision Pédagogique',
    sup_supervisor_default: 'Responsable',
    sup_apprentices_count: '{{count}} apprenant·s',
    sup_loading: 'Chargement…',
    sup_refresh_btn: 'Rafraîchir',
    sup_logout_btn: 'Quitter',
    sup_network_error: 'Erreur réseau',
    sup_send_error: 'Erreur d\'envoi',
    sup_agg_apprentices: 'Apprenants',
    sup_agg_playing: 'Joue actuellement',
    sup_agg_avg_days: 'Jours joués (moy.)',
    sup_agg_total_fleet: 'Camions cumulés',
    sup_agg_neg_equity: 'Capitaux négatifs',
    sup_search_placeholder: 'Filtrer par nom d\'apprenant ou société…',
    sup_displayed_count: '{{count}} affiché·s',
    sup_empty_cohort: 'Aucun apprenant actif dans cette cohorte.',
    sup_empty_hint: 'Affecte des licences à ce groupe via le panneau d\'administration pour les voir apparaître ici.',
    sup_liquidated_on: '⚖ Liquidé J{{day}}',
    sup_rex_badge: 'REX reçu',
    sup_rex_badge_title: 'REX déposé le {{date}} — voir la section « REX de la cohorte »',
    sup_not_played_yet: 'Pas encore joué',
    sup_objective_btn: 'Objectif',
    sup_active_count: '{{count}} actif·s',
    sup_annotate_btn: 'Annoter',
    sup_unread_short: 'non lu',
    sup_pdf_btn: 'PDF',
    sup_pdf_title_active: 'Télécharger la fiche apprenant (PDF)',
    sup_pdf_title_inactive: "L'apprenant n'a pas encore commencé sa partie",
    sup_pdf_btn_error: 'Erreur',
    sup_stmt_title: "Bilans d'exercice (clos + cumulé)",
    sup_stmt_include_current: "Inclure l'exercice en cours (provisoire)",
    sup_stmt_cumulative_pdf: 'Bilan cumulé PDF',
    sup_stmt_pdf: 'Bilan PDF',
    sup_stmt_year: 'Année {{year}}',
    sup_stmt_provisional: 'provisoire',
    sup_stmt_ca_short: 'CA',
    sup_stmt_not_synced: "Aucun bilan remonté pour l'instant — l'apprenant doit relancer sa partie pour synchroniser la télémétrie.",
    sup_stmt_empty: 'Aucun exercice clôturé pour le moment.',
    sup_stmt_empty_with_current: "Aucun exercice clôturé — cochez « inclure l'exercice en cours » pour un bilan provisoire.",
    market_tension_badge: 'Marché sous tension',
    finance_tab_market: 'Marché',
    d3_close: 'Fermer',
    d3_effect: 'Effet :',
    d3_purchase: 'Achat',
    d3_monthly_charge: 'Charge / mois',
    d3_condition: 'Condition',
    d3_related_contracts: 'Contrats concernés',
    d3_zone_operational: 'Zone opérationnelle',
    d3_build_for: 'Construire — {{cost}}',
    d3_insufficient_cash: 'Trésorerie insuffisante',
    d3_locked: 'Verrouillé',
    d3_status: 'Statut',
    d3_driver: 'Chauffeur',
    d3_unassigned: 'Non affecté',
    d3_contract: 'Contrat',
    d3_route: 'Tournée',
    d3_compatible: 'Compatible',
    d3_hq_card_title: 'QG · {{name}}',
    d3_hq_card_sub: 'Ressources humaines et contrats actifs',
    d3_role_chauffeurs: 'Chauffeurs',
    d3_role_mecaniciens: 'Mécaniciens',
    d3_role_caristes: 'Caristes',
    d3_role_exploitants: 'Exploitants',
    d3_role_agents: 'Agents de quai',
    d3_required: '/ {{n}} requis',
    d3_active_contracts: 'Contrats actifs',
    d3_required_zone: 'Zone requise',
    d3_to_build: '(à construire)',
    d3_compatible_vehicles: 'Véhicules compatibles',
    d3_none: 'Aucun',
    d3_see_zone_named: 'Voir « {{name}} »',
    d3_attention_points: '{{n}} point d’attention',
    d3_attention_points_plural: '{{n}} points d’attention',
    d3_hide: 'Masquer',
    d3_show_all: 'Tout voir',
    d3_depot_complete: 'Dépôt complet',
    d3_depot_complete_sub: '— toutes les zones sont opérationnelles et cohérentes avec les contrats.',
    d3_depot_coherent: 'Dépôt cohérent',
    d3_depot_coherent_sub: '— contrats, flotte et effectifs sont en phase avec les zones construites.',
    d3_topic_rh: 'RH',
    d3_topic_flotte: 'Flotte',
    d3_topic_contrat: 'Contrat',
    d3_see_zone: 'Voir la zone',
    d3_see_hq: 'Voir le QG',
    d3_phase: 'Phase {{n}}/{{total}}',
    d3_acquired_from: '· racheté à {{name}}',
    d3_fleet_staff_title: 'Flotte et effectifs',
    d3_vehicles_short: 'véh.',
    d3_slots: '/ {{n}} places',
    d3_click_hint_pre: 'Cliquez une zone',
    d3_click_hint_post: ', un véhicule ou le QG',
    d3_available_badge: '✦ DISPO',
    d3_camera: 'Caméra',
    d3_rotate_left: 'Pivoter à gauche',
    d3_rotate_right: 'Pivoter à droite',
    d3_zoom_in: 'Zoomer',
    d3_zoom_out: 'Dézoomer',
    d3_overview: 'Vue d’ensemble',
    d3_timeline_title: 'Frise chronologique du dépôt',
    d3_steps: 'étapes',
    d3_invested: 'Investi',
    d3_charges: 'Charges',
    d3_unit_day: 'Jour',
    d3_unit_week: 'Semaine',
    d3_unit_day_short: 'J',
    d3_unit_week_short: 'S',
    d3_collapse: 'Replier',
    d3_expand: 'Déplier',
    d3_takeover_of: 'Rachat de {{name}}',
    d3_site_opening: 'Ouverture du site',
    d3_taken_over: 'Repris : {{list}}',
    d3_site: 'Site',
    d3_yard_gate_hq: 'Cour, portail, QG',
    d3_free: 'Gratuit',
    d3_total_charges: 'Total charges {{amount}} €/m',
    d3_serves_contracts: 'Sert {{n}} contrat',
    d3_serves_contracts_plural: 'Sert {{n}} contrats',
    d3_today: 'Aujourd’hui',
    d3_upcoming: 'À venir',
    d3_recommended: '✦ Conseillée',
    d3_waiting_contracts: '{{n}} contrat en attente',
    d3_waiting_contracts_plural: '{{n}} contrats en attente',
    d3_available: 'Disponible',
    d3_locked_steps: '+{{n}} étape verrouillée',
    d3_locked_steps_plural: '+{{n}} étapes verrouillées',
    d3_see_tree: 'Voir l’arbre de développement',
    d3_tree_title: 'Arbre de développement',
    d3_filter_steps: 'Filtrer les étapes',
    d3_filter_all: 'Toutes',
    d3_filter_available: 'Disponibles',
    d3_filter_built: 'Construites',
    d3_filter_locked: 'Verrouillées',
    d3_recommended_step: 'Étape conseillée',
    d3_state_built: 'construite',
    d3_state_available: 'disponible',
    d3_state_locked: 'verrouillée',
    d3_to_unlock: 'Pour débloquer {{id}}',
    d3_conditions_unmet: 'conditions non remplies',
    d3_condition_suffix: ' · condition : {{c}}',
    d3_hover_hint: 'Survolez une étape pour voir ses prérequis et le coût total pour la débloquer.',
    d3_taken_over_ex: 'Repris · ex-{{name}}',
    d3_legend_built: 'Construite',
    d3_legend_available: 'Disponible',
    d3_legend_locked: 'Verrouillée',
    d3_legend_recommended: 'Étape conseillée',
    d3_tier_fondation: 'Fondation',
    d3_tier_structure: 'Structure',
    d3_tier_developpement: 'Développement',
    d3_tier_specialisation: 'Spécialisation',
    d3_tier_excellence: 'Excellence',
    d3_goods_sec: 'Marchandises sèches',
    d3_goods_frigo: 'Produits frais',
    d3_goods_btp: 'Matériaux BTP',
    d3_goods_adr: 'Matières dangereuses (ADR)',
    d3_goods_vrac: 'Vrac',
    d3_body_tautliner: 'bâchée',
    d3_body_frigo: 'frigorifique',
    d3_body_citerne: 'citerne',
    d3_body_plateau: 'plateau',
    d3_body_benne: 'benne',
    d3_body_fourgon: 'fourgon',
    d3_type_semi: 'Semi-remorque',
    d3_type_porteur: 'Porteur 19 t',
    d3_type_vul: 'VUL',
    d3_status_stationne: 'Stationné',
    d3_status_mission: 'En mission',
    d3_status_atelier: 'À l’atelier',
    d3_base_site: 'Site de base',
    d3_coh_goods_without_zone: '{{client}} : {{goods}} sans « {{zone}} »',
    d3_coh_no_vehicle: '{{client}} : aucun véhicule {{bodies}} dans la flotte du dépôt',
    d3_coh_no_slot: '{{n}} véhicule(s) sans emplacement : agrandir le dépôt (P2)',
    d3_coh_no_driver: '{{n}} véhicule(s) sans chauffeur attitré',
    d3_coh_no_mechanic: 'Atelier mécanique construit sans mécanicien',
    d3_coh_no_forklift: 'Entrepôt sans cariste : stock non manutentionné',
    d3_coh_external_garage: 'Véhicule en réparation chez un garage externe (pas d’atelier)',
    d3_reco_unlocks: 'débloque « {{zone}} » requis par {{client}}',
    d3_reco_cheapest: 'étape disponible la moins coûteuse',
    d3_theme_tempere: 'Tempéré',
    d3_theme_mediterraneen: 'Méditerranéen',
    d3_theme_montagne: 'Montagne',
    d3_theme_portuaire: 'Portuaire',
    d3_theme_urbain: 'Urbain',
    d3_country_FR: 'France',
    d3_country_BE: 'Belgique',
    d3_country_LU: 'Luxembourg',
    d3_country_ES: 'Espagne',
    d3_country_DE: 'Allemagne',
    d3_country_AT: 'Autriche',
    d3_country_CH: 'Suisse',
    d3_country_IT: 'Italie',
    d3_country_NL: 'Pays-Bas',
    d3_country_PL: 'Pologne',
    d3_country_PT: 'Portugal',
    d3_country_GB: 'Royaume-Uni',
    d3_country_UK: 'Royaume-Uni',
    d3_country_MA: 'Maroc',
    d3_country_TR: 'Turquie',
    d3_hq_prefix: 'QG',
    d3_depot_prefix: 'Dépôt',
    d3_role_hq: 'siège',
    market_tab_empty: 'Aucune donnée de marge pour l\'instant.',
    market_tab_empty_hint: 'La courbe se construit chaque jour ouvré dès qu\'un contrat est en cours : marge brute moyenne (bonus inclus) face au plafond de marché de {{cap}} %.',
    market_kpi_current: 'Marge brute moyenne (aujourd\'hui)',
    market_kpi_cap: 'Plafond',
    market_kpi_average: 'Moyenne 90 jours',
    market_kpi_average_sub: 'sur {{days}} j · pic {{peak}} %',
    market_kpi_days_over: 'Jours au-dessus du plafond',
    market_kpi_days_over_sub: 'sur les 90 derniers jours ouvrés (> {{cap}} %)',
    market_kpi_renegotiated: 'Contrats renégociés',
    market_kpi_renegotiated_sub: 'manque à gagner : {{amount}}/jour',
    market_chart_title: 'Marge brute moyenne des contrats en cours vs plafond de marché',
    market_chart_subtitle: '{{days}} jours ouvrés glissants · pondérée par le CA · bonus inclus · plafond {{cap}} %',
    market_series_margin: 'Marge brute moyenne',
    market_series_renegotiated: 'Contrats renégociés',
    market_series_contracts: 'Contrats en cours',
    market_tension_high: 'Marché sous tension',
    market_tension_warm: 'Marché vigilant',
    market_tension_calm: 'Marché détendu',
    market_explainer_title: 'Comment lire ce graphique ?',
    market_explainer_body: 'Chaque jour ouvré, HST calcule la marge brute réelle de chaque contrat en cours (tarif × bonus − carburant, entretien, salaire, assurance, péages). La courbe bleue est la moyenne pondérée par le CA. Au-dessus de la ligne rouge ({{cap}} %), la zone orange signale un marché sous tension : les clients renégocient les tarifs (−3 %/jour max) jusqu\'au retour sous le plafond. Les barres orange comptent les contrats renégociés.',
    market_tension_badge_title: 'Marge brute réelle {{margin}} % > 65 % : le client renégocie le tarif (−{{pct}} % à ce jour, −3 %/jour max jusqu\'à 65 %).',
    market_tension_header: '{{count}} contrat·s renégocié·s',
    market_tension_header_title: 'Plafond d\'équilibre de marché : au-dessus de 65 % de marge brute (bonus inclus), les clients — appels d\'offres compris — renégocient progressivement le tarif.',

    sup_metric_treasury: 'Trésorerie',
    sup_metric_equity: 'Capitaux propres',
    sup_metric_monthly_ca: 'CA mensuel',
    sup_metric_monthly_charges: 'Charges mensuelles',
    sup_metric_fleet: 'Flotte',
    sup_fleet_total_active: '{{total}} ({{active}} actifs)',
    sup_metric_drivers: 'Chauffeurs',
    sup_drivers_satisfaction: '{{count}} · sat. {{sat}}%',
    sup_metric_support: 'Support',
    sup_metric_depot: 'Dépôt',
    sup_phase_label: 'Phase {{phase}}',
    sup_metric_active_contracts: 'Contrats actifs',
    sup_metric_game_phase: 'Phase de jeu',
    sup_metric_playtime: 'Temps de jeu',
    // 25/07/2026 — Débriefs annuels (vue superviseur)
    sup_yd_title: 'Débriefs annuels',
    sup_yd_loading: 'Chargement…',
    sup_yd_empty: "Aucune clôture d'exercice remontée pour l'instant (le débrief est envoyé à chaque fin d'année de jeu).",
    sup_yd_year_phase: 'Année {{year}}',
    sup_yd_phase: 'phase {{phase}}',
    sup_yd_revenue_short: 'CA',
    sup_yd_vehicles: '{{n}} véhicule(s)',
    sup_yd_drivers: '{{n}} chauffeur(s)',
    sup_yd_ao_won: '{{n}} AO gagné(s)',
    sup_yd_profit: 'Résultat',
    sup_yd_pace: 'Rythme',
    sup_yd_better_than: 'mieux que {{p}} %',
    sup_yd_faster_than: 'plus rapide que {{p}} %',
    sup_yd_pct_pending: 'Percentiles disponibles dès que ≥ 4 joueurs ont clôturé cette année.',
    sup_strategic_analysis: 'Analyse stratégique',
    sup_not_started_p1: 'Cette personne n\'a pas encore lancé le jeu, ou n\'est pas connectée à internet.',
    sup_not_started_p2: 'Les données apparaîtront ici dès la première clôture mensuelle.',
    sup_tone_encouragement: 'Encouragement',
    sup_tone_advice: 'Conseil',
    sup_tone_warning: 'Avertissement',
    sup_msg_empty: 'Le message ne peut pas être vide.',
    sup_annotate_title: 'Annoter {{name}}',
    sup_annotate_subtitle: 'Le message apparaîtra dans la Messagerie du jeu à la prochaine connexion / clôture mensuelle.',
    sup_tonality_label: 'Tonalité',
    sup_message_label: 'Message',
    sup_message_placeholder: 'Ex : Très bonne gestion de ta flotte ce mois-ci ! Garde un œil sur ta trésorerie qui se rapproche du minimum.',
    sup_chars_remaining: '{{count}} caractère{{plural}} restant{{plural}}',
    sup_annotation_sent: 'Annotation envoyée — elle apparaîtra dans la Messagerie de l\'apprenant.',
    sup_sending: 'Envoi...',
    sup_send_annotation_btn: 'Envoyer l\'annotation',
    sup_history_label: 'Historique',
    sup_read_by_apprentice: 'Lu par l\'apprenant',
    sup_awaiting_read: 'En attente de lecture',
    sup_obj_status_active: 'Actif',
    sup_obj_status_achieved: 'Atteint',
    sup_obj_status_failed: 'Manqué',
    sup_obj_status_cancelled: 'Annulé',
    sup_obj_title_required: 'Le titre est requis.',
    sup_obj_threshold_invalid: 'Le seuil chiffré est invalide.',
    sup_obj_deadline_invalid: 'La deadline doit être un entier positif (en jours de jeu).',
    sup_obj_create_error: 'Erreur lors de la création',
    sup_obj_confirm_cancel: 'Annuler cet objectif actif ?',
    sup_obj_modal_title: 'Objectif pour {{name}}',
    sup_obj_subtitle: 'Évalué automatiquement à chaque clôture mensuelle de l\'apprenant.',
    sup_obj_title_label: 'Intitulé',
    sup_obj_title_placeholder: 'Ex : Atteindre 30 000 € de trésorerie avant J90',
    sup_obj_metric_label: 'Métrique',
    sup_obj_op_label: 'Op.',
    sup_obj_threshold_label: 'Seuil',
    sup_obj_deadline_label: 'Deadline (jours de jeu, optionnel)',
    sup_obj_deadline_hint: 'Si l\'objectif n\'est pas atteint avant ce jour, il passe en statut « Manqué ». Laisser vide = pas de date limite.',
    sup_obj_created_success: 'Objectif créé — il sera évalué à la prochaine clôture mensuelle.',
    sup_obj_creating: 'Création...',
    sup_obj_create_btn: 'Créer l\'objectif',
    sup_obj_deadline_short: 'deadline J{{day}}',
    sup_obj_achieved_on: 'Atteint le {{date}}',
    sup_obj_value_label: 'valeur {{value}}',
    sup_obj_failed_on: 'Manqué le {{date}}',

    // i18n migration — Shared components (Layout, ManualButton, KpiStrip, DepotStrategyPanel, DepotScene, AdvisorInsightsPanel, InteractiveMap, depotEconomics)
    strategic_insights_label: 'Bilan stratégique',
    strategic_insights_tooltip: 'Demander un bilan stratégique au conseiller',
    reports_menu_label: 'Bilans & fiche',
    reports_menu_tooltip: 'Bilan stratégique, bilan pédagogique et fiche apprenant',
    manual_label: 'Manuel pédagogique',
    manual_open_aria: 'Ouvrir le manuel',
    manual_close_aria: 'Fermer le manuel',
    date_label: 'Date',
    kpi_daily_delta_tooltip: 'Delta lissé du dernier jour : revenus du jour − (charges fixes mensuelles ÷ 22 jours ouvrés + carburant + maintenance + assurance du jour). Un delta négatif est NORMAL les jours sans nouvelle livraison : les charges fixes (RH, crédit, loyer) sont réparties sur le mois. Voir le « Net mensuel » dans Finance pour le vrai indicateur de rentabilité.',
    kpi_smoothed_suffix: 'lissé',
    kpi_how_it_evolves: 'Comment elle évolue',
    kpi_rep_evo_1: 'Contrats terminés sans pénalité',
    kpi_rep_evo_2: 'Conducteurs bien notés et satisfaits',
    kpi_rep_evo_3: 'SAV (Lucas, Inès), Communication (Aïcha)',
    kpi_rep_evo_4: 'Résiliations, pannes, accidents',
    kpi_rep_evo_5: 'Aléas négatifs (atténués par event_rep_mitigation)',
    kpi_rep_influence: 'Influence : aléas, assurance, score crédit, fidélité clients.',
    kpi_noto_evo_1: 'Marketing (Yanis, Camille) — passif',
    kpi_noto_evo_2: 'Attachée de presse (Aïcha) — passif',
    kpi_noto_evo_3: 'Salons (Marc Dupuis débloque)',
    kpi_noto_evo_4: 'Challenges réussis (+8, couverture presse)',
    kpi_noto_evo_5: 'Décroît de 0,5/mois si aucune action',
    kpi_noto_influence: 'Influence : nombre de contrats proposés, accès grands comptes, qualité du recrutement.',
    depot_strategy_title: 'Stratégie multi-dépôts',
    depot_strategy_intro: 'Jusqu\'à **{{max}} dépôts en France** : **{{opened}} créés** (croissance organique) + **{{acquired}} rachetés** (croissance externe via M&A), **+ {{intl}} implantations internationales possibles hors France** (villes UE, phase 4). Chaque dépôt a un bonus et une charge propres.',
    depot_strategy_slots_used: 'slots occupés',
    depot_strategy_created_short: 'créés',
    depot_strategy_acquired_short: 'rachetés',
    depot_strategy_intl_short: 'intl',
    depot_strategy_kind_created: 'Créé',
    depot_strategy_kind_acquired: 'Racheté',
    depot_strategy_kind_intl: 'International',
    depot_strategy_intl_label: 'Croissance internationale — implantations hors France ({{open}}/{{max}})',
    depot_strategy_intl_slot_1_label: 'Implantation UE #1',
    depot_strategy_intl_slot_2_label: 'Implantation UE #2',
    depot_strategy_intl_slot_desc: 'Dépôt hors France (ville UE, phase 4 requise). Loyer ×1,25 — ouvre l\'accès aux contrats Export EU locaux.',
    depot_strategy_open_badge: 'OUVERT',
    depot_strategy_slot_default: 'Dépôt {{idx}}',
    depot_strategy_charge_label: 'Charge / mois',
    depot_strategy_included: 'incluse',
    depot_strategy_saturation_title: 'Saturation — Ouvrez ou rachetez un nouveau dépôt',
    depot_strategy_saturation_body: 'Votre flotte de **{{fleet}} véhicules** dépasse la capacité ({{trigger}} max au palier actuel de {{slots}} dépôt{{plural}}). Conséquences :',
    depot_strategy_sat_penalty_1: '**-10 % de revenu global**',
    depot_strategy_sat_penalty_2: 'Événement mensuel **« Plainte de voisinage »** (-3 réputation)',
    depot_strategy_sat_penalty_3: 'Refus auto des contrats > **50 000 €**',
    depot_strategy_organic_label: 'Croissance organique — dépôts créés ({{open}}/{{max}})',
    depot_strategy_external_label: 'Croissance externe — dépôts rachetés ({{open}}/{{max}})',
    depot_strategy_total_monthly: 'Loyers multi-dépôts',
    depot_strategy_rent_by_city: 'Loyer selon ville',
    depot_strategy_rent_ratio: '{{pct}} % du CA mensuel',
    depot_strategy_rent_ratio_tooltip: 'Cible saine : 8-9 % du chiffre d\'affaires en loyers. Au-delà de 12 %, votre immobilier pèse trop lourd.',
    depot_strategy_max_reached: 'Vous avez atteint le maximum de {{max}} dépôts ({{opened}} + {{acquired}}). Optimisez ceux que vous possédez.',
    depot_eco_opened_0_label: 'Siège (HQ)',
    depot_eco_opened_0_desc: 'Votre dépôt historique. Aucun bonus contractuel mais c\'est le seul qui peut être agrandi pour atteindre 10 véhicules de capacité.',
    depot_eco_opened_1_label: '+8 % rayonnement régional',
    depot_eco_opened_1_desc: 'Hub régional. +8 % de revenu sur les contrats courte distance (< 200 km). Charge mensuelle 3 500 €.',
    depot_eco_opened_2_label: '+5 % longue distance + Export',
    depot_eco_opened_2_desc: 'Hub national. +5 % de revenu sur les contrats > 500 km et déblocage des contrats Export EU/Non-EU. Charge mensuelle 4 500 €.',
    depot_eco_acquired_0_label: '+10 % notoriété locale',
    depot_eco_acquired_0_desc: 'L\'image de marque du concurrent racheté est restée forte dans la région : +10 % de réputation lors de chaque clôture mensuelle. Charge mensuelle 4 000 €.',
    depot_eco_acquired_1_label: '+5 % revenus (clients fidèles hérités)',
    depot_eco_acquired_1_desc: 'Le carnet de clients fidèles vous suit : +5 % de revenu sur TOUS vos contrats (toutes distances confondues). Charge mensuelle 5 000 €.',
    depot_eco_acquired_2_label: '-15 % fatigue chauffeurs (équipe vétéran)',
    depot_eco_acquired_2_desc: 'L\'équipe vétérane intégrée transmet ses bonnes pratiques : la fatigue des chauffeurs croît 15 % moins vite. Charge mensuelle 6 000 €.',
    depot_scene_phase_0: 'Terrain nu — prêt à construire',
    depot_scene_phase_1: 'Garage opérationnel',
    depot_scene_phase_2: 'Garage agrandi ×2',
    depot_scene_phase_3: 'Entrepôt en service',
    depot_scene_phase_4: 'Quai accolé à l\'entrepôt',
    depot_scene_phase_5: 'Entrepôt agrandi',
    depot_scene_phase_6: 'Zone frigorifique connectée',
    depot_scene_phase_7: 'Quai renforcé',
    depot_scene_phase_8: 'Entrepôt grand gabarit',
    depot_scene_phase_9: 'Borne de recharge électrique',
    depot_scene_phase_10: 'Pompe à carburant interne',
    depot_scene_phase_11: 'Atelier mécanique',
    depot_scene_phase_12: 'Zone ADR sécurisée',
    depot_scene_phase_13: 'Atelier solarisé',
    depot_scene_phase_14: 'Station carburant agrandie — dépôt complet',
    depot_scene_build_1: 'garage',
    depot_scene_build_2: 'garage agrandi ×2',
    depot_scene_build_3: 'entrepôt',
    depot_scene_build_4: 'quai de chargement accolé',
    depot_scene_build_5: 'entrepôt agrandi',
    depot_scene_build_6: 'zone frigorifique',
    depot_scene_build_7: 'quai renforcé',
    depot_scene_build_8: 'entrepôt grand gabarit',
    depot_scene_build_9: 'borne de recharge',
    depot_scene_build_10: 'pompe à carburant',
    depot_scene_build_11: 'atelier mécanique',
    depot_scene_build_12: 'zone ADR',
    depot_scene_build_13: 'panneaux solaires atelier',
    depot_scene_build_14: 'station carburant agrandie',
    depot_scene_weather_rain: 'Inondations',
    depot_scene_weather_snow: 'Verglas / neige',
    depot_scene_weather_heatwave: 'Canicule',
    depot_scene_weather_storm: 'Tempête',
    depot_scene_weather_fog: 'Brouillard',
    depot_scene_phase_label: 'Phase {{phase}}/14',
    depot_scene_new_building: 'Nouveau bâtiment : {{name}}',
    depot_scene_manage_zones_hint: 'Gérez vos zones via les cartes ci-dessous',
    contract_intl_details_show: 'détails',
    contract_intl_details_hide: 'replier',
    depot_scene_brand_tier_1: 'Site relais',
    depot_scene_brand_tier_2: 'Site régional',
    depot_scene_brand_tier_3: 'Plateforme majeure',
    depot_scene_tier_label: 'Niveau {{tier}}/3',
    depot_scene_site_upgraded: 'Site agrandi — nouvelles installations',
    depot_timeline_title: 'Frise chronologique du dépôt',
    depot_timeline_subtitle: '{{built}}/{{max}} étapes construites',
    depot_timeline_base: 'Installation initiale',
    depot_timeline_day: 'Jour {{day}}',
    depot_timeline_locked: 'À construire',
    acq_success_depot_joins_network: 'Ce site rejoint votre réseau',
    advisor_advice_from: 'Conseils de {{name}}',
    advisor_none_selected: 'Aucun conseiller sélectionné',
    insight_signals_count: '{{count}} signal·aux',
    advisor_all_clear_title: 'Tout est sous contrôle',
    advisor_all_clear_body: 'Aucun signal stratégique majeur détecté. Continuez à piloter — je reviens vers vous dès qu\'une décision mérite votre attention.',
    advisor_footer_realtime_p1: 'Ces conseils sont générés à partir d\'une analyse en temps réel de votre bilan, de votre flotte, de votre équipe et de votre carnet de commandes.',
    advisor_footer_realtime_p2: 'Ils reflètent l\'état actuel — un nouveau tour de jeu peut faire apparaître ou disparaître des signaux.',
    insight_severity_critical: 'CRITIQUE',
    insight_severity_warning: 'ATTENTION',
    insight_severity_opportunity: 'OPPORTUNITÉ',
    insight_severity_info: 'INFO',
    insight_category_finance: 'Finance',
    insight_category_fleet: 'Flotte',
    insight_category_hr: 'Ressources humaines',
    insight_category_commercial: 'Commercial',
    insight_category_fiscalite: 'Fiscalité',
    map_focus_p1: 'France local',
    map_focus_p2: 'France régional',
    map_focus_p3: 'France national',
    map_focus_p4: 'Europe',
    map_phase_select_city: 'Phase {{phase}} · {{focus}} · Cliquez sur une ville',
    map_phase_missions_in_progress: 'Phase {{phase}} · {{focus}} · {{count}} missions en cours',
    map_active_missions_label: 'Missions en cours',
    map_hq_zone_fuel_bonus: 'Zone HQ −10 % carburant',
    tax_label_essieu: 'Taxe à l\'essieu',
    nav_unread_messages: '{{count}} message{{plural}} non lu{{plural}}',
    nav_taxes_to_pay: 'Taxe·s à payer : {{list}}',
    depot_scene_previous_phase_alt: 'phase précédente',
    nav_new_features_tooltip: '{{count}} nouvel{{plural1}} fonctionnalité{{plural2}} débloquée{{plural2}} par votre équipe support',
    theme_tooltip_dark: 'Mode sombre · cliquer pour passer en clair',
    theme_tooltip_light: 'Mode clair · cliquer pour suivre le système',
    theme_tooltip_auto: 'Mode auto système · cliquer pour passer en sombre',

    // === P0 — Hide contracts ===
    contracts_hide_tooltip: 'Masquer ce contrat (réversible)',
    contracts_hide_aria: 'Masquer ce contrat',
    contracts_restore_hidden_label: 'Restaurer ({{count}})',
    contracts_restore_hidden_tooltip: 'Réafficher tous les contrats que vous avez masqués',
    contracts_sort_default: 'Ordre du marché',
    contracts_sort_margin: 'Rentabilité ↓',
    contracts_sort_revenue: 'Revenu ↓',
    contracts_sort_category: 'Catégorie A→Z',
    contracts_sort_duration: 'Durée ↑',
    contracts_sort_tier: 'Tiers ↑',
    contracts_filter_all: 'Tous',
    contracts_filter_ponctuel: 'Ponctuel',
    contracts_filter_regulier: 'Régulier',
    contracts_frigo_zone_badge: 'Zone frigo requise',
    contracts_frigo_zone_tooltip: 'À partir du tiers 3, les contrats frigorifiques exigent une zone frigorifique au dépôt. Investissez depuis la page Dépôt → panneau de la carte (QG : Zone frigorifique · dépôts : Zone frigo locale).',
    contracts_validity_badge: 'Valide J-{{days}}',
    contracts_validity_tooltip: 'Cette offre quitte le marché 14 jours après publication — encore {{days}} jour(s) pour l\'accepter.',
    contracts_frigo_zone_hint: '{{count}} contrat(s) frigorifique(s) bloqué(s) : il faut investir dans une zone frigorifique. Rendez-vous sur la page Dépôt → cliquez sur votre dépôt sur la carte → évolution « Zone frigorifique » (QG) ou « Zone frigo locale » (dépôt satellite).',
    fleet_garage_full_title: 'Garage plein — 2 camions max',
    fleet_garage_full_body: 'Votre garage de base ne loge que 2 camions. Pour acquérir un 3e véhicule (achat, leasing ou financement), construisez l\'« Agrandissement dépôt (x2) » : page Dépôt → cliquez sur votre QG sur la carte → zone Garage.',
    fleet_garage_full_btn: 'Garage plein',
    contracts_out_of_zone_badge: 'Hors zone −{{pct}} %',
    contracts_out_of_zone_tooltip: 'Ce contrat démarre à {{city}}, à {{distance}} km de votre dépôt le plus proche. Revenus réduits de {{pct}} % (sous-traitance locale, trajets à vide). Ouvrez un dépôt dans la région pour le servir à plein tarif.',
    contracts_origin_covered_tooltip: 'Origine : {{city}} — à {{distance}} km de votre dépôt le plus proche (zone couverte).',
    contracts_rare_badge: 'Opportunité rare',
    contracts_rare_tooltip: 'Contrat hors de vos zones habituelles : tarif majoré (+30 à +50 %). Une implantation locale le rendrait encore plus rentable.',
    assign_wrong_depot_notice: '{{count}} camion(s) masqué(s) : seuls les camions d\'un dépôt couvrant {{city}} peuvent servir ce contrat. Transférez un camion depuis la page Flotte si nécessaire.',
    vehicle_transfer_status: 'Transfert',
    vehicle_transfer_label: 'Transférer',
    vehicle_transfer_tooltip: 'Convoyer ce camion vers un autre dépôt (1 jour de route, 1,20 €/km, min. 300 €). Le chauffeur attaché voyage avec.',
    assign_out_of_zone_banner: '**Hors zone** : ce contrat démarre à **{{city}}** ({{distance}} km de votre dépôt de {{depotCity}}). Revenus réduits de **{{pct}} %** — sous-traitance locale et trajets à vide. Ouvrez un dépôt dans la région pour servir cette clientèle à plein tarif.',
    contracts_sort_tooltip: 'Tri activé grâce à votre équipe Marketing + Commercial',
    contracts_special_badge: 'SPÉCIAL',
    contracts_new_badge: 'NEW',
    contracts_new_tooltip: 'Contrat arrivé sur le marché il y a 2 jours ou moins',
    contracts_ready_badge: 'PRÊT',
    contracts_ready_tooltip: 'Vous avez un véhicule ET un chauffeur compatibles immédiatement disponibles. Vu grâce à votre Responsable d\'exploitation.',
    contracts_ready_filter_label: 'Exécutables maintenant',
    contracts_ready_filter_tooltip: 'N\'afficher que les contrats que vous pouvez démarrer immédiatement (véhicule + chauffeur compatibles libres).',
    // Spot exclusivity tenders — 04/06/2026
    ao_spot_badge: 'EXCLUSIF ⚡',
    ao_spot_badge_tooltip: 'Exclusivité ponctuelle — engagement de disponibilité',
    ao_spot_stat_payout: 'Tarif / mission',
    ao_spot_stat_deadline: 'Délai réponse',
    ao_spot_stat_calls_per_month: 'Missions/mois',
    ao_spot_stat_engagement: 'Engagement',
    ao_spot_deadline_value: '{{n}} j max',
    ao_spot_calls_range: '{{min}}–{{max}}',
    ao_spot_payout_range: '{{min}}–{{max}} €',
    ao_spot_engagement_days: '{{n}} j',
    contracts_permit_label: 'Permis',
    contracts_gross_margin: 'Marge brute',
    contracts_avoid: 'À éviter',
    contracts_margin_tooltip: 'Estimation : {{revenue}} − {{charges}} = {{margin}} ({{pct}}%)',
    contracts_estimate_detail: 'Détail estimation ({{days}}j ouvrés)',
    contracts_revenue_row: 'Revenu',
    contracts_fuel_row: 'Carburant',
    contracts_maintenance_row: 'Maintenance',
    contracts_salary_row: 'Salaire',
    contracts_insurance_row: 'Assurance',
    contracts_estimate_footer: 'Charges variables uniquement. Précisé dans la modale d\'assignation après choix véhicule + chauffeur.',

    // === P1 — Midal tax provisioning ===
    tax_prov_title: 'Provisionnement fiscal automatique (perk Midal)',
    tax_prov_status_on: 'Activé',
    tax_prov_status_off: 'Inactif',
    tax_prov_locked_badge: 'Recrutez Midal',
    tax_prov_intro_hired: 'À chaque contrat livré, **Tristan Midal** met automatiquement de côté la TVA collectée et **25 % d\'IS provisionnel**. Votre trésorerie affichée est désormais **la vraie trésorerie disponible** — fini les mauvaises surprises au bilan annuel.',
    tax_prov_intro_locked: '**Recrutez Tristan Midal** (DAF, fonctions support) pour débloquer le provisionnement auto TVA + IS et **dormir tranquille** au lieu de découvrir un trou en fin d\'année.',
    tax_prov_tva_reserve: 'Réserve TVA',
    tax_prov_is_reserve: 'Provision IS',
    tax_prov_locked_until_decl: 'Verrouillée — libérée à la déclaration TVA',
    tax_prov_locked_until_close: 'Verrouillée — libérée à la clôture annuelle',
    tax_prov_bonus_explainer: 'En clôture annuelle, **tout sur-provisionnement est reversé en bonus** dans votre trésorerie. Midal optimise sans bloquer votre cash.',

    // === P2 — Réserve fiscale 25 % Livret A ===
    fiscal_reserve_title: 'Réserve fiscale 25 % (Livret A · {{rate}} %)',
    fiscal_reserve_intro: 'À chaque clôture mensuelle, **25 % du bénéfice net** sont automatiquement transférés sur un compte Livret A séparé. Le solde rapporte **{{rate}} %/an** (intérêts crédités au quotidien) et est libéré à la clôture annuelle pour couvrir l\'IS ou retourner en trésorerie.',
    fiscal_reserve_balance_label: 'Solde réserve',
    fiscal_reserve_interest_label: 'Intérêts cumulés',
    fiscal_reserve_locked_hint: 'Libérée à la clôture annuelle',
    fiscal_reserve_apy: 'Rendement annuel {{rate}} %',

    // === 14/06/2026 — Délégation du paiement TVA/IS (Comptable / DAF) ===
    tax_autopay_title: 'Délégation du paiement TVA & IS',
    tax_autopay_locked_badge: 'Comptable / DAF requis',
    tax_autopay_intro_hired: '**{{name}}** ({{role}}) déclare et règle automatiquement la TVA et les acomptes IS à chaque échéance, dès que la provision ou la trésorerie le permet. Désactivez pour reprendre la main.',
    tax_autopay_intro_locked: 'Recrutez un **Comptable** ou un **DAF** (page Fonctions support) pour déléguer la déclaration et le paiement automatique de la TVA et des acomptes IS.',
    tax_autopay_active_hint: 'À chaque échéance, {{name}} règle d\'abord depuis les provisions, puis depuis la trésorerie. En cas de fonds insuffisants, vous reprenez la main (échéancier DGFiP, crédit fiscal…).',

    // === P3 — Acquired driver bios ===
    acq_drv_bio_veteran: 'Routier(ère) chevronné(e), 25 ans de cabine. Bosse à l\'instinct, allergique aux nouveaux outils.',
    acq_drv_bio_quiet_pro: 'Discret(ète) et fiable. Ne fait pas de vagues — exécute proprement, livre à l\'heure.',
    acq_drv_bio_methodical: 'Maniaque du carnet de bord. Vérifie tout deux fois avant de partir.',
    acq_drv_bio_team_player: 'Bonne ambiance dans la cabine. Toujours partant(e) pour dépanner un collègue.',
    acq_drv_bio_old_school: 'École CAP transport, 30 ans de métier. Se méfie des camions « tout électronique ».',
    acq_drv_bio_eager_youngster: 'Permis fraîchement décroché, motivation à fond. Demande sa première longue distance.',
    acq_drv_bio_diplomat: 'Bon contact client. Souvent envoyé(e) en mission sensible (livraisons grands comptes).',

    // === Midal year-end bonus modal ===
    marchetti_bonus_kicker: 'Clôture annuelle {{year}} · Tristan Midal',
    marchetti_bonus_title: 'Bonne nouvelle Patron !',
    marchetti_bonus_quote: 'Patron, on avait mis trop d\'argent de côté pour le fisc — {{amount}} retombent dans la trésorerie. Avec moi, zéro mauvaise surprise.',
    marchetti_bonus_is_over: 'IS sur-provisionné · refund',
    marchetti_bonus_reserve_release: 'Réserve fiscale Livret A · libération annuelle',
    marchetti_bonus_interest_included: 'dont +{{interest}} d\'intérêts capitalisés',
    marchetti_bonus_cta: 'Excellent — direction la trésorerie',

    // === Annual board meeting (Comité de direction) — 31/05/2026 ===
    board_meeting_kicker: 'Comité de direction · Année {{year}}',
    board_meeting_title: "Bonne fin d'année !",
    board_meeting_progress: 'Intervenant {{current}} / {{total}}',
    board_meeting_prev: 'Précédent',
    board_meeting_next: 'Suivant',
    board_meeting_close: "Clôturer le comité",

    // === Support roles & families (data layer i18n) — 30/05/2026 ===
    support_family_admin_name: "Administration / Exploitation",
    support_family_commerce_name: "Commerce",
    support_family_marketing_name: "Marketing",
    support_family_communication_name: "Communication",
    support_family_achats_name: "Achats",
    support_family_finance_name: "Comptabilité / Finance",
    support_family_rh_name: "Ressources Humaines",
    support_family_sav_name: "SAV / Centre d'appel",
    support_family_garage_name: "Garage / Mécanicien",
    support_family_qhse_name: "QHSE / RSE",
    support_role_role_nathalie_robert_title: "Assistante administrative",
    support_role_role_nathalie_robert_bg: "Formation Gestion, méthodique et rigoureuse, soulage la direction sur tout le suivi administratif quotidien.",
    support_role_role_nathalie_robert_prereq: "CA > 10 000 €/mois",
    support_role_role_nathalie_robert_bonus_0: "+10 % revenus (facturation fluidifiée)",
    support_role_role_christophe_faure_title: "Responsable d'exploitation",
    support_role_role_christophe_faure_bg: "Cadre transport pendant 15 ans, pilote tournées et imprévus avec une rigueur militaire.",
    support_role_role_christophe_faure_prereq: "CA > 25 000 €/mois",
    support_role_role_christophe_faure_bonus_0: "+20 % revenus (planification optimisée)",
    support_role_role_christophe_faure_bonus_1: "+1 réputation / mois (fiabilité)",
    support_role_role_lea_bertrand_title: "Commerciale junior",
    support_role_role_lea_bertrand_bg: "Ex-grande distribution sportive, énergique et orientée terrain.",
    support_role_role_lea_bertrand_prereq: "CA > 5 000 €/mois",
    support_role_role_lea_bertrand_bonus_0: "+10 % revenus contrats classiques",
    support_role_role_marc_dupuis_title: "Commercial terrain",
    support_role_role_marc_dupuis_bg: "15 ans dans le transport, démarche prospects et participe aux salons régionaux.",
    support_role_role_marc_dupuis_prereq: "CA > 20 000 €/mois",
    support_role_role_marc_dupuis_bonus_0: "+30 % revenus (nouveaux contrats apportés)",
    support_role_role_sylvie_marchand_title: "Directrice commerciale",
    support_role_role_sylvie_marchand_bg: "Ancienne cadre logistique grands comptes, ouvre les portes de l'industrie premium.",
    support_role_role_sylvie_marchand_prereq: "Marc Dupuis recruté + CA > 50 000 €/mois",
    support_role_role_sylvie_marchand_bonus_0: "+50 % revenus",
    support_role_role_yanis_elkaroui_title: "Chargé marketing",
    support_role_role_yanis_elkaroui_bg: "École de communication, créatif et au fait des codes digitaux.",
    support_role_role_yanis_elkaroui_prereq: "CA > 8 000 €/mois",
    support_role_role_yanis_elkaroui_bonus_0: "+1 notoriété / mois (présence digitale)",
    support_role_role_yanis_elkaroui_bonus_1: "+5 % contrats (effet vitrine)",
    support_role_role_camille_roussel_title: "Responsable marketing",
    support_role_role_camille_roussel_bg: "Ex-agence de publicité, structure une vraie stratégie de marque.",
    support_role_role_camille_roussel_prereq: "Yanis El Karoui recruté",
    support_role_role_camille_roussel_bonus_0: "+2 notoriété / mois",
    support_role_role_thomas_vidal_title: "Community Manager",
    support_role_role_thomas_vidal_bg: "Freelance, gère les réseaux sociaux et fluidifie les premières crises en ligne.",
    support_role_role_thomas_vidal_prereq: "CA > 6 000 €/mois",
    support_role_role_thomas_vidal_bonus_0: "+5 % contrats",
    support_role_role_thomas_vidal_bonus_1: "-50 % impact aléas réputation",
    support_role_role_aicha_diallo_title: "Attachée de presse",
    support_role_role_aicha_diallo_bg: "Ex-attachée de presse, transforme chaque crise en opportunité narrative.",
    support_role_role_aicha_diallo_prereq: "Yanis El Karoui recruté",
    support_role_role_aicha_diallo_bonus_0: "+1,5 notoriété / mois",
    support_role_role_aicha_diallo_bonus_1: "+0,5 réputation / mois (gestion de crise)",
    support_role_role_karim_benali_title: "Acheteur junior",
    support_role_role_karim_benali_bg: "Ex-acheteur chez un constructeur automobile, ferme et analytique.",
    support_role_role_karim_benali_prereq: "3+ véhicules",
    support_role_role_karim_benali_bonus_0: "-5 % coût carburant",
    support_role_role_helene_pichon_title: "Responsable achats",
    support_role_role_helene_pichon_bg: "Acheteuse grands comptes industrie, négocie des conditions cadres très favorables.",
    support_role_role_helene_pichon_prereq: "Karim Benali recruté + 8+ véhicules",
    support_role_role_helene_pichon_bonus_0: "-10 % carburant",
    support_role_role_helene_pichon_bonus_1: "-8 % coût maintenance",
    support_role_role_sophie_lambert_title: "Comptable",
    support_role_role_sophie_lambert_bg: "DCG en poche, méticuleuse, sait optimiser les déductions fiscales.",
    support_role_role_sophie_lambert_prereq: "CA > 15 000 €/mois",
    support_role_role_sophie_lambert_bonus_0: "-3 % IS (optimisation fiscale)",
    support_role_role_pierre_marchetti_title: "Directeur administratif et financier",
    support_role_role_pierre_marchetti_bg: "Ex-DAF d'un groupe de transport, sait négocier avec les banques et anticiper l'IS.",
    support_role_role_pierre_marchetti_prereq: "Sophie Lambert recrutée",
    support_role_role_pierre_marchetti_bonus_0: "Débloque le provisionnement auto TVA + 25 % IS par contrat livré (zéro mauvaise surprise au bilan)",
    support_role_role_pierre_marchetti_bonus_1: "-10 % agios",
    support_role_role_nadia_cheikh_title: "Responsable RH",
    support_role_role_nadia_cheikh_bg: "Ex-cabinet de recrutement, fidélise les équipes et baisse drastiquement le turnover.",
    support_role_role_nadia_cheikh_prereq: "CA > 18 000 €/mois",
    support_role_role_nadia_cheikh_bonus_0: "-50 % turnover chauffeurs",
    support_role_role_nadia_cheikh_bonus_1: "+5 satisfaction passive / mois",
    support_role_role_nadia_cheikh_bonus_2: "+4 profils chauffeurs recrutables (tier 1)",
    support_role_role_nadia_cheikh_bonus_3: "Révèle traits de personnalité quotidiens + matrice de compatibilité",
    support_role_role_karim_sefrioui_title: "Chasseur de tête",
    support_role_role_karim_sefrioui_bg: "Tête chercheuse du transport — connaît les meilleurs profils du marché et débloque les talents premium.",
    support_role_role_karim_sefrioui_prereq: "Nadia Cheikh recrutée",
    support_role_role_karim_sefrioui_bonus_0: "+4 profils chauffeurs premium (tier 2)",
    support_role_role_karim_sefrioui_bonus_1: "-20 % turnover supplémentaire",
    support_role_role_lucas_mercier_title: "Hotliner",
    support_role_role_lucas_mercier_bg: "Patient et clair au téléphone, gère les premières réclamations.",
    support_role_role_lucas_mercier_prereq: "CA > 10 000 €/mois",
    support_role_role_lucas_mercier_bonus_0: "+0,5 réputation / mois",
    support_role_role_ines_bouchard_title: "Responsable service client",
    support_role_role_ines_bouchard_bg: "Structure un vrai service client, méthodique et empathique.",
    support_role_role_ines_bouchard_prereq: "Lucas Mercier recruté",
    support_role_role_ines_bouchard_bonus_0: "+1 réputation / mois",
    support_role_role_ines_bouchard_bonus_1: "-50 % impact aléas réputation",
    support_role_role_mehdi_ferhat_title: "Mécanicien",
    support_role_role_mehdi_ferhat_bg: "CAP méca + 5 ans atelier, débrouillard et efficace.",
    support_role_role_mehdi_ferhat_prereq: "4+ véhicules",
    support_role_role_mehdi_ferhat_bonus_0: "-20 % coût maintenance",
    support_role_role_bruno_lavergne_title: "Chef d'atelier",
    support_role_role_bruno_lavergne_bg: "Vétéran du diesel, anticipe les pannes avant qu'elles ne surviennent.",
    support_role_role_bruno_lavergne_prereq: "Mehdi Ferhat recruté + 10+ véhicules",
    support_role_role_bruno_lavergne_bonus_0: "-40 % coût maintenance",
    support_role_role_claire_marechal_title: "Responsable QHSE / RSE",
    support_role_role_claire_marechal_bg: "Ingénieure HSE de formation, certifiée ISO 14001 et 45001. Pilote la responsabilité sociétale (CO2, parité, salaires), les formations obligatoires FIMO/FCO et anticipe les audits DREAL/URSSAF. Calme, méthodique, refuse les compromis sur la sécurité.",
    support_role_role_claire_marechal_prereq: "CA > 35 000 €/mois + 4+ véhicules",
    support_role_role_claire_marechal_bonus_0: "+1 réputation / mois (gestion HSE)",
    support_role_role_claire_marechal_bonus_1: "Débloque le tableau de bord RSE (score consolidé)",
    support_role_role_claire_marechal_bonus_2: "Débloque les contrats RSE premium",

    // RSE Dashboard (Phase 1-5, Claire Maréchal)
    rse_dashboard_title: 'Tableau de bord RSE / HSE',
    rse_locked_subtitle: 'Verrouillé',
    rse_locked_recruit_prefix: 'Recrutez',
    rse_locked_recruit_suffix: '(Responsable QHSE / RSE) dans les Fonctions support pour débloquer :',
    rse_locked_bullet_score: 'Score RSE consolidé (CO2, flotte verte, parité, salaires)',
    rse_locked_bullet_audit: 'Notation annuelle EcoVadis (Bronze / Silver / Gold)',
    rse_locked_bullet_contracts: 'Contrats RSE premium (marchés publics, grands comptes)',
    rse_locked_bullet_training: 'Suivi des formations obligatoires FIMO/FCO',
    rse_pilot_by_claire: 'Pilotage par Claire Maréchal',
    rse_overall_label: 'Score global RSE',
    rse_realtime_caption: "Recalculé en temps réel. Audit annuel à la clôture de l'exercice.",
    rse_sub_co2: 'CO2 / km',
    rse_sub_green: 'Flotte verte',
    rse_sub_parity: 'Parité H/F',
    rse_sub_wage: 'Équité salariale',
    rse_caption_in_fleet: 'en flotte',
    rse_caption_low_carbon: 'bas-carbone',
    rse_caption_drivers: 'chauffeurs',
    rse_caption_wage_spread: 'Spread junior → senior',
    rse_caption_vehicles_singular: 'véhicule',
    rse_caption_vehicles_plural: 'véhicules',
    rse_weight_label: 'pds',
    rse_methodology_label: 'Méthodologie :',
    rse_methodology_text: "Score pondéré 30 % CO2 + 30 % flotte verte + 20 % parité + 20 % équité salariale. Atteindre le seuil Silver (≥ 55) débloque les contrats RSE premium ; Gold (≥ 75) ouvre les marchés publics et les appels d'offres responsables.",
    rse_tier_none: 'Non noté',
    rse_tier_bronze: 'Bronze',
    rse_tier_silver: 'Silver',
    rse_tier_gold: 'Gold',

    // HSE Compliance card (Phase 4 + 5)
    hse_compliance_title: 'Compliance HSE — Formations obligatoires',
    hse_chip_compliant: 'Conformes',
    hse_chip_expiring: 'À renouveler',
    hse_chip_expired: 'Expirées',
    hse_training_fco_short: 'FCO',
    hse_training_medical_short: 'Médical',
    hse_training_adr_short: 'ADR',
    hse_training_caces_short: 'CACES',
    hse_training_na: 'Aucun chauffeur concerné',
    hse_expired_at: 'Expirée',
    hse_days_remaining: 'j restants',
    hse_no_attention: 'Aucune formation à renouveler dans les 60 prochains jours.',
    hse_footer_methodology: 'FCO valide 5 ans (1800 j), médical 1 an, ADR/CACES 5 ans. Médical & FCO comptent ×2 dans le score ; ADR/CACES ×1. Programmez les formations depuis la fiche RH du chauffeur.',
    // Contract assign modal — HSE soft block warnings
    contract_hse_medical_blocked: "**{{name}}** ne peut pas être affecté(e) : **visite médicale expirée** (J{{expiresOn}}). Renouvellement obligatoire avant toute conduite.",
    contract_hse_adr_blocked: "**{{name}}** ne peut pas prendre ce véhicule **ADR** : recyclage ADR expiré (J{{expiresOn}}). Programmez le rappel avant affectation.",

    // ── Appels d'Offres (02/06/2026) ──
    ao_page_title: "Appels d'Offres",
    ao_page_subtitle: "Marchés long-terme à forte valeur. Soumissionnez puis négociez si le client revient avec une contre-proposition.",
    // 15/06/2026 — Pipeline AO (récap page + widget Dashboard)
    ao_widget_title: 'Appels d\'offres en cours',
    ao_pipeline_pending: 'Candidatures en attente',
    ao_pipeline_counter: 'Contre-offres à traiter',
    ao_pipeline_staff: 'AO gagnés à staffer',
    ao_staff_section: 'AO gagnés — à staffer',
    ao_staff_hint: 'Associez un véhicule et un chauffeur pour démarrer ce marché.',
    ao_staff_btn: 'Associer véhicule & chauffeur',
    ao_staff_deadline: 'Délai de staffing : J+{days} restant{plural} avant annulation (-10 réputation)',
    ao_staff_deadline_critical: '⚠️ Délai de staffing : J+{days} restant{plural} avant annulation (-10 réputation)',
    ao_locked_title: "Appels d'Offres verrouillés",
    ao_locked_subtitle: "Une fonction commerciale est requise",
    ao_locked_body: "Les AO premium ne sont accessibles qu'à partir du moment où vous recrutez au moins une **fonction commerciale**. Plus votre niveau commercial est élevé, plus les AO accessibles seront ambitieux :",
    ao_locked_bullet_junior: "**Léa Bertrand** (junior) — débloque les AO locaux (mairies, distribution régionale)",
    ao_locked_bullet_senior: "**Marc Dupuis** (senior) — débloque les AO régionaux (coopératives, industriels)",
    ao_locked_bullet_expert: "**Sylvie Marchand** (expert) — débloque les AO nationaux (grands comptes, marchés publics)",
    ao_locked_hint: "Rendez-vous dans l'onglet **Fonctions support** pour recruter.",
    ao_section_open: "AO ouverts",
    ao_section_history: "Historique",
    ao_empty_title: "Aucun appel d'offres ouvert pour le moment.",
    ao_empty_hint: "Le marché renouvelle ses appels chaque semaine (lundi). Vérifiez aussi que votre **flotte**, votre **compliance HSE** et votre **tier RSE** sont au niveau.",
    ao_eligibility_commercial: "Niveau commercial",
    ao_eligibility_fleet: "Flotte",
    ao_eligibility_rse: "RSE",
    ao_eligibility_medical: "Médical",
    ao_tier_local: "Local",
    ao_tier_regional: "Régional",
    ao_tier_national: "National",
    ao_card_fleet_count: "{{n}} véh.",
    ao_card_ref_per_day: "Réf. /jour",
    ao_card_duration: "Durée imposée",
    ao_card_min_fleet: "Flotte mini",
    ao_card_min_rse: "RSE mini",
    ao_card_expires_in: "Expire dans {{days}} j",
    ao_card_prepare_offer: "Préparer une offre",
    ao_card_pending: "Offre en cours d'examen",
    ao_card_pending_detail: "{{price}} €/j × {{duration}} j · réponse client à J{{day}}.",
    ao_card_probability_estimate: "Probabilité estimée : ~{{pct}}%",
    ao_card_counter_received: "Contre-proposition reçue",
    ao_card_your_offer: "Votre offre",
    ao_card_counter_offer: "Contre-offre",
    ao_card_accept: "Accepter",
    ao_card_refuse: "Refuser",
    ao_history_won: "Remporté",
    ao_history_lost: "Perdu",
    ao_history_via_negotiation: "(négo)",

    // Tender application modal
    ao_modal_kicker: "Appel d'offres",
    ao_modal_duration_label: "Durée du contrat (imposée par le client)",
    ao_modal_duration_unit: "jours",
    ao_modal_price_label: "Prix /jour /véhicule",
    ao_modal_price_hint: "Réf. client : {{ref}} €. Plage acceptée : {{min}}-{{max}} €",
    ao_modal_hse_label: "Engagement HSE / RSE proposé",
    ao_modal_hse_low_label: "Standard",
    ao_modal_hse_low_desc: "KPI annuel",
    ao_modal_hse_medium_label: "Modéré",
    ao_modal_hse_medium_desc: "Audit semestriel",
    ao_modal_hse_high_label: "Fort",
    ao_modal_hse_high_desc: "Audit trimestriel + flotte verte 25 %",
    ao_modal_intel_title: "Analyse concurrentielle",
    ao_modal_proba_label: "Probabilité d'obtention",
    ao_modal_total_value: "Valeur totale si remporté",
    ao_modal_cancel: "Annuler",
    ao_modal_submit: "Soumettre l'offre",
    ao_modal_error_prefix: "Erreur",
    ao_modal_competitor_range: "Fourchette prix concurrents estimée :",

    // Board-meeting AO recap (mid-year + annual)
    board_tender_recap_title: "Appels d'Offres — bilan {{scope}}",
    board_tender_recap_scope_s1: "S1",
    board_tender_recap_scope_year: "année",
    board_tender_winrate_label: "Taux {{pct}}%",
    board_tender_won_label: "Remportés",
    board_tender_lost_label: "Perdus",
    board_tender_pending_label: "En cours",
    board_tender_revenue_label: "CA sécurisé",
    board_tender_top_label: "Top contrat",
    board_tender_via_counter_one: "{{n}} signature via négociation",
    board_tender_via_counter_many: "{{n}} signatures via négociation",

    // ── 02/06/2026 — Fire driver / Rupture conventionnelle modal ──
    fire_modal_kicker: "Fin de contrat",
    fire_modal_seniority: "Ancienneté : {{months}} mois",
    fire_modal_gross: "Salaire brut estimé : {{amount}}/mois",
    fire_modal_mode_rupture_title: "Rupture conventionnelle",
    fire_modal_mode_rupture_desc: "Négociée à l'amiable, pas de préavis. Recommandé.",
    fire_modal_mode_fault_title: "Licenciement",
    fire_modal_mode_fault_desc: "Cause réelle et sérieuse, préavis 2 mois dû.",
    fire_modal_probation_note: "Ancienneté inférieure à 8 mois : rupture en période d'essai. Aucune indemnité légale due, seul un solde de tout compte est versé.",
    fire_modal_row_indemnity: "Indemnité de rupture (ISRC)",
    fire_modal_row_notice: "Préavis",
    fire_modal_row_paidleave: "Congés payés (solde)",
    fire_modal_row_charges: "Charges patronales",
    fire_modal_row_total: "Coût total employeur",
    fire_modal_cancel: "Annuler",
    fire_modal_confirm: "Confirmer · {{amount}}",
    // Notification titles after firing
    fire_notif_probation: "Rupture période d'essai",
    fire_notif_fault: "Licenciement",
    fire_notif_rupture: "Rupture conventionnelle",
    // Notification body templates (built via tStandalone in severance.js).
    severance_summary_probation: "{{driverName}} — Rupture en période d'essai ({{months}} mois). Solde de tout compte : {{total}}. Aucune indemnité légale due.",
    severance_summary_rupture: "Rupture conventionnelle de {{driverName}} — Ancienneté : {{months}} mois. Salaire brut estimé : {{gross}}/mois. ISRC : {{indemnity}} · Préavis : {{notice}} · CP : {{paidLeave}} · Charges : {{charges}}. Coût total : {{total}}.",
    severance_summary_fault: "Licenciement de {{driverName}} — Ancienneté : {{months}} mois. Salaire brut estimé : {{gross}}/mois. ISRC : {{indemnity}} · Préavis : {{notice}} · CP : {{paidLeave}} · Charges : {{charges}}. Coût total : {{total}}.",

    // ── 02/06/2026 — Auto-entrepreneur incompatibility modal ──
    auto_blocked_kicker: "Statut incompatible",
    auto_blocked_title: "Auto-entrepreneur : bloqué dans HST",
    auto_blocked_intro: "Le statut **Auto-entrepreneur (micro-entreprise)** ne convient pas au mode de jeu de HST :",
    auto_blocked_bullet_1: "Vous êtes **dirigeant**, pas conducteur — vous allez recruter immédiatement des chauffeurs **salariés**.",
    auto_blocked_bullet_2: "Le régime micro-entreprise **n'autorise pas l'embauche** de salariés (le dirigeant exerce seul).",
    auto_blocked_bullet_3: "Plafond de CA **188 700 €** rapidement dépassé en transport.",
    auto_blocked_bullet_4: "Crédibilité bancaire **insuffisante** pour financer une flotte.",
    auto_blocked_pedagogy: "👨‍🏫 **Pédagogie :** dans la réalité, un transporteur léger qui n'a besoin d'aucun salarié peut rester en auto-entrepreneur. Dès qu'il recrute, il bascule vers EI, EURL ou SARL.",
    auto_blocked_recommended: "Statuts recommandés pour HST",
    auto_blocked_choose_ei: "→ Continuer en EI",
    auto_blocked_choose_ei_desc: "Simple, pas de capital, TNS 40%.",
    auto_blocked_choose_eurl: "→ Continuer en EURL",
    auto_blocked_choose_eurl_desc: "Société 1 associé, IS au choix.",
    auto_blocked_choose_other: "Choisir un autre statut moi-même",

    // ── 02/06/2026 — Support hire celebration popup ──
    support_celebration_kicker: "Félicitations",
    support_celebration_title: "{{name}} rejoint votre équipe !",
    support_celebration_subtitle: "Vous avez maintenant accès à",
    support_celebration_continue: "Continuer",
    support_celebration_pending_bonuses: "Bonus disponibles dès le prochain cycle de jeu.",

    // ── 02/06/2026 — HR sub-tabs (moved from Strategy) ──
    hr_tab_compat: "Compatibilité",
    hr_tab_rse: "RSE / HSE",

    // ── 02/06/2026 — Strategic acquisition value KPI ──
    comp_strategic_value_label: "Valeur stratégique d'acquisition",
    comp_strategic_tier_strategic: "Cible stratégique — priorité haute",
    comp_strategic_tier_attractive: "Cible attractive — bonne opportunité",
    comp_strategic_tier_limited: "Intérêt limité — étudier ROI",
    comp_strategic_tier_marginal: "Intérêt marginal — éviter",
    comp_strategic_dim_fleet: "Flotte (tiers)",
    comp_strategic_dim_specialties: "Spécialités",
    comp_strategic_dim_revenue: "CA déclaré",
    comp_strategic_dim_reach: "Couverture (dépôts)",
    // ── Dashboard Benefits card ──
    benefits_card_title: "Bénéfices & Récompenses",
    benefits_card_months_run: "{{n}} mois écoulés",
    benefits_card_cumul: "Bénéfice cumulé",
    benefits_card_last12: "12 derniers mois",
    benefits_card_best_month: "Meilleur mois",
    benefits_card_rewards: "Récompenses",
    benefits_card_rewards_sub_some: "succès débloqués",
    benefits_card_rewards_sub_none: "aucun pour l'instant",
    benefits_card_rewards_positive_years_one: "{{n}} an +",
    benefits_card_rewards_positive_years_many: "{{n}} ans +",
    // ── Strategie Support benefits panel ──
    support_benefits_title: "Avantages des fonctions support",
    support_benefits_count_one: "{{n}} recrue",
    support_benefits_count_many: "{{n}} recrues",
    support_benefits_empty_title: "Aucune fonction support recrutée pour l'instant.",
    support_benefits_empty_hint: "Chaque recrue débloque des bonus de gameplay — visite l'onglet RH pour explorer.",
    // ── Annual board meeting — avoidable HR cost card ──
    rh_avoidable_cost_title: "Coût RH évitable",
    rh_avoidable_cost_summary_one: "{{n}} rupture sur l'exercice.",
    rh_avoidable_cost_summary_many: "{{n}} ruptures sur l'exercice.",
    rh_avoidable_cost_breakdown_rupture: "Rupture conv. : {{amount}}. ",
    rh_avoidable_cost_breakdown_fault: "Licenciement : {{amount}}. ",
    rh_avoidable_cost_breakdown_probation: "Période d'essai : {{amount}}. ",
    rh_avoidable_cost_tip: "Chaque départ pèse sur la trésorerie. Mieux recruter et fidéliser réduit ce poste.",
    // ── Admin Licences — Hide TEST toggle ──
    admin_hide_test_label: "Masquer TEST",
    admin_hide_test_label_with_count: "Masquer TEST ({{n}})",
    admin_hide_test_title: "{{n}} licence(s) TEST détectée(s)",
    admin_expires_modify_title: "Modifier l'échéance",
    admin_expires_save_title: "Enregistrer",
    admin_expires_cancel_title: "Annuler",
    admin_expires_date_required: "Date requise",
    admin_expires_preset_30: "+30 j",
    admin_expires_preset_90: "+90 j",
    admin_expires_preset_365: "+1 an",
    admin_expires_days_remaining: "{{n}}j restants",

    // ════ Game Over modal (3-act cinematic) — 03/06/2026 hotfix
    gameover_court_header: 'Tribunal de Commerce',
    gameover_act1_title: 'Convocation au Tribunal',
    gameover_day_label: 'Jour {{day}} d\'activité',
    gameover_reason_default: 'pour cessation de paiements caractérisée',
    gameover_reason_technical: 'pour erreur technique exceptionnelle',
    gameover_salutation: 'Monsieur le Dirigeant,',
    gameover_act1_p1_pre: 'Vous êtes convoqué(e) ce jour au Tribunal de Commerce ',
    gameover_act1_p1_post: '. Conformément aux articles L631-1 et suivants du Code de commerce, votre entreprise fait l\'objet d\'une **procédure de liquidation judiciaire**.',
    gameover_act1_p2: 'Le juge-commissaire désignera un mandataire judiciaire chargé de **réaliser l\'actif** (vente des véhicules) et de **régler les créanciers** selon l\'ordre des privilèges. Vos salariés bénéficieront de la procédure de garantie AGS.',
    gameover_act1_footer: 'Document officiel — Greffe du Tribunal de Commerce',
    gameover_act1_next: 'Convoquer le mandataire',

    gameover_act2_label: 'Acte II — Liquidation',
    gameover_act2_title: 'Réalisation de l\'actif',
    gameover_fleet_sold_label: 'Véhicules vendus',
    gameover_fleet_sold_value: '{{count}} véhicule{{plural}} cédé{{plural}} aux enchères',
    gameover_drivers_dismissed_label: 'Chauffeurs licenciés',
    gameover_drivers_dismissed_value: '{{count}} chauffeur{{plural}} pris en charge par l\'AGS',
    gameover_residual_debt_label: 'Dette résiduelle après liquidation',
    gameover_plural_s: 's',
    gameover_activity_duration: 'Durée d\'activité',
    gameover_days: 'jours',
    gameover_final_equity: 'Capitaux propres finaux',
    gameover_act2_footer: 'La liquidation est désormais effective. Les actifs ont été réalisés.',
    gameover_act2_next: 'Voir le bilan pédagogique',

    gameover_act3_label: 'Acte III — Bilan',
    gameover_act3_title: 'Leçons à retenir',
    gameover_act3_summary: 'Sur {{days}} jours d\'activité : {{revenue}} € de revenus pour {{expenses}} € de dépenses.',
    gameover_three_causes: 'Les 3 causes principales',
    gameover_tips_label: 'Conseils pour la prochaine partie',
    gameover_wisdom_bonus: '*« Une faillite n\'est pas un échec, c\'est une école. Maurice Lebon, ex-directeur logistique, qui en a vu d\'autres. »*',
    gameover_restart_btn: 'Recommencer une nouvelle partie',

    // Contract assignment modal banner — 03/06/2026
    contract_assignment: 'Assignation contrat',

    // Assignment conflict modal — 04/06/2026
    assignment_conflict_title: "Conflit d'assignation",
    assignment_conflict_intro: 'Reprendre ce contrat va **interrompre** le(s) contrat(s) en cours suivant(s) :',
    assignment_conflict_vehicle_busy: 'Véhicule déjà sur :',
    assignment_conflict_driver_busy: 'Chauffeur déjà sur :',
    assignment_conflict_days_remaining: '{{days}}j restants',
    assignment_conflict_warning: 'Les contrats interrompus vous coûteront -3 points de réputation chacun. Le client sera notifié et sa fidélité chutera de -15 points.',
    assignment_conflict_keep: 'Garder mes contrats actuels',
    assignment_conflict_force: 'Interrompre et reprendre ce contrat',
    assignment_conflict_notif_title: 'Contrat interrompu',
    assignment_conflict_notif_message: 'Le contrat « {{name}} » a été interrompu suite à la réassignation de son véhicule/chauffeur. Réputation -3.',

    // ============== Phases & Atouts panel (08/02/2026 refonte) =========
    phases_atouts_title: 'Phases & Atouts',
    phases_atouts_intro: 'Visualise les 4 phases du jeu et les leviers — fonctions support, investissements infrastructure et bonus combinés — comme un arbre de compétences. Les nœuds verts sont actifs, les bleus à débloquer, les gris verrouillés.',
    phases_panel_progress_title: 'Progression du jeu — 4 phases',
    phases_panel_current_label: 'Phase courante',
    phases_panel_trigger_label: 'Déclencheur',
    phases_panel_unlocks_label: 'Débloque',
    phases_panel_aria_current: 'Phase en cours',
    phases_panel_aria_reached: 'Phase franchie',
    phases_panel_aria_locked: 'Phase verrouillée',
    phases_panel_features_title: 'Fonctionnalités débloquées par recrutement',
    phases_panel_features_intro: 'Chaque ligne montre une fonctionnalité du jeu et le(s) support(s) à recruter pour la débloquer. Vert = déjà actif, gris = à débloquer.',
    phases_panel_th_state: 'État',
    phases_panel_th_feature: 'Fonctionnalité',
    phases_panel_th_recruit: 'Recruter',
    phases_panel_unlocked: 'Débloqué',
    phases_panel_to_unlock: 'À débloquer',
    phases_panel_or: 'ou',
    phase_1_label: 'Phase 1 — Local',
    phase_2_label: 'Phase 2 — Régional',
    phase_3_label: 'Phase 3 — National',
    phase_4_label: 'Phase 4 — International',
    phase_1_trigger_1: 'Lancement de partie (par défaut, aucune condition).',
    phase_1_unlock_1: 'Contrats Tier 1 et Tier 2 (messagerie, vrac léger, frigo de proximité)',
    phase_1_unlock_2: 'Cinq villes FR locales : Paris, Lyon, Marseille, Bordeaux, Lille',
    phase_1_unlock_3: '3 dépôts maximum',
    phase_2_trigger_1: 'Acheter l\'investissement « Agrandissement dépôt (x2) » à 8 000 € (4 places véhicules).',
    phase_2_unlock_1: 'Contrats Tier 3 (lots inter-régionaux, frigo longue distance, BTP semi-lourd)',
    phase_2_unlock_2: 'Capacité QG +10 % (impactMultiplier)',
    phase_2_unlock_3: 'Toujours 3 dépôts max — incite à investir dans la qualité avant la quantité',
    phase_3_trigger_1: 'Ouvrir un nouveau dépôt en France (hors QG)',
    phase_3_trigger_2: 'OU racheter un concurrent (M&A finalisé)',
    phase_3_trigger_3: 'OU acheter l\'investissement « Extension logistique (+100 km) » (18 000 €) — ou un upgrade radiusExtension sur dépôt satellite.',
    phase_3_unlock_1: 'Contrats Tier 4 et Tier 5 (ADR, convoi exceptionnel, porte-engins, machines agricoles)',
    phase_3_unlock_2: 'Toutes les villes FR ouvertes (Nantes, Toulouse, Nice, Montpellier...)',
    phase_3_unlock_3: '5 dépôts maximum — maillage national',
    phase_3_unlock_4: 'Leasing libéré (plafond ∞) — accès aux groupements financiers',
    phase_4_trigger_1: 'Ouvrir un dépôt à l\'étranger (Barcelone, Madrid, Francfort, Milan, Bruxelles...)',
    phase_4_trigger_2: 'OU acheter un véhicule Tier 5 (R 650 V8, FX Electric, Heavyhaul XXL, Porte-engins).',
    phase_4_unlock_1: 'Contrats internationaux (Export UE, lot Espagne/Allemagne, frigo EU)',
    phase_4_unlock_2: 'Onglet Fiscalité internationale (TVA intra-UE, douane, incoterms)',
    phase_4_unlock_3: 'Pension de retraite chef d\'entreprise calculable',
    phase_4_unlock_4: 'AO exceptionnels (Heavyhaul, ADR convoi)',
    phase_4_unlock_5: '10 dépôts maximum (incl. 2 internationaux) + transition électrique (☀️ solaire, 🔌 borne de recharge)',
    feature_label_fiscal_simulator: 'Simulateur fiscal (IS/IR/dividendes)',
    feature_label_audit_fiscal: 'Audit fiscal anticipé',
    feature_label_hr_dashboard: 'Dashboard RH avancé',
    feature_label_market_intel: 'Intelligence marché — analyse concurrentielle',
    feature_label_salons: 'Action « Salons & événements » sur Dashboard',
    feature_label_grands_comptes: 'Contrats Grands comptes (haute valeur)',
    feature_label_contrats_cadres: 'Contrats-cadres (achats groupés −%)',
    feature_label_crisis_comm: 'Choix « Communication de crise » (atténue rep)',
    feature_label_negociation_taux: 'Négociation taux d\'emprunt (−1 %)',
    feature_label_diag_preventif: 'Diagnostic préventif (−50 % pannes)',
    feature_label_tax_auto_provisioning: 'Provision fiscale automatique',
    sup_notify_milestones_no_email: 'Renseignez l\'adresse email de contact dans Admin → Licences pour activer cette option.',
    sup_notify_milestones_active_tip: 'Recevoir un mail à chaque bascule de phase d\'un apprenant. Cliquer pour désactiver.',
    sup_notify_milestones_off_tip: 'Cliquer pour recevoir un mail à chaque bascule de phase d\'un apprenant.',
    sup_notify_milestones_label: 'Mails milestones {{state}}',
    hr_tab_former: 'Anciens chauffeurs',
    fisc_tab_urssaf: 'URSSAF',
    hr_filter_title: 'Filtres',
    hr_filter_all: 'Tous',
    hr_filter_available: 'Disponible',
    hr_filter_mission: 'En mission',
    hr_filter_training: 'En formation',
    hr_filter_absent: 'Absent (congés, maladie…)',
    hr_filter_license: 'Permis',
    hr_filter_level: 'Niveau',
    hr_filter_level_short: 'Niv.',
    hr_filter_availability: 'Disponibilité',
    hr_filter_salary: 'Coût employeur',
    hr_filter_specialty: 'Spécialité',
    hr_filter_reset: 'Réinitialiser',
    hr_filter_shown: '{{shown}}/{{total}} affichés',
    hr_filter_empty_team: 'Aucun chauffeur ne correspond aux filtres.',
    hr_filter_empty_recruit: 'Aucun candidat ne correspond aux filtres.',
    btn_my_profile_pdf: 'Ma fiche apprenant',
    btn_my_profile_pdf_title: 'Télécharger votre fiche apprenant PDF (même document que celui du formateur)',
    my_profile_pdf_error: 'Impossible de générer la fiche apprenant.',
    my_profile_pdf_not_started: 'Démarrez une partie pour éditer votre fiche apprenant.',
  },

  en: {
    // Common
    save: 'Save',
    load: 'Load',
    delete: 'Delete',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    yes: 'Yes',
    no: 'No',

    // Nav
    nav_dashboard: 'Dashboard',
    nav_fleet: 'Fleet',
    nav_hr: 'HR',
    nav_fonctions_support: 'Support functions',
    nav_depot: 'Depot',
    nav_agenda: 'Agenda',
    nav_finance: 'Finance',
    nav_achievements: 'Achievements',
    nav_challenges: 'Challenges',
    nav_atouts: 'Phases & Perks',
    nav_save: 'Save',
    nav_quit: 'Quit',

    // Dashboard
    day: 'Day',
    month: 'Month',
    year: 'Year',
    treasury: 'Treasury',
    reputation: 'Reputation',
    daily_result: 'Daily Result',
    working_day: 'Working day',
    weekend: 'Weekend',
    next_day: 'Next Day',
    resolve_events: 'Resolve events',
    fast_forward: 'Fast forwarding...',
    available_contracts: 'Available Contracts',
    active_contracts: 'Active Contracts',
    monthly_revenue: 'Monthly Revenue',
    monthly_expenses: 'Monthly Expenses',
    alerts: 'Alerts',
    treasury_evolution: 'Treasury Evolution',
    market_ranking: 'Market Ranking',
    no_contracts: 'No contracts available. Wait for the next batch.',
    accept: 'Accept',
    active: 'Active',
    remaining: 'remaining',
    per_day: '/day',
    special: 'SPECIAL',
    data_after_days: 'Data will appear after a few days',

    // Fleet
    fleet_title: 'Fleet',
    my_vehicles: 'My Vehicles',
    buy_vehicle: 'Buy',
    sell_vehicle: 'Sell',
    repair: 'Repair',
    assign_driver: 'Assign',
    insurance: 'Vehicle Insurance',
    insurance_claims: 'Claims filed',
    file_claim: 'File an insurance claim',
    max_claims: 'Maximum claims reached. Coverage denied.',
    coverage: 'Current coverage',
    total_vehicles: 'Total vehicles',
    on_mission: 'On mission',
    fleet_value: 'Fleet value',
    broken_count: 'Broken down',
    my_fleet: 'My fleet',
    buy_tab: 'Buy',
    leasing_tab: 'Leasing',
    available_status: 'Available',
    active_status: 'On mission',
    maintenance_status: 'In maintenance',
    broken_status: 'Broken down',
    km_traveled: 'Km traveled',
    active_days: 'Active days',
    revenue_generated: 'Revenue generated',
    sell_confirm_title: 'Sell this vehicle?',
    sell_confirm_text: 'You are about to sell the',
    estimated_resale: 'Estimated resale price',
    of_new_price: 'of new price',
    driver_released: 'The assigned driver will be released.',
    assign_a_driver: 'Assign a driver',
    wear: 'Wear',
    wear_critical: 'Critical wear — breakdown risk!',
    hide_stats: 'Hide stats',
    show_stats: 'Show stats',
    no_vehicle: 'No vehicles. Buy your first vehicle!',
    already_owned: 'Already owned',
    insufficient_funds: 'Insufficient funds',
    locked: 'Locked',
    models: 'models',
    license_required: 'License {license} required',
    leasing_title: 'Vehicle Leasing',
    leasing_description: 'Rent a vehicle without paying the full price. Pay 10% deposit at signing and fixed monthly payments. At contract end, the vehicle is returned (or buyable at 25% residual value).',
    chosen_duration: 'Chosen duration',
    current_payments: 'Current payments',
    months_remaining: 'months remaining',
    buyout: 'Buy out',
    sign_lease: 'Sign lease',
    insufficient_deposit: 'Insufficient deposit',
    new_price: 'new',
    deposit: 'Deposit',
    buyout_possible: 'Buyout possible',
    declare_claim: 'File a claim',
    premium: 'Premium',
    claim_number: 'Claim',
    reimbursement: 'Reimbursement',
    franchise: 'Deductible',
    used_vehicle: 'Used',
    purchase_at: 'purchased at',

    // HR
    hr_title: 'Human Resources',
    team: 'My Team',
    recruit: 'Recruit',
    hire: 'Hire',
    fire: 'Fire',
    train: 'Train',
    bonus: 'Bonus',
    rest: 'Rest',
    headcount: 'Headcount',
    in_training: 'In training',
    payroll: 'Payroll',
    team_tab: 'Team',
    recruit_tab: 'Recruit driver(s)',
    training_label: 'Training',
    active_hr_status: 'Active',
    resting_status: 'Resting',
    available_hr_status: 'Available',
    holiday_hr_status: 'On leave',
    sick_hr_status: 'Sick leave',
    striking_hr_status: 'On strike',
    returning_hr_status: 'Returning',
    fatigue: 'Fatigue',
    satisfaction: 'Satisfaction',
    fatigue_high: 'High fatigue',
    satisfaction_low: 'Low satisfaction',
    details: 'Details',
    hide: 'Hide',
    no_driver: 'No drivers. Hire your first driver!',
    recruit_now: 'Recruit now',
    no_candidate: 'No candidates available. Progress to unlock more profiles.',
    locked_profiles_section: 'Locked profiles',
    locked_profiles_hint: 'These profiles exist on the market but are not reachable yet — meet the displayed condition to unlock them.',
    experience: 'Experience',
    accident_risk: 'Accident risk',
    strength: 'Strength',
    weakness: 'Weakness',
    trainings_done: 'Trainings completed',
    remove: 'Remove',
    level: 'Lvl.',
    years_exp: 'yrs exp.',
    available_trainings: 'Available trainings',
    acquired: 'Acquired',
    done: 'Done',
    training_days: 'd',

    // Depot
    depot_title: 'Depot',
    depot_plan: 'Depot Map',
    upgrade: 'Upgrade',
    active_zones: 'Active zones',
    parked_vehicles: 'Parked vehicles',
    vehicles_on_mission: 'On mission',
    depot_charges: 'Depot charges',
    build: 'Build',
    zone_operational: 'Zone operational',
    upgrades_label: 'Upgrades',
    activate: 'Activate',
    not_built: 'Not built',
    level_label: 'Level',
    route_label: 'ROUTE D42 — INDUSTRIAL ZONE',
    entrance: 'ENTRANCE',
    garage_label: 'GARAGE',
    loading_dock: 'LOADING DOCK',
    warehouse_label: 'WAREHOUSE',
    cold_zone: 'COLD ZONE',
    diesel_station: 'DIESEL STATION',
    vehicles_label: 'VEHICLES',
    parked: 'parked',
    on_mission_depot: 'on mission',
    broken_depot: 'broken',
    zones_active_label: 'ACTIVE ZONES',

    // Finance
    finance_title: 'Finance',
    income: 'Income',
    expenses: 'Expenses',
    net_result: 'Net Result',
    loan: 'Loan',
    revenue_per_month: 'Revenue/month',
    charges_per_month: 'Charges/month',
    overview: 'Overview',
    income_statement: 'Income Statement',
    credits_tab: 'Credits',
    treasury_chart: 'Treasury Evolution',
    revenue_vs_expenses: 'Revenue vs Expenses (last 30 days)',
    monthly_summary: 'Monthly Summary',
    products: 'Products',
    revenue_contracts: 'Revenue (contracts)',
    total_products: 'Total products',
    charges: 'Charges',
    total_charges: 'Total charges',
    net_monthly_result: 'Net monthly result',
    margin: 'Margin',
    charges_breakdown: 'Charges breakdown',
    no_active_charge: 'No active charges',
    total_debt: 'Total debt',
    monthly_payments: 'Monthly payments',
    num_credits: 'Num credits',
    active_credits: 'Active credits',
    no_credit: 'No active credits',
    credit_number: 'Credit',
    months_left: 'months remaining',
    capital: 'Capital',
    monthly_payment: 'Monthly payment',
    remaining_due: 'Remaining due',
    rate: 'Rate',
    amortization_table: 'Amortization table (constant)',
    total_interest_cost: 'Total interest cost',
    total_repaid: 'Total repaid',
    month_col: 'Month',
    payment_col: 'Payment',
    capital_col: 'Capital',
    interest_col: 'Interest',
    remaining_col: 'Remaining',
    credit_simulator: 'Credit simulator',
    amount: 'Amount',
    duration: 'Duration',
    estimated_payment: 'Estimated payment (constant amort.)',
    annual_rate: 'Rate: 5.5% annual',
    total_cost: 'Total cost',
    take_loan: 'Take this loan',
    insufficient_data: 'Insufficient data',
    statement_month: 'Income Statement (Month {month}, Year {year})',

    // Challenges
    challenges_title: 'Challenges',
    start_challenge: 'Start this challenge',
    abandon_challenge: 'Abandon this challenge',
    challenge_won: 'Challenge completed!',
    challenge_failed: 'Challenge failed',
    time_remaining: 'remaining',
    completed: 'COMPLETED',
    in_progress: 'IN PROGRESS',
    current_value: 'Current',
    max_value: 'max',
    ok_status: 'OK',
    failed_status: 'FAILED',

    // Difficulty
    easy: 'Easy',
    normal: 'Normal',
    hard: 'Hard',

    // Audio
    sound_effects: 'Sound Effects',
    music: 'Music',
    volume: 'Volume',

    // Create Company
    company_name: 'Company Name',
    choose_name: 'Choose a name for your transport company.',
    logo: 'Company Logo',
    starting_city: 'Starting City',
    difficulty_level: 'Difficulty Level',
    initial_specialty: 'Initial Specialty',
    launch: 'Launch my company',
    resume_game: 'Resume a game',
    characters: 'characters',

    // Settings
    language: 'Language',
    french: 'Français',
    english: 'English',

    // Monthly Report
    monthly_report: 'Monthly Report',
    best_driver: 'Best Driver',
    vehicles_active: 'Active Vehicles',
    contracts_completed: 'Completed Contracts',

    // Misc
    quit_confirm: 'Quit the game? Remember to save first.',
    phase: 'Phase',
    loading: 'Loading...',
    // --- i18n audit additions (2026-02) ---
    create_company_to_unlock: 'Create your company to start unlocking achievements.',
    license_too_short: 'License key too short',
    invalid_key: 'Invalid key',
    waiting_room_title: 'Waiting room',
    waiting_room_opens: 'Your session opens on',
    waiting_room_auto: 'Access will unlock automatically — keep this page open.',
    waiting_room_entering: "It's time! Opening the simulation…",
    waiting_days: 'Days',
    waiting_hours: 'Hours',
    waiting_minutes: 'Minutes',
    waiting_seconds: 'Seconds',
    waiting_change_key: 'Use another key',
    app_subtitle: 'HYPER TRANSPORT COMPANY',
    no_advisor_selected: 'No guide selected',
    presentation_mode_title: 'Presentation mode fullscreen (F11)',
    exit_presentation_title: 'Exit presentation mode (Esc)',
    presentation_label: 'Presentation',
    advisor_label: 'Advisor',
    advisor_active: 'Advisor active',
    active_status_short: 'ACTIVE',
    quit: 'Quit',
    exit_presentation: 'Exit presentation',
    operations_group: 'Operations',
    finance_group: 'Finance',
    strategy_group: 'Strategy',
    dashboard_title: 'Dashboard',
    pilot_console: 'Pilot Console',
    system_operational: 'SYSTEM · OPERATIONAL',
    date_label: 'Date',
    current_balance: 'Current balance',
    daily_delta: 'Daily Δ',
    net_last_day: 'Net last day',
    advance_5days: 'Advance 5 days',
    advance_week: 'Advance one week',
    go_to: 'Go to',
    and_recruit_driver: 'and recruit a driver',
    to_accept_contracts: 'To accept contracts:',
    assign_driver_hint: 'Assign a driver to an available vehicle on the Fleet page.',
    aerial_view_site: 'Aerial View — HST Site',
    click_on_zone: 'Click on a zone',
    repair_all_fleet: 'Repair entire fleet',
    available_treasury: 'Available treasury',
    market_competition_title: 'Market & Competition',
    active_on_your_market: 'active on your market',
    your_revenue: 'Your revenue',
    total_daily_per_driver: 'Total daily per driver',
    no_competitive_event: 'No competitive event at the moment',
    competitor_recent_event: 'Recent events',
    fiscality_title: 'Taxation',
    vat_to_pay: 'To remit',
    vat_credit: 'VAT credit',
    is_estimated: 'Corp. tax (est.)',
    regime_label: 'Regime',
    deadlines: 'Deadlines',
    vat_declaration: 'VAT return',
    next_payment: 'Next deadline',
    cfe_label: 'Business property tax (CFE)',
    cvae_label: 'CVAE — Value-added tax',
    axle_tax: 'Axle tax',
    optimizations: 'Tax optimizations',
    international_tax: 'International taxation',
    status_compliant: 'Compliant',
    status_late: 'Late',
    limited_credit: 'Limited credit',
    granted_amount: 'Granted amount',
    total_interests: 'Total interest',
    apply: 'Apply',
    bank_rating_score: 'Reliability rating',
    bank_proposal: 'Proposal',
    bank_advisor_name: 'Bank advisor',
    holder_name_required: 'Holder name *',
    owner_field_label: 'Owner / Assignment (free text)',
    ip_limit_label: 'IP limit (0 = unlimited)',
    ip_limit_help: 'Maximum number of distinct allowed IPs. 0 = no limit.',
    contact_name: 'Contact name',
    contact_email_required: 'Contact email *',
    duration_months_label: 'Duration (months)',
    notes_internal: 'Internal notes',
    generate_license: 'Generate a license',
    search_placeholder: 'Search by name, email, owner or key...',
    no_license_found: 'No license found',
    expired: 'Expired',
    expires_soon: 'Expires soon',
    copy_key: 'Copy key',
    revoke: 'Revoke',
    extend: 'Extend',
    stats_total: 'Total licenses',
    stats_active: 'Active',
    stats_expired: 'Expired',
    stats_unused: 'Unused',
    hst_subtitle: 'Hyper Transport Company',
    import_logo_or_select: 'Import your logo or pick a preset.',
    logo_imported_ok: 'Logo imported successfully',
    preset_logos: 'Preset logos',
    upload_logo: 'Upload a logo',
    remove_custom_logo: 'Remove imported logo',
    starting_city_hint: 'Your company headquarters will be based in this city.',
    difficulty_hint: 'Tune the challenge to your level.',
    specialty_hint: 'Your business focus from day one.',
    advisor_hint: 'Who will guide you on your journey?',
    advisor_skip: 'Continue without a guide',
    unlocked: 'Unlocked:',
    vehicle_compat: 'Vehicle compatibility',
    no_vehicle_fleet: 'No vehicle in fleet',
    training_impact: 'Training impact',
    team_total_xp: 'Team total XP',
    driver_of_month: 'Driver of the month',
    team_overview: 'Team overview',
    spec_compatible: 'Compatible specialties',
    monthly_revenue_label: 'Monthly revenue',
    monthly_expenses_label: 'Monthly expenses',
    net_result_label: 'Net result',
    active_vehicles_label: 'Active vehicles',
    reputation_label: 'Reputation',
    driver_of_month_label: 'Driver of the month',
    monthly_report_close: 'Continue',
    estimated_cost: 'Estimated cost',
    impact_duration: 'Impact duration',
    market_ranking_title: 'Market ranking',
    your_position: 'Your position',
    new_unlocks: 'New unlocks',
    lets_go: 'Let\'s go!',
    selected_city: 'Selected city',
    saved: 'Saved!',
    choose_guide: 'Choose your guide',
    capacity_under_used: 'Underused capacity',
    choose_vehicle_driver: 'Choose a vehicle and its driver',
    no_vehicle_available: 'No vehicle available',
    all_vehicles_busy: 'All your vehicles are on mission or have no driver assigned.',
    license_activation: 'License activation',
    enter_key_hint: 'Enter your key to access the game',
    license_key: 'License key',
    verifying: 'Verifying...',
    activate_license: 'Activate license',
    contact_admin_no_key: 'Contact your administrator if you do not have a license key.',

    // ---- LicenseGate (Tier A i18n migration 29/05/2026) ----
    master_login_not_master_key: 'This key is not a Pedagogical Supervisor license.',
    master_login_disabled_or_expired: 'This license has been disabled or has expired.',
    master_login_invalid_key: 'Invalid Pedagogical Supervisor key.',
    master_space_title: 'Pedagogical Supervisor Area',
    master_space_subtitle: 'Cohort supervision',
    mode_apprentice: 'Learner',
    mode_master: 'Supervisor',
    master_key_label: 'Pedagogical Supervisor key',
    access_supervision: 'Open supervision',
    master_supervision_only_note: 'The supervisor license only grants supervision — you cannot play with it.',
    demo_cta_banner: 'Watch the 2-min demo — no license needed',

    // ---- Demo + DemoContactForm (Tier A) ----
    demo_subtitle: 'Express demo · 2 min',
    demo_stat_treasury: 'Cash',
    demo_stat_vehicles: 'Vehicles',
    demo_stat_drivers: 'Drivers',
    demo_stat_contracts: 'Contracts',
    demo_stat_reputation: 'Reputation',
    demo_stat_achievements: 'Badges',
    demo_contact_intro: 'Want to bring HST to your cohort? Drop us your email — we reply within one business day.',
    demo_step_label: 'Step',
    demo_already_have_license: 'I already have a license',
    demo_control_pause: 'Pause',
    demo_control_resume: 'Resume',
    demo_control_skip: 'Next',
    demo_control_restart: 'Restart',

    // ---- Achievements (Tier B) ----
    achievements_unlocked_pct: 'unlocked',

    // ---- HR (Tier B) ----
    hr_tab_departure: 'Departure',
    hr_dislikes_unlock_note: 'inside Support Functions to reveal what each driver',
    hr_dislikes_unlock_word: 'dislikes',
    hr_insights_hint_prefix: 'Hire',
    hr_insights_hint_role: 'Nadia Cheikh — HR Manager',
    hr_insights_hint_mid: 'in Support Functions to reveal what each driver',
    hr_insights_hint_likes: 'likes',
    hr_insights_hint_or: 'or',
    hr_insights_hint_dislikes: 'dislikes',
    hr_insights_hint_suffix: 'during missions, and watch their live mood.',

    // ---- DAFCommentary (Tier C) ----
    daf_avis_title: 'CFO strategic opinion',
    daf_refresh: 'Refresh',
    daf_loading_caption: 'The CFO is reviewing the file…',
    daf_retry: 'Retry',
    daf_default_error: 'Could not generate the report.',
    daf_default_no_weakness: 'No weakness identified',

    // ---- CreateCompany (Tier A) ----
    cc_legal_status_step: 'Legal form',
    cc_company_tagline: 'Hyper Transport Company',
    cc_city_rent: 'HQ rent ≈ {{rent}} €/month',
    cc_city_rent_free: 'free for the first {{days}} days',
    driver_lumery_duo_badge: 'Sibling bonus: −10% fatigue (brothers at the same depot)',
    cc_city_zone_bonus: 'Local zone — −10 % fuel bonus within 200 km',
    cc_diff_revenues: 'Revenue',
    cc_diff_charges: 'Costs',
    cc_diff_capital: 'Capital',
    cc_name_placeholder: 'e.g. Durand Transport',
    cc_save_day_label: 'Day',
    cc_save_phase_label: 'Phase',
    cc_save_vehicles_short: 'veh.',
    cc_save_drivers_short: 'drv.',
    spec_messagerie_name: 'Parcels',
    spec_messagerie_desc: 'Packages, express, e-commerce. Steady revenue, light vehicles.',
    spec_messagerie_revenue: '€1,500 - €3,000 /mo',
    spec_vrac_name: 'Bulk / Pallets',
    spec_vrac_desc: 'Pallets, materials, retail distribution. High volumes.',
    spec_vrac_revenue: '€2,000 - €4,000 /mo',
    spec_frigo_name: 'Refrigerated',
    spec_frigo_desc: 'Food, pharma, cold chain. High margins.',
    spec_frigo_revenue: '€2,500 - €5,000 /mo',

    // ---- HQOfficePanel (Tier C) ----
    hq_locked_title: 'Headquarters — Locked',
    hq_deadline_title: 'Headquarters required — {{days}} day(s) left',
    hq_deadline_body: 'Your 3 support functions need proper working conditions. Invest in the "Headquarters / Dedicated office" (below, Administrative family) before the deadline, or your latest hire will resign.',
    hq_resigned_title: 'A support function resigned — headquarters missing',
    hq_resigned_body: 'You cannot hire a 3rd support function until the "Headquarters / Dedicated office" investment is made.',
    hq_hire_blocked_toast: 'Hiring blocked: invest in the "Headquarters / Dedicated office" first before re-hiring a 3rd support function.',
    hq_unlocked_title: 'Headquarters — Office space',
    hq_locked_body: 'Your support staff is crammed into the depot shack. Once {threshold} support functions are hired, you have 45 days to invest in the "Headquarters / Dedicated office" (Support functions tab) — otherwise your latest support hire will resign.',
    hq_locked_more_to_hire: '{count} more to hire',
    hq_locked_unlock_imminent: 'Unlock imminent',
    hq_unlocked_body: 'Gradual fit-out via the proposals you receive in the Inbox. Each upgrade boosts the satisfaction of the whole team (drivers + support).',
    hq_upgrades_installed: 'upgrades installed',
    hq_equipment_section: 'Equipment',
    hq_upgrade_pending_mail: 'Will arrive by email',
    hq_kpi_support: 'Support headcount',
    hq_kpi_monthly: 'Monthly cost',
    hq_kpi_satisfaction: 'Satisfaction bonus',

    // ---- HireNegotiationModal (Tier C) ----
    hn_subtitle: 'Salary negotiation',
    hn_band_refus_label: 'Likely refusal',
    hn_band_refus_detail: 'The candidate will walk away and stay unavailable for 45 to 90 days.',
    hn_band_rancune_label: 'Reluctant acceptance',
    hn_band_rancune_detail: 'The candidate will accept but start with −10 satisfaction (resentful).',
    hn_band_ok_label: 'Fair offer',
    hn_band_ok_detail: 'The candidate accepts at fair market rate, normal satisfaction.',
    hn_band_genereuse_label: 'Generous offer',
    hn_band_genereuse_detail: 'The candidate is delighted, +10 satisfaction at start.',
    hn_offer_rejected: 'Offer rejected',
    hn_offer_accepted: 'Offer accepted',
    hn_close: 'Close',
    hn_profile: 'Profile',
    hn_expected: 'Asking',
    hn_your_offer: 'Your offer',
    hn_per_month_gross: '/mo gross',
    hn_target: 'Target',
    hn_contract_type: 'Contract type',
    hn_propose_at: 'Make an offer of',
    hn_per_month: '/mo',
    hn_expected_at_least: 'expected at least',
    hn_and_refused: 'and rejected your offer of',
    hn_unavailable_until: 'Unavailable until day',
    hn_joins_team_for: 'joins the team for',
    hn_gross_per_month: 'gross/month',
    hn_resentment: 'resentful',
    hn_cdi_full_time: 'Full-time employee, employer contributions included in the displayed cost.',
    hn_no_freelance_note: 'Self-employed (subcontracting) status not available: you are the manager, you hire salaried drivers — you cannot drive yourself.',

    // ---- Fiscalite (Tier B) ----
    fisc_title: 'Taxation',
    fisc_kpi_tva_net: 'Net VAT',
    fisc_kpi_tva_to_pay: 'To pay',
    fisc_kpi_tva_credit: 'VAT credit',
    fisc_kpi_is_estimated: 'Corporate tax (annual est.)',
    fisc_kpi_is_annual_basis: 'On annualised profit',
    fisc_kpi_is_paid: 'Paid',
    fisc_kpi_is_damped_hint: 'Smoothed estimate (< 3 months sample)',
    fisc_kpi_is_damped_tooltip: 'Smoothed extrapolation: months 1-2 use a × 4 floor (instead of × 12 / × 6) to avoid unstable projections on a too-short sample.',
    ao_aggression_title: 'Competition on high alert',
    ao_aggression_days_left: 'days left',
    ao_aggression_body: 'After the latest Actu Transport article, your competitors are more aggressive: counter-offer probability boosted and client discount +4 pts (12% instead of 8%). Defend your margins.',
    fisc_kpi_regime: 'Regime',
    fisc_kpi_tva_monthly: 'Monthly VAT',
    fisc_kpi_tva_quarterly: 'Quarterly VAT',
    fisc_kpi_deadlines: 'Deadlines',
    fisc_kpi_pending_count: 'pending',
    fisc_kpi_none: 'None',
    fisc_month: 'Month',
    fisc_year: 'Year',
    fisc_tab_overview: 'Overview',
    fisc_tab_tva: 'VAT',
    fisc_tab_is: 'Corporate tax',
    fisc_tab_local: 'Local taxes',
    fisc_tab_regime: 'Regime & Optimisation',
    fisc_tab_statut: 'Legal form',
    fisc_tab_intl: 'International',

    // ---- FonctionsSupport (Tier B) ----
    fs_title: 'Support functions',
    fs_intro: 'Hire strategic profiles (other than drivers) to unlock bonuses, cut costs and accelerate growth.',
    fs_hired: 'Hired',
    fs_salary: 'Salary',
    fs_unlocks_prefix: 'Unlocks',
    fs_fire: 'Dismiss',
    fs_recruit: 'Hire',
    fs_locked: 'Locked',
    fs_treasury_short: 'Cash too low for one month of salary',
    fs_tool: 'Tool',
    fs_cost: 'Cost',
    fs_deactivate: 'Deactivate',
    fs_activate: 'Activate',
    fs_kpi_hired_count: 'Support headcount',
    fs_kpi_payroll: 'Payroll',
    fs_kpi_revenue_bonus: 'Cumulative revenue bonus',
    fs_kpi_families_coverage: 'Families covered',
    fs_entry_singular: 'entry',
    fs_entry_plural: 'entries',

    // ---- CompetitionAnalysis (Tier B) ----
    ca_family_marketing: 'Marketing',
    ca_family_commerce: 'Sales',
    ca_family_admin: 'Admin / Operations',
    ca_family_finance: 'Accounting / Finance',
    ca_locked_title: 'Competitive analysis unit',
    ca_locked_body: 'To unlock deep competitor analysis and M&A operations, you must first hire at least one member of each of the 4 following functions:',
    ca_locked_tip: 'Learner tip: these 4 support functions are the foundation of a leadership team capable of running an M&A project. Hire them from the Support tab.',
    ca_unlocked_title: 'Competitive analysis',
    ca_unlocked_subtitle: 'Synthesis produced by your Marketing + Sales + Operations + CFO cell.',
    ca_owned_depots: 'Owned depots',
    ca_kpi_ca: 'Revenue / mo',
    ca_kpi_fleet: 'Fleet',
    ca_kpi_drivers: 'Drivers',
    ca_kpi_reputation: 'Reputation',
    ca_stat_equity: 'Equity',
    ca_stat_margin: 'Net margin',
    ca_stat_debt: 'Net debt',
    ca_health_label: 'Overall health score',
    ca_weakness_label: 'Exploitable weakness',
    ca_daf_price_label: 'CFO suggested price',
    ca_already_acquired: 'Acquired · this depot is now yours',
    ca_start_acquisition: 'Initiate an acquisition',
    ca_reco_default_label: 'Fair target',
    ca_locked_already: 'Competitor already acquired',
    ca_locked_pending: 'An M&A operation is already in progress',
    ca_locked_cooldown_prefix: 'LOI previously refused — retry in',
    ca_locked_cooldown_suffix: 'd',
    ca_locked_quota: 'Depot quota reached (3/3)',

    // ---- PhaseNotification (Tier C) ----
    phase_2_title: 'Regional Phase',
    phase_2_subtitle: 'Your company is expanding!',
    phase_2_desc: 'You unlocked access to regional areas. New routes, new contracts and bigger vehicles await.',
    phase_2_u1: 'Regional contracts (bulk, pallets, construction)',
    phase_2_u2: 'Tier 2 vehicles — 7T-12T rigid trucks',
    phase_2_u3: 'Senior drivers (C-class licence)',
    phase_2_u4: 'New zones: Grand Est, Normandy, Brittany',
    phase_3_title: 'National Phase',
    phase_3_subtitle: 'Your network covers France!',
    phase_3_desc: 'National highways are within reach. Semi-trailers, long-haul and lucrative contracts become accessible.',
    phase_3_u1: 'National long-haul contracts',
    phase_3_u2: 'Tier 3 semi-trailers — VOLVAX, SCANEX, DAFORA',
    phase_3_u3: 'Experienced drivers (CE-class licence)',
    phase_3_u4: 'Paris-Lyon-Marseille-Bordeaux-Lille corridors',
    phase_4_title: 'European Phase',
    phase_4_subtitle: 'Europe is yours!',
    phase_4_desc: 'EU export is now accessible. Prestige international contracts, specialty vehicles and exceptional margins.',
    phase_4_u1: 'EU Export contracts — Spain, Germany, Italy, Benelux',
    phase_4_u2: 'Tier 4-5 vehicles — Specialty and prestige',
    phase_4_u3: 'Senior drivers and multilingual experts',
    phase_4_u4: 'SCANEX R 650 V8 Prestige and VOLVAX Electric',
    phase_new_phase_label: 'New phase',

    // ---- Demo scene script ----
    demo_scene_intro_narrator: 'Welcome to HST. In 2 minutes, you will run a real transport company.',
    demo_scene_intro_cta: 'Start',
    demo_scene_hire_narrator: 'First reflex: hire a driver. Sophie Martin has 5 years of experience — she will handle priority contracts.',
    demo_scene_hire_experience: '5 years of experience',
    demo_scene_hire_specialty: 'Refrigerated',
    demo_scene_hire_cta: 'Hire Sophie (€2,400 / month)',
    demo_scene_contract_narrator: 'Carrefour is looking for a carrier. 28 days, €850 net per day. You sense a great deal.',
    demo_scene_contract_kind: 'Fresh',
    demo_scene_contract_cta: 'Accept contract',
    demo_scene_ff_narrator: 'Three days go by. Sophie drives, Carrefour pays, your cash flow gets a breather.',
    demo_scene_ff_cta: 'Fast-forward ×3 days',
    demo_scene_event_narrator: 'Surprise — engine breakdown on your Mercedes Actros. Quick decision: pay €1,200 or wait for insurance?',
    demo_scene_event_title: 'Actros engine breakdown',
    demo_scene_event_impact: '-1 mission day',
    demo_scene_event_cta: 'Repair immediately (€1,200)',
    demo_scene_capex_narrator: 'Tristan Midal — your CFO — calculates: buying this Renault Master saves you €6,200 in corporate tax over 5 years.',
    demo_scene_capex_vehicle: 'Renault Master Refrigerated',
    demo_scene_capex_cta: 'Invest (€45,000)',
    demo_scene_support_narrator: 'Nadia Cheikh, HR Manager, offers her services. She unlocks the advanced HR Dashboard.',
    demo_scene_support_role: 'HR Manager',
    demo_scene_support_u1: 'Advanced HR Dashboard',
    demo_scene_support_u2: 'At-risk driver detection',
    demo_scene_support_u3: 'Team coaching',
    demo_scene_support_cta: 'Hire Nadia',
    demo_scene_ach_narrator: 'Your first decisions pay off — a badge unlocks. The career system tracks you throughout the entire game.',
    demo_scene_ach_title: 'First steps as a manager',
    demo_scene_ach_description: '5 strategic decisions in less than 5 days',
    demo_scene_ach_cta: 'View my career profile',
    demo_scene_recap_narrator: 'You just saw 8 core mechanics. HST offers 40+ — taxation, M&A, banking, random events, pedagogical supervision…',
    demo_scene_recap_f1: 'HR (drivers + support)',
    demo_scene_recap_f2: 'Client contracts & negotiation',
    demo_scene_recap_f3: 'Cash flow & annual accounts',
    demo_scene_recap_f4: 'Random events (breakdowns, strikes, audits)',
    demo_scene_recap_f5: 'CAPEX investment & depreciation',
    demo_scene_recap_f6: 'SME taxation (VAT, CIT, CFE)',
    demo_scene_recap_f7: 'Banking & credit + scoring',
    demo_scene_recap_f8: 'M&A and multi-depot expansion',
    demo_scene_contact_narrator: 'Want to bring HST to your cohort? Drop us your email — we reply within one business day.',

    // ---- Demo scene visual labels ----
    demo_scene_header_recruitment: 'Driver recruitment',
    demo_scene_header_contract: 'Contract proposal',
    demo_scene_header_time: 'Time progress',
    demo_scene_header_event: 'Unexpected event',
    demo_scene_header_capex: 'CAPEX investment — CFO advice',
    demo_scene_header_support: 'Support hire',
    demo_scene_header_recap: 'What you saw',
    demo_scene_hire_signing: 'Open-ended contract',
    demo_scene_hire_monthly_salary: 'Monthly salary',
    demo_scene_hire_recruit: 'Hire',
    demo_scene_contract_client: 'Client',
    demo_scene_contract_daily_rate: 'Daily rate',
    demo_scene_contract_total_ht: 'Total net revenue',
    demo_scene_capex_price: 'Purchase price',
    demo_scene_capex_annual_is_saved: 'Annual CIT saved',
    demo_scene_capex_total_is_saved: 'Total CIT saved',
    demo_scene_capex_net_cost: 'Net cost after CIT',
    demo_scene_event_cost: 'Repair cost',
    demo_scene_support_monthly_cost: 'Monthly cost',
    demo_scene_ach_unlocked: 'Achievement unlocked',
    demo_scene_recap_intro: 'You have seen',
    demo_scene_recap_outro: 'And 40+ advanced mechanics await your cohort.',
    demo_subtitle_hero: 'Professional pedagogical simulator — managing a road transport company.',
    demo_ff_subtitle: 'Sophie drives · net revenue',
    demo_ff_per_day: '€ / day',
    load_save: 'Load',
    step: 'Step',
    step_name: 'Name',
    step_logo: 'Logo',
    step_city: 'City',
    step_difficulty: 'Difficulty',
    step_specialty: 'Specialty',
    step_guide: 'Guide',
    company_name_question: 'Company name',
    name_hint: 'Choose a name for your transport company.',
    company_logo: 'Company logo',
    launch_game: 'Launch the game',
    min_3: '(min. 3)',
    difficulty_choice: 'Difficulty',
    pick_difficulty: 'Tune the challenge to your level.',
    pick_specialty: 'Your business focus from day one.',
    pick_guide: 'Who will guide you on your journey?',
    pick_city: 'Your headquarters will be based in this city.',
    pick_logo: 'Import your logo or pick a preset.',
    continue_without_guide: 'Continue without a guide',
    saved_at: 'Save from',
    delete_save: 'Delete save',
    upload_your_logo: 'Upload your logo',
    upload_format_hint: 'PNG, JPG, SVG — max 500 KB',
    or_pick_template: 'or pick a preset',
    image_too_heavy: 'Image too heavy (max 500 KB)',
    city_pick_hint: 'Select a city or click directly on the map.',
    logo_classic: 'Classic',
    logo_plus: 'Plus',
    logo_triangle: 'Triangle',
    logo_circle: 'Circle',
    logo_bar: 'Bar',
    logo_x: 'X',
    logo_truck: 'Truck',
    logo_wheel: 'Wheel',
    logo_package: 'Package',
    logo_pallet: 'Pallet',
    logo_container: 'Container',
    logo_compass: 'Compass',
    logo_road: 'Road',
    logo_network: 'Network',
    advisor_intro: 'A professor will guide you throughout your journey. You can change them in the settings.',
    guide_selected: 'Guide selected',
    advisor_disable_hint: 'You can disable the advisor anytime in the settings',
    years_old: 'years old',
    bank_title: 'Bank',
    active_loans: 'active loan(s)',
    per_month: 'per month',
    placements_label: 'Placements',
    placement_count: 'placement(s)',
    loyalty: 'Loyalty',
    new_client: 'New client',
    loans_repaid: 'loan(s) repaid',
    advisors_tab: 'Advisors',
    request_loan_tab: 'Request a loan',
    my_loans_tab: 'My loans',
    bank_selected: 'Selected bank',
    placement_available: 'Placement available',
    total_borrowed: 'Total borrowed',
    loans_active_count: 'Active loans',
    first_time_setup: 'First-time setup',
    sme_transport_tag: 'SME transport',
    products_available: 'products available',
    invest: 'Invest',
    market_title: 'Market & Competition',
    ranking: 'Ranking',
    on_5_companies: 'of 5 companies',
    competitors_label: 'Competitors',
    active_on_market: 'active on your market',
    export_contracts: 'Export contracts',
    daily_relocation_fee: 'relocation fees',
    your_revenue_kpi: 'Your revenue',
    reputation_short: 'Reputation',
    regional_ranking_tab: 'Regional ranking',
    export_costs_tab: 'Export costs',
    events_tab: 'Events',
    regional_ranking_subtitle: 'Regional ranking — monthly revenue',
    vehicles_short: 'veh.',
    drivers_short: 'drivers',
    rep_short: 'rep.',
    your_company: 'Your company',
    you: 'you',
    per_month_short: '/m',
    no_event_active: 'No competitive event at the moment',
    available_contracts_title: 'Available contracts',
    contracts_col_name: 'Name',
    contracts_col_client: 'Client',
    contracts_col_category: 'Category',
    contracts_col_freq: 'Type',
    contracts_col_tier: 'Tier',
    contracts_col_price: 'Price',
    contracts_col_duration: 'Duration',
    contracts_col_margin: 'Margin',
    contracts_col_actions: 'Actions',
    go_to_hr_step: 'Go to **HR** and recruit a driver',
    assign_driver_step: 'Go to **Fleet** and assign them to a vehicle',
    come_back_step: 'Come back here to accept a contract',
    nav_fiscality: 'Taxation',
    nav_strategy: 'Strategy',
    nav_messagerie: 'Messages',
    nav_bank: 'Bank',
    nav_capitaux: 'Equity',
    nav_market: 'Market',
    nav_appels_offres: 'Tenders',
    nav_clients: 'Clients',
    nav_competition: 'Competition',
    freq_ponctuel: 'one-shot',
    freq_regulier: 'regular',
    cat_messagerie: 'Courier / Parcels',
    cat_vrac: 'Bulk / Pallets',
    cat_frigo: 'Refrigerated',
    cat_express: 'Express',
    cat_btp: 'Construction / Site',
    cat_premium: 'Premium / VIP',
    cat_dangerous: 'Hazardous materials',
    cat_lourd: 'Heavy / Special transport',
    cat_international: 'International',

    // Contract cancellation
    cancel_contract: 'Cancel',
    cancel_contract_title: 'Cancel this contract?',
    cancel_contract_warning: 'Cancellation triggers a 25% penalty on the remaining revenue, releases the vehicle and drops your reputation by 5 points.',
    cancel_contract_remaining_revenue: 'Remaining revenue',
    cancel_contract_penalty: 'Penalty (25%)',
    cancel_contract_rep_loss: 'Reputation impact',
    cancel_contract_confirm: 'Confirm cancellation',
    keep_contract: 'Keep contract',
    contract_cancelled_toast: 'Contract cancelled. Penalty applied.',

    // Early loan repayment
    early_repay: 'Pay off loan',
    early_repay_title: 'Pay off this loan?',
    early_repay_intro: 'You will repay the entire outstanding principal now. A 3% indemnity (capped at 6 months of contractual interest) applies in accordance with French consumer law.',
    early_repay_remaining: 'Outstanding principal',
    early_repay_indemnity: 'Indemnity (3%)',
    early_repay_total: 'Total due',
    early_repay_confirm: 'Confirm repayment',
    early_repay_insufficient: 'Insufficient treasury to pay off this loan.',
    loan_repaid_toast: 'Loan paid off. Well done!',

    // Lease buyout (new formula)
    buyout_lease_title: 'Buy out this lease?',
    buyout_lease_intro: 'You buy this vehicle out early. The balance covers remaining monthly payments + residual value + a 5% contractual penalty.',
    buyout_lease_monthly_left: 'Remaining monthlies',
    buyout_lease_residual: 'Residual value',
    buyout_lease_penalty: 'Penalty (5%)',
    buyout_lease_total: 'Total balance',
    buyout_lease_confirm: 'Settle and keep the vehicle',
    buyout_lease_insufficient: 'Insufficient treasury to buy out this lease.',
    months_remaining: 'months left',
    months: 'months',

    // Contract assignment (free choice)
    select_vehicle: 'Choose a vehicle',
    select_driver: 'Choose a driver',
    no_vehicle_meets_criteria: 'No vehicle matches this contract\'s criteria.',
    no_driver_available_label: 'No driver available.',
    requires_tier: 'Tier {{tier}} minimum',
    requires_license: 'License {{license}} required',
    requires_specialty: '{{specialty}} specialty required',
    requires_vehicle_model: '{{model}} model required',
    incompatible_short: 'Incompatible',
    compatible_short: 'Compatible',
    on_mission_short: 'On mission',
    in_training_short: 'In training',
    specialty_match_bonus: '+15% specialty bonus',
    perfect_match: 'Ideal combo',

    // Driver training restriction
    cannot_train_on_mission: 'Cannot start: this driver is on a mission. Free them up to begin training.',
    cannot_fire_on_mission: 'Cannot fire: this driver is on a mission. Cancel the contract first.',
    days_remaining_short: 'days left',

    // Lease confirmation + early break
    confirm_lease_title: 'Confirm lease',
    confirm_lease_intro: 'You will commit the company for the full lease term. A deposit is taken immediately.',
    confirm_lease_deposit: 'Deposit (10%)',
    confirm_lease_monthly: 'Monthly payment',
    confirm_lease_duration: 'Duration',
    confirm_lease_residual: 'Residual value',
    confirm_lease_total_engagement: 'Total commitment',
    confirm_lease_confirm: 'Sign lease',
    break_lease: 'Break lease',
    break_lease_title: 'Break this lease?',
    break_lease_intro: 'You return the vehicle to the lessor before term. A break fee applies: 30% of remaining monthlies + €1,000 admin fee. The vehicle leaves your fleet for good.',
    break_lease_penalty_label: 'Penalty (30% × remaining monthlies)',
    break_lease_admin_fee: 'Admin / reconditioning fee',
    break_lease_total: 'Total due',
    break_lease_confirm: 'Confirm break',
    break_lease_insufficient: 'Insufficient treasury to break this lease.',

    // i18n migration — FonctionsSupport
    support_functions_title: 'Support Functions',
    support_functions_intro: 'Hire strategic profiles (other than drivers) to unlock bonuses, cut costs, and accelerate growth.',
    support_hired_count_label: 'Support staff',
    support_payroll_label: 'Payroll',
    support_revenue_bonus_label: 'Cumulative revenue bonus',
    support_families_label: 'Families covered',
    support_hired_badge: 'Hired',
    support_salary_label: 'Salary',
    support_age_suffix: 'y',
    support_unlocks_label: 'Unlocks',
    support_fire_btn: 'Dismiss',
    support_hire_btn: 'Hire',
    support_locked_btn: 'Locked',
    support_low_treasury_full: 'Insufficient treasury for one month of salary',
    support_low_treasury_short: 'Insufficient treasury',
    support_tool_label: 'Tool',
    support_cost_label: 'Cost',
    support_deactivate_btn: 'Deactivate',
    support_activate_btn: 'Activate',
    support_entries_singular: 'entry',
    support_entries_plural: 'entries',

    // i18n migration — CompetitionAnalysis
    comp_family_marketing: 'Marketing',
    comp_family_commerce: 'Sales',
    comp_family_admin: 'Administration / Operations',
    comp_family_finance: 'Accounting / Finance',
    comp_locked_title: 'Competitor Intelligence Cell',
    comp_locked_intro: 'To unlock deep competitor analysis and consider M&A operations, you must first hire at least one member in each of the 4 functions below:',
    comp_locked_tip: 'Learner tip: these 4 support functions form the backbone of a leadership team capable of running an M&A project. Hire them from the Support tab.',
    comp_analysis_title: 'Competitor Analysis',
    comp_analysis_subtitle: 'Synthesis provided by your Marketing + Sales + Operations + CFO cell.',
    comp_owned_depots: 'Depots owned',
    comp_reco_fair: 'Fair target',
    comp_already_acquired_reason: 'Competitor already acquired',
    comp_ma_in_progress: 'An M&A operation is already in progress',
    comp_loi_cooldown: 'LOI previously refused — retry in {{days}}d',
    comp_depot_quota_reached: 'Depot quota reached (3/3)',
    comp_kpi_ca: 'Revenue / month',
    comp_kpi_fleet: 'Fleet',
    comp_kpi_drivers: 'Drivers',
    comp_kpi_reputation: 'Reputation',
    comp_stat_equity: 'Shareholder equity',
    comp_stat_net_margin: 'Net margin',
    comp_stat_net_debt: 'Net debt',
    comp_health_score: 'Overall health score',
    comp_exploitable_weakness: 'Exploitable weakness',
    comp_asking_price_label: 'Price suggested by CFO',
    comp_already_acquired_badge: 'Acquired · this depot is now yours',
    comp_initiate_acquisition: 'Initiate acquisition operation',

    // i18n migration — EventPopup
    event_days_singular: 'day',
    event_days_plural: 'days',
    event_reputation_label: 'Reputation',
    event_pts_suffix: 'pts',
    event_treasury_after: 'Treasury after',
    event_estimated_agios: 'Estimated overdraft fees',
    event_per_day_suffix: '/day',
    event_contact_bank_tip: 'You may need to contact your bank to consider a loan.',
    event_crisis_comm_label: 'Crisis communication (Aïcha)',
    event_crisis_comm_desc: 'Phone call to journalists, controlled narrative. The maximum reputation loss is **halved**, and notoriety gains **+2 points**.',
    event_postpone_title: 'Later — let me review my fleet',
    event_postpone_desc: 'Put this offer on hold. A reminder will remain visible to come back to it when you\'re ready.',

    // i18n migration — FiscalAuditModal
    fiscal_audit_admin_control: 'Administrative control',
    fiscal_audit_items_examined: 'Items examined',
    fiscal_audit_urssaf_item_1: 'Driver social contributions',
    fiscal_audit_urssaf_item_2: 'Employment contracts & duty time',
    fiscal_audit_urssaf_item_3: 'Pay policy & seniority',
    fiscal_audit_customs_item_1: 'Cross-border customs documents',
    fiscal_audit_customs_item_2: 'ADR / Refrigerated compliance',
    fiscal_audit_customs_item_3: 'Certifications & traceability',
    fiscal_audit_compliance_tip: 'Your investments in **Premium insurance**, **quality certifications** and **support functions** improve your compliance score.',
    fiscal_audit_cooperate_btn: 'Cooperate with the audit',
    fiscal_audit_result_label: 'Audit result',
    fiscal_audit_outcome_clean: 'Compliant',
    fiscal_audit_outcome_minor: 'Minor reassessment',
    fiscal_audit_outcome_major: 'Major reassessment',
    fiscal_audit_compliance_score: 'Compliance score',
    fiscal_audit_no_redress: 'No reassessment',
    fiscal_audit_clean_body: 'Your file is compliant. **+2 reputation** with the administration.',
    fiscal_audit_financial_penalty: 'Financial penalty',
    fiscal_audit_redress_label: 'Reassessment',
    fiscal_audit_reputation_label: 'Reputation',
    fiscal_audit_strengthen_tip: 'Consider strengthening certifications & insurance to reduce risk.',

    // i18n migration — DepotTabs
    depot_tabs_brand_hst: 'HST HQ',
    depot_tabs_brand_transnord: 'TransNord',
    depot_tabs_brand_logistar: 'LogiStar',
    depot_tabs_brand_ecoroute: 'EcoRoute',
    depot_tabs_brand_independent: 'Independent',
    depot_tabs_quota_reached: 'Quota reached (3/3)',
    depot_tabs_open_btn: 'Open a depot',
    depot_tabs_default_name: 'Depot',
    depot_tabs_modal_title: 'Open a new depot',
    depot_tabs_open_cost_label: 'Opening cost',
    depot_tabs_open_cost_suffix: '(land acquisition + base equipment).',
    depot_tabs_name_label: 'Depot name',
    depot_tabs_treasury_label: 'Treasury',
    depot_tabs_after_open_label: 'after opening',
    depot_tabs_open_short: 'Open',
    depot_tabs_err_insufficient: 'Insufficient treasury: you\'re short by {{amount}} €.',
    depot_tabs_err_max: 'You\'ve already reached the 3-depot cap.',
    depot_tabs_err_generic: 'Opening impossible.',
    depot_tabs_err_no_city: 'Choose a city for your new depot.',
    depot_tabs_err_city_taken: 'You already operate a depot in this city.',
    depot_tabs_err_max_intl: 'Limit reached: 2 international locations maximum.',
    depot_tabs_err_phase: 'City unlocked from phase {{phase}}.',
    depot_tabs_city_label: 'Depot city',
    depot_tabs_rent_label: 'Rent',
    depot_tabs_subsidy_label: 'regional subsidy',
    depot_tabs_aid_note: 'Settlement aid: rent −50% for 6 months + regional subsidy of 30% of the opening cost.',
    depot_map_title: 'Logistics network — locations map',
    depot_map_legend_hq: 'HQ',
    depot_map_legend_opened: 'Opened',
    depot_map_legend_acquired: 'Acquired',
    depot_map_legend_target: 'M&A target',
    depot_map_kind_hq: 'Headquarters',
    depot_map_kind_opened: 'Opened depot',
    depot_map_kind_acquired: 'Acquired depot',
    depot_map_stat_radius: 'Action radius',
    depot_map_stat_rent: 'Rent',
    depot_map_stat_vehicles: 'Trucks',
    depot_map_stat_contracts: 'Contracts served',
    depot_map_rent_free: 'Exempt',
    depot_map_upgrades_title: 'Possible upgrades',
    depot_map_manage_cta: 'Manage this depot',
    depot_map_legend_prospect: 'Free city',
    depot_map_prospect_kind: 'Prospecting',
    depot_map_prospect_title: 'Possible location',
    depot_map_prospect_radius: 'Action radius',
    depot_map_prospect_rent: 'Estimated rent',
    depot_map_prospect_inrange: 'Contracts in range',
    depot_map_prospect_unlocked: 'Contracts unlocked',
    depot_map_prospect_cost: 'Opening cost (net of aid)',
    depot_map_prospect_open_btn: 'Open a depot here',
    depot_map_prospect_locked: 'City unlocks at phase {{phase}}.',
    depot_map_prospect_quota_fr: 'Quota of created depots in France reached (3).',
    depot_map_prospect_quota_intl: 'International locations quota reached (2).',
    depot_map_prospect_hint: '◇ Hover a free city to preview its 250 km radius, click to prospect.',
    depot_upg_phase_req: 'Phase {{phase}} required',
    depot_upg_detail_benefit: 'Benefit',
    depot_upg_detail_condition: 'Requirement',
    depot_upg_detail_none: 'None — available now',
    depot_upg_detail_rent_note: 'Bigger site: rent +5% of the city base.',
    depot_upg_radius_name: 'Logistics extension (+100 km)',
    depot_upg_radius_desc: 'Relay platform and carrier agreements: action radius extended to 350 km.',
    depot_upg_quai_name: 'Loading dock',
    depot_upg_quai_desc: 'Faster rotation: depot capacity +3 trucks.',
    depot_upg_frigo_name: 'Local cold zone',
    depot_upg_frigo_desc: 'Certified cold dock: unlocks T3+ refrigerated contracts for the whole network.',
    depot_upg_atelier_name: 'Mechanical workshop',
    depot_upg_atelier_desc: 'In-house servicing: −10% maintenance for vehicles attached to this depot.',
    depot_upg_solar_name: 'Solar panels',
    depot_upg_solar_desc: 'Self-consumption rooftop solar: site rent −20%.',
    depot_upg_borne_name: 'EV charging station',
    depot_upg_borne_desc: 'On-site fast charging: −15% fuel/energy for vehicles attached to this depot.',

    // i18n migration — PhaseNotification
    phase_new_phase_label: 'New phase',
    phase_2_title: 'Regional Phase',
    phase_2_subtitle: 'Your company is expanding!',
    phase_2_description: 'You\'ve unlocked access to regional zones. New routes, new contracts and bigger vehicles await you.',
    phase_2_unlock_1: 'Regional contracts (bulk, pallets, construction)',
    phase_2_unlock_2: 'Tier 2 vehicles — Trucks 7T-12T',
    phase_2_unlock_3: 'Experienced drivers (license C)',
    phase_2_unlock_4: 'New zones: Grand Est, Normandy, Brittany',
    phase_2_condition: 'Monthly revenue ≥ €30,000 · 2 months of activity · 3 vehicles',
    phase_3_title: 'National Phase',
    phase_3_subtitle: 'Your network covers France!',
    phase_3_description: 'National routes are within reach. Semi-trailers, long distance and lucrative contracts become accessible.',
    phase_3_unlock_1: 'National long-distance contracts',
    phase_3_unlock_2: 'Tier 3 semi-trailers — VOLVAX, SCANEX, DAFORA',
    phase_3_unlock_3: 'Experienced drivers (license CE)',
    phase_3_unlock_4: 'Paris-Lyon-Marseille-Bordeaux-Lille corridors',
    phase_3_condition: 'Monthly revenue ≥ €60,000 · 5 months · 5 vehicles · 2 depots',
    phase_4_title: 'European Phase',
    phase_4_subtitle: 'Europe is yours!',
    phase_4_description: 'EU exports are now accessible. International prestige contracts, specialised vehicles and exceptional margins.',
    phase_4_unlock_1: 'EU Export contracts — Spain, Germany, Italy, Benelux',
    phase_4_unlock_2: 'Tier 4-5 vehicles — Specialised and prestige',
    phase_4_unlock_3: 'Senior drivers and multilingual experts',
    phase_4_unlock_4: 'SCANEX R 650 V8 Prestige and VOLVAX Electric',
    phase_4_condition: 'Monthly revenue ≥ €200,000 · 7 months · 8 vehicles · 2 depots · 1 sales support',

    // i18n migration — Depot zones
    depot_zone_garage_name: 'Garage / Box',
    depot_zone_garage_desc: 'Vehicle parking and repairs',
    depot_zone_garage_capacity: '2 vehicles',
    depot_zone_quai_name: 'Loading dock',
    depot_zone_quai_desc: 'Fast loading/unloading area',
    depot_zone_quai_capacity: '1 dock',
    depot_zone_entrepot_name: 'Dedicated warehouse',
    depot_zone_entrepot_desc: 'Client goods storage',
    depot_zone_entrepot_capacity: '200 m²',
    depot_zone_frigo_name: 'Refrigerated zone',
    depot_zone_frigo_desc: 'Temperature-controlled storage',
    depot_zone_frigo_capacity: '50 m²',
    depot_zone_pompe_name: 'Fuel pump',
    depot_zone_pompe_desc: 'Dedicated diesel station, cost reduction',
    depot_zone_pompe_capacity: '2,000L',
    // 04/02/2026 — Phase F4 : new specialised zones (Fleet analysis doc)
    depot_zone_point_eau_name: 'Water point',
    depot_zone_point_eau_desc: 'Watering and care, required for livestock transporter',
    depot_zone_point_eau_capacity: '1 point',
    depot_zone_zone_adr_name: 'Secure ADR area',
    depot_zone_zone_adr_desc: 'Hazardous-materials tank storage and washing',
    depot_zone_zone_adr_capacity: '300 m² secure',
    depot_zone_borne_recharge_name: 'Electric charging station',
    depot_zone_borne_recharge_desc: 'Fast 150 kW DC charger, required for electric trucks',
    depot_zone_borne_recharge_capacity: '2 vehicles',
    depot_zone_atelier_name: 'Mechanical workshop',
    depot_zone_atelier_desc: 'In-house workshop, -20% fleet maintenance cost',
    depot_zone_atelier_capacity: '1 workshop',
    depot_upg_inv_depot_01_label: 'Expansion x2',
    depot_upg_inv_depot_01_desc: '4 spots instead of 2',
    depot_upg_inv_depot_03_label: 'Buy land + warehouse',
    depot_upg_inv_depot_03_desc: 'Owner, +30% margin',
    depot_upg_inv_depot_06_label: 'Logistic extension (+100 km)',
    depot_upg_inv_depot_06_desc: 'HQ coverage radius extended by 100 km',
    depot_upg_inv_depot_07_label: 'Reinforced dock (heavy BTP)',
    depot_upg_inv_depot_07_desc: 'Dedicated dock for equipment transport and 44 T dump trucks',
    depot_upg_inv_depot_08_label: 'High-ceiling hangar (T3+)',
    depot_upg_inv_depot_08_desc: 'Gate height 4.5m — unlocks Tier 3+ semi-trailers',
    depot_upg_inv_depot_solar_label: 'Photovoltaic panels (HQ)',
    depot_upg_inv_depot_solar_desc: 'Self-consumption on workshop roof — HQ rent −20 % (Phase 4 required)',
    depot_upg_inv_energy_01_label: 'Fuel tank 2,000L',
    depot_upg_inv_energy_01_desc: '-8% fuel cost',
    depot_productivity_title: 'Depot productivity score',
    depot_productivity_subtitle: 'Cumulative bonus across all possible investments',
    depot_no_bonus_yet: 'No active bonus yet. Activate your zones to gain productivity.',
    depot_non_hq_info: '**Depot {{name}}.** This installation is already equipped (garage, warehouse, dock, refrigerator, pump). You park {{vehicleCount}} vehicle(s) here and {{driverCount}} driver(s) are attached. Physical upgrades remain reserved for the HST HQ.',
    per_month_short: '/mo',

    // i18n migration — Marche
    market_intel_unlock_tip: 'Hire Sherazade Fetitou (Senior Marketing) + a sales rep to unlock',
    months_short: 'months',
    notoriety_short: 'Notoriety',
    regional_ranking_tab: 'Regional ranking',
    competitors_label: 'Competitors',
    market_intel_tab: 'Competitor intel',
    events_tab: 'Events',
    market_intel_title: 'Strategic competitor intel',
    market_intel_monthly_challenges: 'Challenges this month:',
    market_intel_intro: 'Your Marketing + Sales teams identified contracts held by your competitors. Choose targets then launch a poaching attempt with the argument that fits the client.',
    market_intel_pending_label: 'Pending poaching attempts / results',
    market_intel_argument_label: 'argument',
    market_intel_in_progress: 'In progress · D-{{days}}',
    market_intel_capture: 'Capture ({{prob}}%)',
    market_intel_failure: 'Failed ({{prob}}%)',
    market_intel_empty: 'No competitor contract identified yet.',
    market_intel_competitor_label: 'Competitor:',
    market_intel_loyalty_label: 'Loyalty',
    market_intel_primary_arg: 'Primary argument:',
    market_intel_secondary_arg: 'secondary:',
    market_intel_low_treasury_800: 'Insufficient treasury (€800 required)',
    market_intel_low_treasury_1600: 'Insufficient treasury (€1,600 required)',
    market_intel_monthly_quota_reached: 'Monthly quota reached (3 challenges)',
    market_intel_launch_challenge: 'Launch a poaching attempt',
    market_intel_challenge_btn: 'Challenge',
    market_intel_history_title: 'Poaching history',
    market_intel_intensity_intensive: 'intensive',
    market_intel_intensity_standard: 'standard',
    market_intel_chance: 'chance',
    market_intel_won: 'Won',
    market_intel_lost: 'Lost',
    market_intel_success_rate: 'Success rate:',
    market_intel_alert_low_treasury: 'Insufficient treasury',
    challenge_modal_title: 'Strategic poaching',
    challenge_modal_intro: 'Choose the argument to convince **{{client}}** to break their contract with **{{competitor}}**.',
    challenge_modal_profile: 'Client profile',
    challenge_modal_sensitive_to: 'Sensitive to',
    challenge_modal_and: 'and',
    challenge_intensity_standard: 'Standard',
    challenge_intensity_standard_desc: '€800 · nominal rate',
    challenge_intensity_intensive: 'Intensive',
    challenge_intensity_intensive_desc: '€1,600 · +20% chance',
    argument_strongest: 'strongest',
    argument_medium: 'medium',
    challenge_cost_intensive: 'Poaching cost: €1,600 · +20% success · 4 days · max 3 challenges/month.',
    challenge_cost_standard: 'Poaching cost: €800 · 4 days · max 3 challenges/month.',
    event_cost_label: 'Cost:',
    market_competition_history_title: 'Competition history',
    market_competitor_activity_title: 'Competitor activity',

    // i18n migration — ContractAssignModal
    contract_equipment_label: 'Equipment',
    contract_international_label: 'International contract',
    contract_incoterm_label: 'Incoterm',
    contract_risk_transfer: 'Risk transfer:',
    contract_your_charge: 'Your charge:',
    contract_vat_applicable: 'Applicable VAT',
    contract_invoice_mention: 'Mandatory invoice mention:',
    contract_customs_fees: 'Customs fees:',
    contract_customs_fees_detail: 'SAD + transit + EUR1',
    contract_ht_deducted: 'excl. VAT (deducted from result)',
    contract_why_this_choice: 'Why this choice?',
    contract_equipment_required: '{{value}} equipment required',
    contract_driver_level: 'Lvl. {{level}}',
    contract_driver_specialty_required: '{{value}} specialty required (training)',
    contract_estimated_gross_margin: 'Estimated gross margin',
    contract_avoid_deficit: 'Avoid — loss-making contract',
    contract_margin_market_cap_hint: 'Above {{cap}}% gross margin the client will renegotiate the rate (market tension)',
    contract_fuel_short: 'fuel',
    contract_maintenance_short: 'maint',
    contract_salary_short: 'salary',
    contract_insurance_short: 'insur',
    contract_toll_short: 'tolls',
    contract_permit_missing_warning: '**{{name}}** does not have the **{{required}}** license required to drive this vehicle. Licenses held: {{owned}}. Train them or pick another driver.',

    // i18n migration — Strategie
    strat_title: 'Strategic Dashboard',
    strat_subtitle: '— run your company as CEO',
    strat_kpi_revenue: 'Current monthly revenue',
    strat_kpi_net_result: 'Result of the month',
    strat_kpi_runway: 'Cash runway',
    strat_treasury_hint: 'Treasury {{value}}',
    strat_kpi_avg_margin: 'Avg. gross margin / contract',
    strat_locked_value: '— locked',
    strat_unlock_with_tms: 'Unlocked with TMS + sales rep',
    strat_kpi_fleet_use: 'Fleet utilisation',
    strat_fleet_hint: '{{active}}/{{total}} vehicles',
    strat_kpi_driver_satisfaction: 'Driver satisfaction',
    strat_drivers_count_hint: '{{count}} driver(s)',
    strat_kpi_churn: 'Churn 12 months',
    strat_resignations_hint: '{{count}} resignation(s)',
    strat_kpi_depot_prod: 'Depot productivity',
    strat_kpi_cost_per_km: 'Avg. cost per km',
    strat_fuel_maintenance_hint: 'Fuel + maintenance',
    strat_buy_vehicle_hint: 'Buy a vehicle',
    strat_kpi_challenge_rate: 'Poaching success',
    strat_challenge_hint: '{{wins}}/{{total}} challenges',
    strat_kpi_compliance: 'Compliance score',
    strat_audit_high_risk: 'High audit risk',
    strat_kpi_audits: 'Audits faced',
    strat_clean_short: 'clean',
    strat_redresses_hint: 'Reassessments {{value}}',
    strat_kpi_equity: 'Equity',
    strat_solvency_hint: 'Solvency {{pct}}%',
    strat_kpi_fleet_net: 'Fleet net worth',
    strat_fleet_breakdown_hint: '{{count}} truck(s) · {{mortgaged}} mortg.',
    strat_kpi_debt_ratio: 'Debt / Assets',
    strat_passif_hint: 'Liabilities {{value}}',
    strat_kpi_actif_total: 'Total assets',
    strat_actif_breakdown_hint: 'Cash {{cash}} · Fleet {{fleet}}',
    strat_rep_noto_title: 'Reputation & Notoriety trend',
    strat_rep_noto_measures: '{{count}} measures · weekly',
    strat_day_label: 'Day {{day}}',
    strat_active_missions_title: 'Active missions map',
    strat_contracts_count: '{{count}} contract(s)',
    strat_alerts_title: 'Alerts & attention points',
    strat_alert_runway: 'Critical cash runway: less than 3 months.',
    strat_alert_satisfaction: 'Very low driver satisfaction: high attrition risk.',
    strat_alert_compliance: 'Low compliance score: an audit could be costly.',
    strat_alert_resolution_prefix: 'Active Board resolution:',
    strat_alert_resolution_until: '(until D{{day}}).',
    strat_compat_title: 'Team × missions compatibility matrix',
    strat_compat_lock_msg: 'Hire **Nadia Cheikh — HR Manager** in Support Functions to see which drivers fit which missions, and anticipate resignations before it\'s too late.',

    // i18n migration — Capitaux
    cap_title: 'Capital & Assets',
    cap_subtitle_at_day: '— simplified balance sheet at day {{day}}',
    cap_total_actif: 'TOTAL ASSETS',
    cap_actif_hint: 'Treasury + placements + fleet',
    cap_total_passif: 'TOTAL LIABILITIES',
    cap_passif_hint: 'Loans + lease commitments + tax debt',
    cap_equity_label: 'EQUITY',
    cap_equity_hint: 'Solvency {{solvency}}% · Debt {{debt}}%',
    cap_fleet_label: 'FLEET NET WORTH',
    cap_fleet_hint: '{{count}} truck(s) · {{mortgaged}} mortgaged',
    cap_risk_signals: 'Risk signals',
    cap_alert_equity_minor: 'Slightly negative equity — normal startup situation, to monitor as soon as revenue stabilises.',
    cap_alert_equity_critical: 'Negative equity — the company faces imminent insolvency.',
    cap_alert_solvency_low: 'Low solvency ({{pct}}%) — recapitalise via early repayment or asset disposal.',
    cap_alert_debt_high: 'Very high debt ratio ({{pct}}%) — limit new loans.',
    cap_equity_chart_title: 'Equity Trend',
    cap_chart_monthly_closes: '{{count}} monthly close(s)',
    cap_chart_waiting: 'Awaiting first monthly close',
    cap_chart_grows_text: 'The chart grows with each **monthly close** (every 30 days).',
    cap_chart_day_info: 'Current day: {{day}} · next close: D{{next}}.',
    cap_chart_equity_name: 'Equity',
    cap_chart_actif_name: 'Total assets',
    cap_chart_passif_name: 'Total liabilities',
    cap_chart_fleet_name: 'Fleet net worth',
    cap_actif_panel: 'Assets',
    cap_passif_panel: 'Liabilities',
    cap_row_treasury: 'Treasury',
    cap_row_treasury_hint: 'Current account',
    cap_row_placements: 'Bank placements',
    cap_row_placements_hint: '{{count}} placement(s)',
    cap_row_fleet_resale: 'Fleet (resale value)',
    cap_row_fleet_owned_hint: '{{count}} truck(s) owned',
    cap_row_credits: 'Bank loans',
    cap_row_credits_hint: '{{count}} active loan(s)',
    cap_row_lease: 'Lease commitments',
    cap_row_lease_hint: '{{count}} active contract(s)',
    cap_row_tax_debt: 'Tax debt',
    cap_row_tax_hint: 'VAT pending {{tva}} · CIT provision {{is}}',
    cap_row_tva_provisioned: 'VAT provision',
    cap_row_tva_provisioned_hint: 'Cash set aside for the next VAT deadline',
    cap_row_is_provisioned: 'CIT provision',
    cap_row_is_provisioned_hint: 'Cash set aside for upcoming corporate tax',
    cap_row_fiscal_reserve: 'Fiscal reserve (placement)',
    cap_row_fiscal_reserve_hint: 'Interest-bearing placement (3%) buffering tax deadlines',
    cap_row_tva_pending: 'incl. VAT pending',
    cap_row_tva_pending_hint: 'Collected VAT − deductible VAT to remit',
    cap_row_is_provision_due: 'incl. CIT to provision',
    cap_row_is_provision_due_hint: '~25% of projected annual profit',
    // 17/06/2026 (Lot 6 Phase 1) — Diplomacy / competitive relations
    relation_tier_enemy: 'Sworn enemy',
    relation_tier_rival: 'Rival',
    relation_tier_neutral: 'Neutral',
    relation_tier_peer: 'Peer',
    relation_tier_ally: 'Ally',
    relation_with_us: 'Relationship with you',
    cap_fleet_detail_title: 'Fleet net worth — per truck',
    cap_fleet_breakdown: 'Gross value {{gross}} − Mortgage debt {{debt}}',
    cap_fleet_empty: 'No owned truck. Buy or buy out a leased vehicle to build equity.',
    cap_th_truck: 'Truck',
    cap_th_tier: 'Tier',
    cap_th_resale: 'Resale value',
    cap_th_mortgage_debt: 'Mortgage debt',
    cap_th_net_value: 'Net value',
    cap_th_status: 'Status',
    cap_status_mortgaged: 'Mortgaged · {{months}} mo',
    cap_status_free: 'Free',
    cap_lease_engagements_title: 'Lease commitments',
    cap_lease_total_remaining: 'Total remaining',
    cap_th_months_left: 'Months left',
    cap_th_monthly: 'Monthly',
    cap_th_residual: 'Residual value',
    cap_th_total_engagement: 'Total commitment',
    cap_pedagogical_footer: '**Equity = Assets − Liabilities.** Represents the company\'s net wealth. A **solvency ratio ≥ 30%** is healthy for a transport SME; beyond **60% debt**, banks become reluctant and risk rises. **Fleet resale value** reflects depreciation (wear + age), not purchase price. Leased vehicles are not on the asset side (they still belong to the lessor), but the residual commitment (monthlies + residual value) appears on the liabilities side.',

    // i18n migration — AcquisitionModal
    acq_header_prefix: 'Acquisition',
    acq_stage_label: 'Stage {{current}}/5',
    acq_abandon_btn: 'Abandon',
    acq_dd_title: 'CFO audit report',
    acq_dd_ca: 'Monthly revenue',
    acq_dd_net_margin: 'Net margin',
    acq_dd_equity: 'Shareholder equity',
    acq_dd_net_debt: 'Net debt',
    acq_dd_fleet: 'Fleet',
    acq_dd_drivers: 'Drivers',
    acq_dd_lever_title: 'Identified negotiation lever',
    acq_dd_lever_bonus: 'Negotiation bonus: +{{pct}}% chance of agreement.',
    acq_loi_rep_line: 'Your current reputation: **{{reputation}}/100** · Notoriety: **{{notoriety}}/100**',
    acq_loi_chance: 'LOI acceptance chance: **{{pct}}%**',
    acq_loi_refusal_warning: 'If the LOI is refused, you cannot retry this acquisition for 90 days.',
    acq_neg_asking_price: 'CFO asking price',
    acq_neg_choose_strategy: 'Choose your strategy',
    acq_neg_accept_label: 'Accept CFO price',
    acq_neg_accept_sub: '100% success — no discount',
    acq_neg_negotiate_label: 'Negotiate −15%',
    acq_neg_negotiate_sub: 'Moderate risk — based on reputation',
    acq_neg_aggressive_label: 'Aggressive offer −25%',
    acq_neg_aggressive_sub: 'High risk — based on reputation',
    acq_neg_success_label: 'Success: {{pct}}%',
    acq_anti_our_ca: 'Your monthly revenue',
    acq_anti_target_ca: 'Target monthly revenue',
    acq_anti_combined_share: 'Combined market share',
    acq_anti_low: 'Low concentration — quasi-automatic authorisation.',
    acq_anti_medium: 'Moderate concentration — the authority will examine the file carefully.',
    acq_anti_high: 'High concentration — significant refusal risk (30%).',
    acq_anti_dominant: 'Dominant concentration — refusal very likely (60%).',
    acq_anti_refusal_fee: 'Filing fee in case of refusal: €5,000 (your charge).',
    acq_closing_final_terms: 'Final terms',
    acq_closing_neg_accepted: '✓ Negotiation accepted (-{{pct}}%)',
    acq_closing_neg_refused: '✗ Negotiation refused — asking price kept',
    acq_closing_you_get_title: 'After closing you get:',
    acq_closing_get_fleet: '{{count}} used vehicles',
    acq_closing_get_drivers: 'Up to {{count}} drivers (some may not follow)',
    acq_closing_get_depot: '1 fully equipped depot (becomes your Depot 2 or 3)',
    acq_closing_get_contracts: '{{count}} active contracts in progress',
    acq_closing_treasury_line: 'Current treasury: **€{{before}}** → after closing: **€{{after}}**',
    acq_closing_insufficient: '⚠ Insufficient treasury. Increase treasury or take a loan before signing.',
    acq_closing_postpone_btn: 'Postpone signature',
    acq_closing_sign_btn: 'Sign closing — €{{price}}',
    acq_success_label: 'Closing finalised',
    acq_success_welcome: 'Welcome to {{name}}!',
    acq_success_finalized: 'Acquisition completed for **€{{price}}**',
    acq_success_new_depot: 'New depot',
    acq_success_vehicles_inherited: 'Inherited vehicles',
    acq_success_contracts_inherited: '{{count}} client contract(s) transferred',
    acq_success_drivers_followed: 'Drivers who followed',
    acq_success_drivers_left: '{{count}} driver(s) left elsewhere',
    acq_success_reputation: 'Reputation',
    acq_success_notoriety: 'Notoriety',
    acq_success_access_depot_btn: 'Excellent — access the new depot',

    // i18n migration — SupervisionView
    sup_title: 'Pedagogical Supervision',
    sup_supervisor_default: 'Supervisor',
    sup_apprentices_count: '{{count}} apprentice(s)',
    sup_loading: 'Loading…',
    sup_refresh_btn: 'Refresh',
    sup_logout_btn: 'Quit',
    sup_network_error: 'Network error',
    sup_send_error: 'Send error',
    sup_agg_apprentices: 'Apprentices',
    sup_agg_playing: 'Playing now',
    sup_agg_avg_days: 'Days played (avg.)',
    sup_agg_total_fleet: 'Trucks cumulative',
    sup_agg_neg_equity: 'Negative equity',
    sup_search_placeholder: 'Filter by apprentice name or company…',
    sup_displayed_count: '{{count}} shown',
    sup_empty_cohort: 'No active apprentice in this cohort.',
    sup_empty_hint: 'Assign licenses to this group via the admin panel to see them appear here.',
    sup_liquidated_on: '⚖ Liquidated D{{day}}',
    sup_rex_badge: 'REX received',
    sup_rex_badge_title: 'REX submitted on {{date}} — see the "Cohort REX" section',
    sup_not_played_yet: 'Not played yet',
    sup_objective_btn: 'Objective',
    sup_active_count: '{{count}} active',
    sup_annotate_btn: 'Annotate',
    sup_unread_short: 'unread',
    sup_pdf_btn: 'PDF',
    sup_pdf_title_active: 'Download learner PDF report',
    sup_pdf_title_inactive: 'Learner has not started their game yet',
    sup_pdf_btn_error: 'Error',
    sup_stmt_title: 'Financial statements (closed years + cumulative)',
    sup_stmt_include_current: 'Include current year (provisional)',
    sup_stmt_cumulative_pdf: 'Cumulative PDF',
    sup_stmt_pdf: 'Statement PDF',
    sup_stmt_year: 'Year {{year}}',
    sup_stmt_provisional: 'provisional',
    sup_stmt_ca_short: 'Revenue',
    sup_stmt_not_synced: 'No statements received yet — the learner must resume the game so the telemetry syncs.',
    sup_stmt_empty: 'No closed fiscal year yet.',
    sup_stmt_empty_with_current: 'No closed fiscal year yet — tick “Include current year” for a provisional statement.',
    market_tension_badge: 'Market tension',
    finance_tab_market: 'Market',
    d3_close: 'Close',
    d3_effect: 'Effect:',
    d3_purchase: 'Purchase',
    d3_monthly_charge: 'Monthly charge',
    d3_condition: 'Condition',
    d3_related_contracts: 'Related contracts',
    d3_zone_operational: 'Zone operational',
    d3_build_for: 'Build — {{cost}}',
    d3_insufficient_cash: 'Insufficient cash',
    d3_locked: 'Locked',
    d3_status: 'Status',
    d3_driver: 'Driver',
    d3_unassigned: 'Unassigned',
    d3_contract: 'Contract',
    d3_route: 'Route',
    d3_compatible: 'Compatible with',
    d3_hq_card_title: 'HQ · {{name}}',
    d3_hq_card_sub: 'Human resources and active contracts',
    d3_role_chauffeurs: 'Drivers',
    d3_role_mecaniciens: 'Mechanics',
    d3_role_caristes: 'Forklift operators',
    d3_role_exploitants: 'Dispatchers',
    d3_role_agents: 'Dock agents',
    d3_required: '/ {{n}} required',
    d3_active_contracts: 'Active contracts',
    d3_required_zone: 'Required zone',
    d3_to_build: '(to build)',
    d3_compatible_vehicles: 'Compatible vehicles',
    d3_none: 'None',
    d3_see_zone_named: 'See “{{name}}”',
    d3_attention_points: '{{n}} attention point',
    d3_attention_points_plural: '{{n}} attention points',
    d3_hide: 'Hide',
    d3_show_all: 'Show all',
    d3_depot_complete: 'Depot complete',
    d3_depot_complete_sub: '— every zone is operational and consistent with the contracts.',
    d3_depot_coherent: 'Depot consistent',
    d3_depot_coherent_sub: '— contracts, fleet and staff match the built zones.',
    d3_topic_rh: 'HR',
    d3_topic_flotte: 'Fleet',
    d3_topic_contrat: 'Contract',
    d3_see_zone: 'See zone',
    d3_see_hq: 'See HQ',
    d3_phase: 'Phase {{n}}/{{total}}',
    d3_acquired_from: '· acquired from {{name}}',
    d3_fleet_staff_title: 'Fleet and staff',
    d3_vehicles_short: 'veh.',
    d3_slots: '/ {{n}} slots',
    d3_click_hint_pre: 'Click a zone',
    d3_click_hint_post: ', a vehicle or the HQ',
    d3_available_badge: '✦ AVAILABLE',
    d3_camera: 'Camera',
    d3_rotate_left: 'Rotate left',
    d3_rotate_right: 'Rotate right',
    d3_zoom_in: 'Zoom in',
    d3_zoom_out: 'Zoom out',
    d3_overview: 'Overview',
    d3_timeline_title: 'Depot timeline',
    d3_steps: 'steps',
    d3_invested: 'Invested',
    d3_charges: 'Charges',
    d3_unit_day: 'Day',
    d3_unit_week: 'Week',
    d3_unit_day_short: 'D',
    d3_unit_week_short: 'W',
    d3_collapse: 'Collapse',
    d3_expand: 'Expand',
    d3_takeover_of: 'Takeover of {{name}}',
    d3_site_opening: 'Site opening',
    d3_taken_over: 'Taken over: {{list}}',
    d3_site: 'Site',
    d3_yard_gate_hq: 'Yard, gate, HQ',
    d3_free: 'Free',
    d3_total_charges: 'Total charges {{amount}} €/mo',
    d3_serves_contracts: 'Serves {{n}} contract',
    d3_serves_contracts_plural: 'Serves {{n}} contracts',
    d3_today: 'Today',
    d3_upcoming: 'Upcoming',
    d3_recommended: '✦ Recommended',
    d3_waiting_contracts: '{{n}} contract waiting',
    d3_waiting_contracts_plural: '{{n}} contracts waiting',
    d3_available: 'Available',
    d3_locked_steps: '+{{n}} locked step',
    d3_locked_steps_plural: '+{{n}} locked steps',
    d3_see_tree: 'See the development tree',
    d3_tree_title: 'Development tree',
    d3_filter_steps: 'Filter steps',
    d3_filter_all: 'All',
    d3_filter_available: 'Available',
    d3_filter_built: 'Built',
    d3_filter_locked: 'Locked',
    d3_recommended_step: 'Recommended step',
    d3_state_built: 'built',
    d3_state_available: 'available',
    d3_state_locked: 'locked',
    d3_to_unlock: 'To unlock {{id}}',
    d3_conditions_unmet: 'conditions not met',
    d3_condition_suffix: ' · condition: {{c}}',
    d3_hover_hint: 'Hover a step to see its prerequisites and the total cost to unlock it.',
    d3_taken_over_ex: 'Taken over · ex-{{name}}',
    d3_legend_built: 'Built',
    d3_legend_available: 'Available',
    d3_legend_locked: 'Locked',
    d3_legend_recommended: 'Recommended step',
    d3_tier_fondation: 'Foundation',
    d3_tier_structure: 'Structure',
    d3_tier_developpement: 'Development',
    d3_tier_specialisation: 'Specialisation',
    d3_tier_excellence: 'Excellence',
    d3_goods_sec: 'Dry goods',
    d3_goods_frigo: 'Fresh produce',
    d3_goods_btp: 'Construction materials',
    d3_goods_adr: 'Hazardous materials (ADR)',
    d3_goods_vrac: 'Bulk',
    d3_body_tautliner: 'curtainsider',
    d3_body_frigo: 'refrigerated',
    d3_body_citerne: 'tanker',
    d3_body_plateau: 'flatbed',
    d3_body_benne: 'tipper',
    d3_body_fourgon: 'van body',
    d3_type_semi: 'Articulated truck',
    d3_type_porteur: '19 t rigid truck',
    d3_type_vul: 'LCV',
    d3_status_stationne: 'Parked',
    d3_status_mission: 'On mission',
    d3_status_atelier: 'In the workshop',
    d3_base_site: 'Base site',
    d3_coh_goods_without_zone: '{{client}}: {{goods}} without “{{zone}}”',
    d3_coh_no_vehicle: '{{client}}: no {{bodies}} vehicle in the depot fleet',
    d3_coh_no_slot: '{{n}} vehicle(s) without a slot: expand the depot (P2)',
    d3_coh_no_driver: '{{n}} vehicle(s) without an assigned driver',
    d3_coh_no_mechanic: 'Mechanical workshop built without a mechanic',
    d3_coh_no_forklift: 'Warehouse without forklift operator: stock not handled',
    d3_coh_external_garage: 'Vehicle under repair at an external garage (no workshop)',
    d3_reco_unlocks: 'unlocks “{{zone}}” required by {{client}}',
    d3_reco_cheapest: 'cheapest available step',
    d3_theme_tempere: 'Temperate',
    d3_theme_mediterraneen: 'Mediterranean',
    d3_theme_montagne: 'Mountain',
    d3_theme_portuaire: 'Harbour',
    d3_theme_urbain: 'Urban',
    d3_country_FR: 'France',
    d3_country_BE: 'Belgium',
    d3_country_LU: 'Luxembourg',
    d3_country_ES: 'Spain',
    d3_country_DE: 'Germany',
    d3_country_AT: 'Austria',
    d3_country_CH: 'Switzerland',
    d3_country_IT: 'Italy',
    d3_country_NL: 'Netherlands',
    d3_country_PL: 'Poland',
    d3_country_PT: 'Portugal',
    d3_country_GB: 'United Kingdom',
    d3_country_UK: 'United Kingdom',
    d3_country_MA: 'Morocco',
    d3_country_TR: 'Turkey',
    d3_hq_prefix: 'HQ',
    d3_depot_prefix: 'Depot',
    d3_role_hq: 'head office',
    market_tab_empty: 'No margin data yet.',
    market_tab_empty_hint: 'The curve builds up every working day once a contract is running: average gross margin (bonuses included) against the {{cap}}% market cap.',
    market_kpi_current: 'Average gross margin (today)',
    market_kpi_cap: 'Cap',
    market_kpi_average: '90-day average',
    market_kpi_average_sub: 'over {{days}} d · peak {{peak}}%',
    market_kpi_days_over: 'Days above the cap',
    market_kpi_days_over_sub: 'over the last 90 working days (> {{cap}}%)',
    market_kpi_renegotiated: 'Renegotiated contracts',
    market_kpi_renegotiated_sub: 'foregone revenue: {{amount}}/day',
    market_chart_title: 'Average gross margin of running contracts vs market cap',
    market_chart_subtitle: '{{days}} rolling working days · revenue-weighted · bonuses included · cap {{cap}}%',
    market_series_margin: 'Average gross margin',
    market_series_renegotiated: 'Renegotiated contracts',
    market_series_contracts: 'Running contracts',
    market_tension_high: 'Market tension',
    market_tension_warm: 'Market watch',
    market_tension_calm: 'Market at ease',
    market_explainer_title: 'How to read this chart?',
    market_explainer_body: 'Every working day, HST computes the real gross margin of each running contract (rate × bonuses − fuel, maintenance, salary, insurance, tolls). The blue curve is the revenue-weighted average. Above the red line ({{cap}}%), the orange zone flags market tension: clients renegotiate rates (max −3%/day) until you are back under the cap. Orange bars count renegotiated contracts.',
    market_tension_badge_title: 'Real gross margin {{margin}}% > 65%: the client is renegotiating the rate (−{{pct}}% so far, max −3%/day down to 65%).',
    market_tension_header: '{{count}} renegotiated contract(s)',
    market_tension_header_title: 'Market equilibrium cap: above 65% gross margin (bonuses included), clients — tenders included — progressively renegotiate the rate.',

    sup_metric_treasury: 'Treasury',
    sup_metric_equity: 'Shareholder equity',
    sup_metric_monthly_ca: 'Monthly revenue',
    sup_metric_monthly_charges: 'Monthly charges',
    sup_metric_fleet: 'Fleet',
    sup_fleet_total_active: '{{total}} ({{active}} active)',
    sup_metric_drivers: 'Drivers',
    sup_drivers_satisfaction: '{{count}} · sat. {{sat}}%',
    sup_metric_support: 'Support',
    sup_metric_depot: 'Depot',
    sup_phase_label: 'Phase {{phase}}',
    sup_metric_active_contracts: 'Active contracts',
    sup_metric_game_phase: 'Game phase',
    sup_metric_playtime: 'Play time',
    // 25/07/2026 — Annual debriefs (supervisor view)
    sup_yd_title: 'Annual debriefs',
    sup_yd_loading: 'Loading…',
    sup_yd_empty: 'No fiscal year close reported yet (the debrief is sent at each in-game year end).',
    sup_yd_year_phase: 'Year {{year}}',
    sup_yd_phase: 'phase {{phase}}',
    sup_yd_revenue_short: 'Revenue',
    sup_yd_vehicles: '{{n}} vehicle(s)',
    sup_yd_drivers: '{{n}} driver(s)',
    sup_yd_ao_won: '{{n}} tender(s) won',
    sup_yd_profit: 'Profit',
    sup_yd_pace: 'Pace',
    sup_yd_better_than: 'better than {{p}}%',
    sup_yd_faster_than: 'faster than {{p}}%',
    sup_yd_pct_pending: 'Percentiles available once ≥ 4 players have closed this year.',
    sup_strategic_analysis: 'Strategic analysis',
    sup_not_started_p1: 'This person has not yet launched the game or is not online.',
    sup_not_started_p2: 'Data will appear here from the first monthly close.',
    sup_tone_encouragement: 'Encouragement',
    sup_tone_advice: 'Advice',
    sup_tone_warning: 'Warning',
    sup_msg_empty: 'The message cannot be empty.',
    sup_annotate_title: 'Annotate {{name}}',
    sup_annotate_subtitle: 'The message will appear in the game Inbox at the next connection / monthly close.',
    sup_tonality_label: 'Tone',
    sup_message_label: 'Message',
    sup_message_placeholder: 'Ex: Great fleet management this month! Keep an eye on your treasury, it\'s nearing the minimum.',
    sup_chars_remaining: '{{count}} character{{plural}} remaining',
    sup_annotation_sent: 'Annotation sent — it will appear in the apprentice\'s Inbox.',
    sup_sending: 'Sending...',
    sup_send_annotation_btn: 'Send annotation',
    sup_history_label: 'History',
    sup_read_by_apprentice: 'Read by the apprentice',
    sup_awaiting_read: 'Awaiting read',
    sup_obj_status_active: 'Active',
    sup_obj_status_achieved: 'Achieved',
    sup_obj_status_failed: 'Missed',
    sup_obj_status_cancelled: 'Cancelled',
    sup_obj_title_required: 'Title is required.',
    sup_obj_threshold_invalid: 'Numeric threshold is invalid.',
    sup_obj_deadline_invalid: 'Deadline must be a positive integer (in game days).',
    sup_obj_create_error: 'Error during creation',
    sup_obj_confirm_cancel: 'Cancel this active objective?',
    sup_obj_modal_title: 'Objective for {{name}}',
    sup_obj_subtitle: 'Evaluated automatically at each apprentice monthly close.',
    sup_obj_title_label: 'Title',
    sup_obj_title_placeholder: 'Ex: Reach €30,000 treasury by D90',
    sup_obj_metric_label: 'Metric',
    sup_obj_op_label: 'Op.',
    sup_obj_threshold_label: 'Threshold',
    sup_obj_deadline_label: 'Deadline (game days, optional)',
    sup_obj_deadline_hint: 'If the objective is not met before this day, it becomes "Missed". Leave empty = no deadline.',
    sup_obj_created_success: 'Objective created — it will be evaluated at the next monthly close.',
    sup_obj_creating: 'Creating...',
    sup_obj_create_btn: 'Create objective',
    sup_obj_deadline_short: 'deadline D{{day}}',
    sup_obj_achieved_on: 'Achieved on {{date}}',
    sup_obj_value_label: 'value {{value}}',
    sup_obj_failed_on: 'Missed on {{date}}',

    // i18n migration — Shared components
    strategic_insights_label: 'Strategic insights',
    strategic_insights_tooltip: 'Ask the advisor for a strategic review',
    reports_menu_label: 'Reports & profile',
    reports_menu_tooltip: 'Strategic insights, session summary and learner profile',
    manual_label: 'Pedagogical manual',
    manual_open_aria: 'Open manual',
    manual_close_aria: 'Close manual',
    date_label: 'Date',
    kpi_daily_delta_tooltip: 'Smoothed delta of the last day: today\'s revenue − (monthly fixed costs ÷ 22 working days + fuel + maintenance + insurance for the day). A negative delta is NORMAL on days without a new delivery: fixed costs (HR, loan, rent) are spread across the month. See "Monthly net" in Finance for the real profitability metric.',
    kpi_smoothed_suffix: 'smoothed',
    kpi_how_it_evolves: 'How it evolves',
    kpi_rep_evo_1: 'Contracts completed without penalty',
    kpi_rep_evo_2: 'Well-rated and satisfied drivers',
    kpi_rep_evo_3: 'Customer service (Lucas, Inès), Communication (Aïcha)',
    kpi_rep_evo_4: 'Cancellations, breakdowns, accidents',
    kpi_rep_evo_5: 'Negative events (mitigated by event_rep_mitigation)',
    kpi_rep_influence: 'Influences: events, insurance, credit score, customer loyalty.',
    kpi_noto_evo_1: 'Marketing (Yanis, Camille) — passive',
    kpi_noto_evo_2: 'Press officer (Aïcha) — passive',
    kpi_noto_evo_3: 'Trade shows (unlocked by Marc Dupuis)',
    kpi_noto_evo_4: 'Successful challenges (+8, press coverage)',
    kpi_noto_evo_5: 'Decreases 0.5/month with no action',
    kpi_noto_influence: 'Influences: number of contracts offered, access to large accounts, recruitment quality.',
    depot_strategy_title: 'Multi-depot strategy',
    depot_strategy_intro: 'Up to **{{max}} depots in France**: **{{opened}} created** (organic growth) + **{{acquired}} acquired** (external growth via M&A), **plus {{intl}} international locations possible outside France** (EU cities, phase 4). Each depot has its own bonus and cost.',
    depot_strategy_slots_used: 'slots used',
    depot_strategy_created_short: 'created',
    depot_strategy_acquired_short: 'acquired',
    depot_strategy_intl_short: 'intl',
    depot_strategy_kind_created: 'Created',
    depot_strategy_kind_acquired: 'Acquired',
    depot_strategy_kind_intl: 'International',
    depot_strategy_intl_label: 'International growth — locations outside France ({{open}}/{{max}})',
    depot_strategy_intl_slot_1_label: 'EU location #1',
    depot_strategy_intl_slot_2_label: 'EU location #2',
    depot_strategy_intl_slot_desc: 'Depot outside France (EU city, phase 4 required). Rent ×1.25 — unlocks access to local EU export contracts.',
    depot_strategy_open_badge: 'OPEN',
    depot_strategy_slot_default: 'Depot {{idx}}',
    depot_strategy_charge_label: 'Charge / month',
    depot_strategy_included: 'included',
    depot_strategy_saturation_title: 'Saturation — Open or acquire a new depot',
    depot_strategy_saturation_body: 'Your fleet of **{{fleet}} vehicles** exceeds capacity ({{trigger}} max at the current tier of {{slots}} depot{{plural}}). Consequences:',
    depot_strategy_sat_penalty_1: '**-10% overall revenue**',
    depot_strategy_sat_penalty_2: 'Monthly event **"Neighborhood complaint"** (-3 reputation)',
    depot_strategy_sat_penalty_3: 'Auto-rejection of contracts > **€50,000**',
    depot_strategy_organic_label: 'Organic growth — created depots ({{open}}/{{max}})',
    depot_strategy_external_label: 'External growth — acquired depots ({{open}}/{{max}})',
    depot_strategy_total_monthly: 'Multi-depot rents',
    depot_strategy_rent_by_city: 'Rent by city',
    depot_strategy_rent_ratio: '{{pct}}% of monthly revenue',
    depot_strategy_rent_ratio_tooltip: 'Healthy target: 8-9% of revenue spent on rents. Above 12%, real estate weighs too heavily.',
    depot_strategy_max_reached: 'You\'ve reached the maximum of {{max}} depots ({{opened}} + {{acquired}}). Optimise the ones you own.',
    depot_eco_opened_0_label: 'Headquarters (HQ)',
    depot_eco_opened_0_desc: 'Your historic depot. No contract bonus but it\'s the only one that can be upgraded to 10 vehicles capacity.',
    depot_eco_opened_1_label: '+8% regional reach',
    depot_eco_opened_1_desc: 'Regional hub. +8% revenue on short-distance contracts (< 200 km). €3,500/month.',
    depot_eco_opened_2_label: '+5% long distance + Export',
    depot_eco_opened_2_desc: 'National hub. +5% revenue on contracts > 500 km and unlocks Export EU/Non-EU contracts. €4,500/month.',
    depot_eco_acquired_0_label: '+10% local notoriety',
    depot_eco_acquired_0_desc: 'The acquired competitor\'s brand stays strong in the region: +10% reputation at each monthly close. €4,000/month.',
    depot_eco_acquired_1_label: '+5% revenue (inherited loyal clients)',
    depot_eco_acquired_1_desc: 'The loyal client book follows: +5% revenue on ALL your contracts (all distances). €5,000/month.',
    depot_eco_acquired_2_label: '-15% driver fatigue (veteran team)',
    depot_eco_acquired_2_desc: 'The integrated veteran team shares its best practices: driver fatigue grows 15% slower. €6,000/month.',
    depot_scene_phase_0: 'Bare land — ready to build',
    depot_scene_phase_1: 'Garage operational',
    depot_scene_phase_2: 'Garage expanded ×2',
    depot_scene_phase_3: 'Warehouse in service',
    depot_scene_phase_4: 'Loading dock attached to the warehouse',
    depot_scene_phase_5: 'Warehouse extended',
    depot_scene_phase_6: 'Cold-storage connected',
    depot_scene_phase_7: 'Reinforced loading dock',
    depot_scene_phase_8: 'High-bay XXL warehouse',
    depot_scene_phase_9: 'EV charging station',
    depot_scene_phase_10: 'Private fuel pump',
    depot_scene_phase_11: 'Maintenance workshop',
    depot_scene_phase_12: 'Secured ADR zone',
    depot_scene_phase_13: 'Solar workshop roof',
    depot_scene_phase_14: 'Expanded fuel station — depot complete',
    depot_scene_build_1: 'garage',
    depot_scene_build_2: 'garage expanded ×2',
    depot_scene_build_3: 'warehouse',
    depot_scene_build_4: 'attached loading dock',
    depot_scene_build_5: 'extended warehouse',
    depot_scene_build_6: 'cold-storage',
    depot_scene_build_7: 'reinforced dock',
    depot_scene_build_8: 'high-bay XXL warehouse',
    depot_scene_build_9: 'EV charging station',
    depot_scene_build_10: 'fuel pump',
    depot_scene_build_11: 'maintenance workshop',
    depot_scene_build_12: 'ADR zone',
    depot_scene_build_13: 'workshop solar panels',
    depot_scene_build_14: 'expanded fuel station',
    depot_scene_weather_rain: 'Floods',
    depot_scene_weather_snow: 'Ice / snow',
    depot_scene_weather_heatwave: 'Heatwave',
    depot_scene_weather_storm: 'Storm',
    depot_scene_weather_fog: 'Fog',
    depot_scene_phase_label: 'Phase {{phase}}/14',
    depot_scene_new_building: 'New building: {{name}}',
    depot_scene_manage_zones_hint: 'Manage your zones via the cards below',
    contract_intl_details_show: 'details',
    contract_intl_details_hide: 'collapse',
    depot_scene_brand_tier_1: 'Satellite site',
    depot_scene_brand_tier_2: 'Regional site',
    depot_scene_brand_tier_3: 'Major hub',
    depot_scene_tier_label: 'Level {{tier}}/3',
    depot_scene_site_upgraded: 'Site expanded - new facilities',
    depot_timeline_title: 'Depot timeline',
    depot_timeline_subtitle: '{{built}}/{{max}} milestones built',
    depot_timeline_base: 'Initial setup',
    depot_timeline_day: 'Day {{day}}',
    depot_timeline_locked: 'To build',
    acq_success_depot_joins_network: 'This site joins your network',
    advisor_advice_from: 'Advice from {{name}}',
    advisor_none_selected: 'No advisor selected',
    insight_signals_count: '{{count}} signal(s)',
    advisor_all_clear_title: 'Everything is under control',
    advisor_all_clear_body: 'No major strategic signal detected. Keep steering — I\'ll come back to you as soon as a decision deserves your attention.',
    advisor_footer_realtime_p1: 'These insights are generated from real-time analysis of your balance sheet, fleet, team and order book.',
    advisor_footer_realtime_p2: 'They reflect the current state — a new turn may bring up or dismiss signals.',
    insight_severity_critical: 'CRITICAL',
    insight_severity_warning: 'WARNING',
    insight_severity_opportunity: 'OPPORTUNITY',
    insight_severity_info: 'INFO',
    insight_category_finance: 'Finance',
    insight_category_fleet: 'Fleet',
    insight_category_hr: 'Human Resources',
    insight_category_commercial: 'Sales',
    insight_category_fiscalite: 'Taxation',
    map_focus_p1: 'France local',
    map_focus_p2: 'France regional',
    map_focus_p3: 'France national',
    map_focus_p4: 'Europe',
    map_phase_select_city: 'Phase {{phase}} · {{focus}} · Click on a city',
    map_phase_missions_in_progress: 'Phase {{phase}} · {{focus}} · {{count}} missions in progress',
    map_active_missions_label: 'Missions in progress',
    map_hq_zone_fuel_bonus: 'HQ zone −10% fuel',
    tax_label_essieu: 'Axle tax',
    nav_unread_messages: '{{count}} unread message{{plural}}',
    nav_taxes_to_pay: 'Taxes to pay: {{list}}',
    depot_scene_previous_phase_alt: 'previous phase',
    nav_new_features_tooltip: '{{count}} new feature(s) unlocked by your support team',
    theme_tooltip_dark: 'Dark mode · click to switch to light',
    theme_tooltip_light: 'Light mode · click to follow system',
    theme_tooltip_auto: 'Auto system mode · click to switch to dark',

    // === P0 — Hide contracts ===
    contracts_hide_tooltip: 'Hide this contract (reversible)',
    contracts_hide_aria: 'Hide this contract',
    contracts_restore_hidden_label: 'Restore ({{count}})',
    contracts_restore_hidden_tooltip: 'Show all contracts you previously hid',
    contracts_sort_default: 'Market order',
    contracts_sort_margin: 'Profitability ↓',
    contracts_sort_revenue: 'Revenue ↓',
    contracts_sort_category: 'Category A→Z',
    contracts_sort_duration: 'Duration ↑',
    contracts_sort_tier: 'Tier ↑',
    contracts_filter_all: 'All',
    contracts_filter_ponctuel: 'One-off',
    contracts_filter_regulier: 'Recurring',
    contracts_frigo_zone_badge: 'Cold zone required',
    contracts_frigo_zone_tooltip: 'From tier 3 onward, refrigerated contracts require a depot cold zone. Invest from the Depot page → map panel (HQ: Cold zone · depots: Local cold zone).',
    contracts_validity_badge: 'Valid D-{{days}}',
    contracts_validity_tooltip: 'This offer leaves the board 14 days after publication — {{days}} day(s) left to accept it.',
    contracts_frigo_zone_hint: '{{count}} refrigerated contract(s) blocked: you must invest in a cold zone. Go to the Depot page → click your depot on the map → "Cold zone" upgrade (HQ) or "Local cold zone" (satellite depot).',
    fleet_garage_full_title: 'Garage full — 2 trucks max',
    fleet_garage_full_body: 'Your base garage only holds 2 trucks. To acquire a 3rd vehicle (purchase, leasing or financing), build the "Depot expansion (x2)": Depot page → click your HQ on the map → Garage zone.',
    fleet_garage_full_btn: 'Garage full',
    contracts_out_of_zone_badge: 'Out of zone −{{pct}}%',
    contracts_out_of_zone_tooltip: 'This contract starts in {{city}}, {{distance}} km from your nearest depot. Revenue reduced by {{pct}}% (local subcontracting, empty runs). Open a depot in the region to serve it at full rate.',
    contracts_origin_covered_tooltip: 'Origin: {{city}} — {{distance}} km from your nearest depot (covered zone).',
    contracts_rare_badge: 'Rare opportunity',
    contracts_rare_tooltip: 'Contract outside your usual zones: premium rate (+30 to +50%). A local depot would make it even more profitable.',
    assign_wrong_depot_notice: '{{count}} truck(s) hidden: only trucks from a depot covering {{city}} can serve this contract. Transfer a truck from the Fleet page if needed.',
    vehicle_transfer_status: 'Transfer',
    vehicle_transfer_label: 'Transfer',
    vehicle_transfer_tooltip: 'Convoy this truck to another depot (1 day on the road, €1.20/km, min €300). The attached driver travels along.',
    assign_out_of_zone_banner: '**Out of zone**: this contract starts in **{{city}}** ({{distance}} km from your {{depotCity}} depot). Revenue reduced by **{{pct}}%** — local subcontracting and empty runs. Open a depot in the region to serve this client base at full rate.',
    contracts_sort_tooltip: 'Sort unlocked via your Marketing + Sales team',
    contracts_special_badge: 'SPECIAL',
    contracts_new_badge: 'NEW',
    contracts_new_tooltip: 'Contract that arrived on the market 2 days ago or less',
    contracts_ready_badge: 'READY',
    contracts_ready_tooltip: 'You have a compatible vehicle AND driver available right now. Visible thanks to your Operations Manager.',
    contracts_ready_filter_label: 'Executable now',
    contracts_ready_filter_tooltip: 'Show only contracts you can start immediately (compatible vehicle + driver available).',
    // Spot exclusivity tenders — 04/06/2026
    ao_spot_badge: 'EXCLUSIVE ⚡',
    ao_spot_badge_tooltip: 'Spot exclusivity — availability commitment',
    ao_spot_stat_payout: 'Per-call rate',
    ao_spot_stat_deadline: 'Response deadline',
    ao_spot_stat_calls_per_month: 'Calls/month',
    ao_spot_stat_engagement: 'Engagement',
    ao_spot_deadline_value: '{{n}} d max',
    ao_spot_calls_range: '{{min}}–{{max}}',
    ao_spot_payout_range: '{{min}}–{{max}} €',
    ao_spot_engagement_days: '{{n}} d',
    contracts_permit_label: 'License',
    contracts_gross_margin: 'Gross margin',
    contracts_avoid: 'Avoid',
    contracts_margin_tooltip: 'Estimate: {{revenue}} − {{charges}} = {{margin}} ({{pct}}%)',
    contracts_estimate_detail: 'Estimate detail ({{days}} working days)',
    contracts_revenue_row: 'Revenue',
    contracts_fuel_row: 'Fuel',
    contracts_maintenance_row: 'Maintenance',
    contracts_salary_row: 'Salary',
    contracts_insurance_row: 'Insurance',
    contracts_estimate_footer: 'Variable costs only. Refined in the assignment modal once you pick a vehicle + driver.',

    // === P1 — Midal tax provisioning ===
    tax_prov_title: 'Automatic tax provisioning (Midal perk)',
    tax_prov_status_on: 'Active',
    tax_prov_status_off: 'Inactive',
    tax_prov_locked_badge: 'Hire Midal',
    tax_prov_intro_hired: 'At every contract delivered, **Tristan Midal** automatically sets aside the collected VAT and **25% of CIT provision**. Your displayed treasury is now **your true available cash** — no more year-end surprises.',
    tax_prov_intro_locked: '**Hire Tristan Midal** (CFO, support functions) to unlock automatic VAT + CIT provisioning and **sleep tight** instead of discovering a hole at year-end.',
    tax_prov_tva_reserve: 'VAT reserve',
    tax_prov_is_reserve: 'CIT provision',
    tax_prov_locked_until_decl: 'Locked — released at VAT declaration',
    tax_prov_locked_until_close: 'Locked — released at annual close',
    tax_prov_bonus_explainer: 'At annual close, **any over-provisioning is refunded as bonus** to your treasury. Midal optimises without locking your cash.',

    // === P2 — Réserve fiscale 25 % Livret A ===
    fiscal_reserve_title: '25% Tax reserve (Livret A · {{rate}}%)',
    fiscal_reserve_intro: 'At each monthly close, **25% of net profit** is automatically transferred to a separate Livret A account. The balance earns **{{rate}}% APY** (daily-accrued interest) and is released at annual close to cover CIT or return to treasury.',
    fiscal_reserve_balance_label: 'Reserve balance',
    fiscal_reserve_interest_label: 'Interest accrued',
    fiscal_reserve_locked_hint: 'Released at annual close',
    fiscal_reserve_apy: 'Annual yield {{rate}}%',

    // === 14/06/2026 — TVA/IS payment delegation (Accountant / CFO) ===
    tax_autopay_title: 'VAT & CIT payment delegation',
    tax_autopay_locked_badge: 'Accountant / CFO required',
    tax_autopay_intro_hired: '**{{name}}** ({{role}}) automatically files and pays the VAT and CIT instalments at each deadline, whenever the provision or the treasury allows. Turn off to take back control.',
    tax_autopay_intro_locked: 'Hire an **Accountant** or a **CFO** (Support functions page) to delegate the automatic filing and payment of VAT and CIT instalments.',
    tax_autopay_active_hint: 'At each deadline, {{name}} pays from the provisions first, then from the treasury. If funds fall short, you take back control (DGFiP payment plan, tax credit…).',

    // === P3 — Acquired driver bios ===
    acq_drv_bio_veteran: 'Seasoned road veteran, 25 years behind the wheel. Trusts instinct, allergic to new tools.',
    acq_drv_bio_quiet_pro: 'Discreet and reliable. Doesn\'t make waves — executes cleanly, delivers on time.',
    acq_drv_bio_methodical: 'Logbook fanatic. Double-checks everything before leaving the depot.',
    acq_drv_bio_team_player: 'Great cabin vibe. Always up to help a colleague out of a jam.',
    acq_drv_bio_old_school: 'Transport CAP school, 30 years in the trade. Suspicious of "all-electronic" trucks.',
    acq_drv_bio_eager_youngster: 'License freshly earned, motivation maxed. Asking for their first long-haul run.',
    acq_drv_bio_diplomat: 'Good with clients. Often sent on sensitive runs (key-account deliveries).',

    // === Midal year-end bonus modal ===
    marchetti_bonus_kicker: 'Annual close {{year}} · Tristan Midal',
    marchetti_bonus_title: 'Good news Chief!',
    marchetti_bonus_quote: 'Boss, we had set aside too much for the taxman — {{amount}} is back in your treasury. With me on board, zero nasty surprise.',
    marchetti_bonus_is_over: 'CIT over-provision · refund',
    marchetti_bonus_reserve_release: 'Livret A fiscal reserve · annual release',
    marchetti_bonus_interest_included: 'incl. +{{interest}} of capitalised interest',
    marchetti_bonus_cta: 'Excellent — back to treasury',

    // === Annual board meeting (Comité de direction) — 31/05/2026 ===
    board_meeting_kicker: 'Board meeting · Year {{year}}',
    board_meeting_title: 'Great year wrap-up!',
    board_meeting_progress: 'Speaker {{current}} / {{total}}',
    board_meeting_prev: 'Previous',
    board_meeting_next: 'Next',
    board_meeting_close: 'Close the meeting',

    // === Support roles & families (data layer i18n) — 30/05/2026 ===
    support_family_admin_name: "Administration / Operations",
    support_family_commerce_name: "Sales",
    support_family_marketing_name: "Marketing",
    support_family_communication_name: "Communications",
    support_family_achats_name: "Procurement",
    support_family_finance_name: "Accounting / Finance",
    support_family_rh_name: "Human Resources",
    support_family_sav_name: "Customer Service / Call Center",
    support_family_garage_name: "Garage / Mechanic",
    support_family_qhse_name: "QHSE / CSR",
    support_role_role_nathalie_robert_title: "Administrative Assistant",
    support_role_role_nathalie_robert_bg: "Business management graduate. Methodical and rigorous, takes daily admin off your shoulders.",
    support_role_role_nathalie_robert_prereq: "Revenue > €10,000/mo",
    support_role_role_nathalie_robert_bonus_0: "+10% revenue (smoother invoicing)",
    support_role_role_christophe_faure_title: "Operations Manager",
    support_role_role_christophe_faure_bg: "15 years as a transport ops manager. Pilots routes and incidents with military rigor.",
    support_role_role_christophe_faure_prereq: "Revenue > €25,000/mo",
    support_role_role_christophe_faure_bonus_0: "+20% revenue (optimised planning)",
    support_role_role_christophe_faure_bonus_1: "+1 reputation / month (reliability)",
    support_role_role_lea_bertrand_title: "Junior Sales Rep",
    support_role_role_lea_bertrand_bg: "Ex-sports retail, high energy, hands-on field worker.",
    support_role_role_lea_bertrand_prereq: "Revenue > €5,000/mo",
    support_role_role_lea_bertrand_bonus_0: "+10% revenue on standard contracts",
    support_role_role_marc_dupuis_title: "Field Sales Rep",
    support_role_role_marc_dupuis_bg: "15 years in transport sales. Hunts prospects and works regional trade shows.",
    support_role_role_marc_dupuis_prereq: "Revenue > €20,000/mo",
    support_role_role_marc_dupuis_bonus_0: "+30% revenue (new contracts brought in)",
    support_role_role_sylvie_marchand_title: "Sales Director",
    support_role_role_sylvie_marchand_bg: "Former key-account logistics manager. Opens the doors of premium industry.",
    support_role_role_sylvie_marchand_prereq: "Marc Dupuis hired + Revenue > €50,000/mo",
    support_role_role_sylvie_marchand_bonus_0: "+50% revenue",
    support_role_role_yanis_elkaroui_title: "Marketing Officer",
    support_role_role_yanis_elkaroui_bg: "Communications school grad. Creative and fluent in digital culture.",
    support_role_role_yanis_elkaroui_prereq: "Revenue > €8,000/mo",
    support_role_role_yanis_elkaroui_bonus_0: "+1 notoriety / month (digital presence)",
    support_role_role_yanis_elkaroui_bonus_1: "+5% contracts (storefront effect)",
    support_role_role_camille_roussel_title: "Marketing Manager",
    support_role_role_camille_roussel_bg: "Former ad agency exec. Structures a proper brand strategy.",
    support_role_role_camille_roussel_prereq: "Yanis El Karoui hired",
    support_role_role_camille_roussel_bonus_0: "+2 notoriety / month",
    support_role_role_thomas_vidal_title: "Community Manager",
    support_role_role_thomas_vidal_bg: "Freelance — runs social media and defuses early online crises.",
    support_role_role_thomas_vidal_prereq: "Revenue > €6,000/mo",
    support_role_role_thomas_vidal_bonus_0: "+5% contracts",
    support_role_role_thomas_vidal_bonus_1: "-50% reputation event impact",
    support_role_role_aicha_diallo_title: "Press Officer",
    support_role_role_aicha_diallo_bg: "Ex-press officer. Turns every crisis into a narrative opportunity.",
    support_role_role_aicha_diallo_prereq: "Yanis El Karoui hired",
    support_role_role_aicha_diallo_bonus_0: "+1.5 notoriety / month",
    support_role_role_aicha_diallo_bonus_1: "+0.5 reputation / month (crisis management)",
    support_role_role_karim_benali_title: "Junior Buyer",
    support_role_role_karim_benali_bg: "Ex-buyer at a car manufacturer. Tough and analytical.",
    support_role_role_karim_benali_prereq: "3+ vehicles",
    support_role_role_karim_benali_bonus_0: "-5% fuel cost",
    support_role_role_helene_pichon_title: "Procurement Manager",
    support_role_role_helene_pichon_bg: "Industrial key-account buyer. Negotiates highly favourable framework agreements.",
    support_role_role_helene_pichon_prereq: "Karim Benali hired + 8+ vehicles",
    support_role_role_helene_pichon_bonus_0: "-10% fuel",
    support_role_role_helene_pichon_bonus_1: "-8% maintenance cost",
    support_role_role_sophie_lambert_title: "Accountant",
    support_role_role_sophie_lambert_bg: "DCG accounting degree. Meticulous, skilled at optimising tax deductions.",
    support_role_role_sophie_lambert_prereq: "Revenue > €15,000/mo",
    support_role_role_sophie_lambert_bonus_0: "-3% CIT (tax optimisation)",
    support_role_role_pierre_marchetti_title: "Chief Financial Officer",
    support_role_role_pierre_marchetti_bg: "Ex-CFO at a transport group. Negotiates with banks and anticipates CIT.",
    support_role_role_pierre_marchetti_prereq: "Sophie Lambert hired",
    support_role_role_pierre_marchetti_bonus_0: "Unlocks auto-provisioning of VAT + 25% CIT per contract delivered (zero year-end surprise)",
    support_role_role_pierre_marchetti_bonus_1: "-10% overdraft fees",
    support_role_role_nadia_cheikh_title: "HR Manager",
    support_role_role_nadia_cheikh_bg: "Ex-recruitment consultant. Retains teams and drastically cuts turnover.",
    support_role_role_nadia_cheikh_prereq: "Revenue > €18,000/mo",
    support_role_role_nadia_cheikh_bonus_0: "-50% driver turnover",
    support_role_role_nadia_cheikh_bonus_1: "+5 passive satisfaction / month",
    support_role_role_nadia_cheikh_bonus_2: "+4 recruitable driver profiles (tier 1)",
    support_role_role_nadia_cheikh_bonus_3: "Reveals daily personality traits + compatibility matrix",
    support_role_role_karim_sefrioui_title: "Head Hunter",
    support_role_role_karim_sefrioui_bg: "Transport headhunter — knows the best profiles on the market and unlocks premium talent.",
    support_role_role_karim_sefrioui_prereq: "Nadia Cheikh hired",
    support_role_role_karim_sefrioui_bonus_0: "+4 premium driver profiles (tier 2)",
    support_role_role_karim_sefrioui_bonus_1: "-20% additional turnover reduction",
    support_role_role_lucas_mercier_title: "Hotline Agent",
    support_role_role_lucas_mercier_bg: "Patient and clear on the phone — handles first-line complaints.",
    support_role_role_lucas_mercier_prereq: "Revenue > €10,000/mo",
    support_role_role_lucas_mercier_bonus_0: "+0.5 reputation / month",
    support_role_role_ines_bouchard_title: "Customer Service Manager",
    support_role_role_ines_bouchard_bg: "Builds out a real customer service — methodical and empathic.",
    support_role_role_ines_bouchard_prereq: "Lucas Mercier hired",
    support_role_role_ines_bouchard_bonus_0: "+1 reputation / month",
    support_role_role_ines_bouchard_bonus_1: "-50% reputation event impact",
    support_role_role_mehdi_ferhat_title: "Mechanic",
    support_role_role_mehdi_ferhat_bg: "Mechanic vocational degree + 5 years workshop. Resourceful and efficient.",
    support_role_role_mehdi_ferhat_prereq: "4+ vehicles",
    support_role_role_mehdi_ferhat_bonus_0: "-20% maintenance cost",
    support_role_role_bruno_lavergne_title: "Workshop Manager",
    support_role_role_bruno_lavergne_bg: "Diesel veteran. Anticipates breakdowns before they happen.",
    support_role_role_bruno_lavergne_prereq: "Mehdi Ferhat hired + 10+ vehicles",
    support_role_role_bruno_lavergne_bonus_0: "-40% maintenance cost",
    support_role_role_claire_marechal_title: "QHSE / CSR Manager",
    support_role_role_claire_marechal_bg: "HSE engineer by training, certified ISO 14001 and 45001. Drives corporate social responsibility (CO2, gender parity, wages), mandatory FIMO/FCO trainings and anticipates DREAL/URSSAF audits. Calm, methodical, refuses any safety compromise.",
    support_role_role_claire_marechal_prereq: "Revenue > €35,000/month + 4+ vehicles",
    support_role_role_claire_marechal_bonus_0: "+1 reputation / month (HSE management)",
    support_role_role_claire_marechal_bonus_1: "Unlocks the CSR dashboard (consolidated score)",
    support_role_role_claire_marechal_bonus_2: "Unlocks CSR premium contracts",

    // RSE Dashboard (Phase 1-5, Claire Maréchal)
    rse_dashboard_title: 'CSR / HSE Dashboard',
    rse_locked_subtitle: 'Locked',
    rse_locked_recruit_prefix: 'Hire',
    rse_locked_recruit_suffix: '(QHSE / CSR Manager) under Support functions to unlock:',
    rse_locked_bullet_score: 'Consolidated CSR score (CO2, green fleet, parity, wages)',
    rse_locked_bullet_audit: 'Annual EcoVadis rating (Bronze / Silver / Gold)',
    rse_locked_bullet_contracts: 'CSR premium contracts (public tenders, key accounts)',
    rse_locked_bullet_training: 'Mandatory training compliance tracking (FIMO/FCO)',
    rse_pilot_by_claire: 'Driven by Claire Maréchal',
    rse_overall_label: 'Overall CSR score',
    rse_realtime_caption: 'Recalculated in real time. Annual audit at fiscal year close.',
    rse_sub_co2: 'CO2 / km',
    rse_sub_green: 'Green fleet',
    rse_sub_parity: 'Gender parity',
    rse_sub_wage: 'Wage equity',
    rse_caption_in_fleet: 'in fleet',
    rse_caption_low_carbon: 'low-carbon',
    rse_caption_drivers: 'drivers',
    rse_caption_wage_spread: 'Junior → senior spread',
    rse_caption_vehicles_singular: 'vehicle',
    rse_caption_vehicles_plural: 'vehicles',
    rse_weight_label: 'wt',
    rse_methodology_label: 'Methodology:',
    rse_methodology_text: 'Weighted score: 30% CO2 + 30% green fleet + 20% parity + 20% wage equity. Reaching Silver (≥ 55) unlocks CSR premium contracts; Gold (≥ 75) opens public tenders and responsible procurement.',
    rse_tier_none: 'Not rated',
    rse_tier_bronze: 'Bronze',
    rse_tier_silver: 'Silver',
    rse_tier_gold: 'Gold',

    // HSE Compliance card (Phase 4 + 5)
    hse_compliance_title: 'HSE Compliance — Mandatory trainings',
    hse_chip_compliant: 'Compliant',
    hse_chip_expiring: 'Expiring',
    hse_chip_expired: 'Expired',
    hse_training_fco_short: 'FCO',
    hse_training_medical_short: 'Medical',
    hse_training_adr_short: 'ADR',
    hse_training_caces_short: 'CACES',
    hse_training_na: 'No driver concerned',
    hse_expired_at: 'Expired',
    hse_days_remaining: 'd remaining',
    hse_no_attention: 'No training to renew in the next 60 days.',
    hse_footer_methodology: 'FCO valid 5 years (1800 d), medical 1 year, ADR/CACES 5 years. Medical & FCO weigh ×2 in the score; ADR/CACES ×1. Schedule trainings from the driver HR card.',
    // Contract assign modal — HSE soft block warnings
    contract_hse_medical_blocked: "**{{name}}** cannot be assigned: **medical check expired** (D{{expiresOn}}). Renewal required before any driving.",
    contract_hse_adr_blocked: "**{{name}}** cannot drive this **ADR** vehicle: ADR refresh expired (D{{expiresOn}}). Schedule the refresh before assignment.",

    // ── Tenders / Appels d'Offres (02/06/2026) ──
    ao_page_title: "Tenders",
    ao_page_subtitle: "High-value long-term contracts. Submit a bid then negotiate if the client comes back with a counter-offer.",
    // 15/06/2026 — Tender pipeline (page recap + Dashboard widget)
    ao_widget_title: 'Tenders in progress',
    ao_pipeline_pending: 'Pending bids',
    ao_pipeline_counter: 'Counter-offers to handle',
    ao_pipeline_staff: 'Won tenders to staff',
    ao_staff_section: 'Won tenders — to staff',
    ao_staff_hint: 'Assign a vehicle and a driver to start this contract.',
    ao_staff_btn: 'Assign vehicle & driver',
    ao_staff_deadline: 'Staffing deadline: D+{days} left before cancellation (-10 reputation)',
    ao_staff_deadline_critical: '⚠️ Staffing deadline: D+{days} left before cancellation (-10 reputation)',
    ao_locked_title: "Tenders locked",
    ao_locked_subtitle: "A commercial role is required",
    ao_locked_body: "Premium tenders are only accessible once you hire at least one **commercial role**. The higher the seniority, the more ambitious the tenders become:",
    ao_locked_bullet_junior: "**Léa Bertrand** (junior) — unlocks local tenders (city halls, regional distribution)",
    ao_locked_bullet_senior: "**Marc Dupuis** (senior) — unlocks regional tenders (co-ops, industrials)",
    ao_locked_bullet_expert: "**Sylvie Marchand** (expert) — unlocks national tenders (key accounts, public markets)",
    ao_locked_hint: "Head over to the **Support roles** tab to hire.",
    ao_section_open: "Open tenders",
    ao_section_history: "History",
    ao_empty_title: "No open tender at the moment.",
    ao_empty_hint: "The market publishes new tenders every Monday. Also check that your **fleet**, **HSE compliance** and **CSR tier** are up to standard.",
    ao_eligibility_commercial: "Commercial level",
    ao_eligibility_fleet: "Fleet",
    ao_eligibility_rse: "CSR",
    ao_eligibility_medical: "Medical",
    ao_tier_local: "Local",
    ao_tier_regional: "Regional",
    ao_tier_national: "National",
    ao_card_fleet_count: "{{n}} veh.",
    ao_card_ref_per_day: "Ref / day",
    ao_card_duration: "Imposed duration",
    ao_card_min_fleet: "Min fleet",
    ao_card_min_rse: "Min CSR",
    ao_card_expires_in: "Expires in {{days}} d",
    ao_card_prepare_offer: "Prepare a bid",
    ao_card_pending: "Bid under review",
    ao_card_pending_detail: "€{{price}}/d × {{duration}} d · client reply on D{{day}}.",
    ao_card_probability_estimate: "Estimated probability: ~{{pct}}%",
    ao_card_counter_received: "Counter-offer received",
    ao_card_your_offer: "Your bid",
    ao_card_counter_offer: "Counter-offer",
    ao_card_accept: "Accept",
    ao_card_refuse: "Decline",
    ao_history_won: "Won",
    ao_history_lost: "Lost",
    ao_history_via_negotiation: "(neg.)",

    // Tender application modal
    ao_modal_kicker: "Tender",
    ao_modal_duration_label: "Contract duration (set by the client)",
    ao_modal_duration_unit: "days",
    ao_modal_price_label: "Price / day / vehicle",
    ao_modal_price_hint: "Client ref: €{{ref}}. Accepted range: €{{min}}-{{max}}",
    ao_modal_hse_label: "Proposed HSE / CSR commitment",
    ao_modal_hse_low_label: "Standard",
    ao_modal_hse_low_desc: "Annual KPI",
    ao_modal_hse_medium_label: "Moderate",
    ao_modal_hse_medium_desc: "Bi-annual audit",
    ao_modal_hse_high_label: "Strong",
    ao_modal_hse_high_desc: "Quarterly audit + 25% green fleet",
    ao_modal_intel_title: "Competitive intel",
    ao_modal_proba_label: "Win probability",
    ao_modal_total_value: "Total value if won",
    ao_modal_cancel: "Cancel",
    ao_modal_submit: "Submit bid",
    ao_modal_error_prefix: "Error",
    ao_modal_competitor_range: "Estimated competitor price range:",

    // Board-meeting AO recap (mid-year + annual)
    board_tender_recap_title: "Tenders — {{scope}} recap",
    board_tender_recap_scope_s1: "H1",
    board_tender_recap_scope_year: "year",
    board_tender_winrate_label: "Rate {{pct}}%",
    board_tender_won_label: "Won",
    board_tender_lost_label: "Lost",
    board_tender_pending_label: "Pending",
    board_tender_revenue_label: "Revenue secured",
    board_tender_top_label: "Top contract",
    board_tender_via_counter_one: "{{n}} signature via negotiation",
    board_tender_via_counter_many: "{{n}} signatures via negotiation",

    // ── 02/06/2026 — Fire driver / Mutual termination modal ──
    fire_modal_kicker: "End of contract",
    fire_modal_seniority: "Seniority: {{months}} months",
    fire_modal_gross: "Estimated gross salary: {{amount}}/month",
    fire_modal_mode_rupture_title: "Mutual termination",
    fire_modal_mode_rupture_desc: "Negotiated amicably, no notice period. Recommended.",
    fire_modal_mode_fault_title: "Dismissal",
    fire_modal_mode_fault_desc: "Real and serious cause, 2-month notice required.",
    fire_modal_probation_note: "Seniority below 8 months: termination during probation period. No statutory indemnity is due; only the final pay settlement is paid.",
    fire_modal_row_indemnity: "Termination indemnity (ISRC)",
    fire_modal_row_notice: "Notice period",
    fire_modal_row_paidleave: "Unused paid leave",
    fire_modal_row_charges: "Employer social charges",
    fire_modal_row_total: "Total employer cost",
    fire_modal_cancel: "Cancel",
    fire_modal_confirm: "Confirm · {{amount}}",
    // Notification titles after firing
    fire_notif_probation: "Probation termination",
    fire_notif_fault: "Dismissal",
    fire_notif_rupture: "Mutual termination",
    // Notification body templates (built via tStandalone in severance.js).
    severance_summary_probation: "{{driverName}} — Probation termination ({{months}} months). Final settlement: {{total}}. No statutory indemnity due.",
    severance_summary_rupture: "Mutual termination of {{driverName}} — Seniority: {{months}} months. Estimated gross salary: {{gross}}/month. ISRC: {{indemnity}} · Notice: {{notice}} · Paid leave: {{paidLeave}} · Charges: {{charges}}. Total cost: {{total}}.",
    severance_summary_fault: "Dismissal of {{driverName}} — Seniority: {{months}} months. Estimated gross salary: {{gross}}/month. ISRC: {{indemnity}} · Notice: {{notice}} · Paid leave: {{paidLeave}} · Charges: {{charges}}. Total cost: {{total}}.",

    // ── 02/06/2026 — Auto-entrepreneur incompatibility modal ──
    auto_blocked_kicker: "Incompatible status",
    auto_blocked_title: "Auto-entrepreneur: blocked in HST",
    auto_blocked_intro: "The **Auto-entrepreneur (micro-enterprise)** status is not suitable for HST's gameplay:",
    auto_blocked_bullet_1: "You are a **manager**, not a driver — you will immediately hire **salaried** drivers.",
    auto_blocked_bullet_2: "The micro-enterprise regime **does not allow hiring** employees (the manager operates alone).",
    auto_blocked_bullet_3: "Revenue cap of **€188,700** quickly exceeded in transport.",
    auto_blocked_bullet_4: "Banking credibility **insufficient** to finance a fleet.",
    auto_blocked_pedagogy: "👨‍🏫 **Pedagogy:** in reality, a light transporter who needs no employee can stay as auto-entrepreneur. As soon as they hire, they switch to EI, EURL or SARL.",
    auto_blocked_recommended: "Recommended statuses for HST",
    auto_blocked_choose_ei: "→ Continue as EI",
    auto_blocked_choose_ei_desc: "Simple, no capital, TNS 40%.",
    auto_blocked_choose_eurl: "→ Continue as EURL",
    auto_blocked_choose_eurl_desc: "Single-owner company, IS optional.",
    auto_blocked_choose_other: "Choose another status myself",

    // ── 02/06/2026 — Support hire celebration popup ──
    support_celebration_kicker: "Congratulations",
    support_celebration_title: "{{name}} joins your team!",
    support_celebration_subtitle: "You now have access to",
    support_celebration_continue: "Continue",
    support_celebration_pending_bonuses: "Bonuses available from the next game cycle.",

    // ── 02/06/2026 — HR sub-tabs (moved from Strategy) ──
    hr_tab_compat: "Compatibility",
    hr_tab_rse: "ESG / HSE",

    // ── 02/06/2026 — Strategic acquisition value KPI ──
    comp_strategic_value_label: "Strategic acquisition value",
    comp_strategic_tier_strategic: "Strategic target — high priority",
    comp_strategic_tier_attractive: "Attractive target — good fit",
    comp_strategic_tier_limited: "Limited interest — assess ROI",
    comp_strategic_tier_marginal: "Marginal interest — avoid",
    comp_strategic_dim_fleet: "Fleet (tiers)",
    comp_strategic_dim_specialties: "Specialties",
    comp_strategic_dim_revenue: "Reported revenue",
    comp_strategic_dim_reach: "Coverage (depots)",
    // ── Dashboard Benefits card ──
    benefits_card_title: "Profits & Achievements",
    benefits_card_months_run: "{{n}} months elapsed",
    benefits_card_cumul: "Cumulative profit",
    benefits_card_last12: "Last 12 months",
    benefits_card_best_month: "Best month",
    benefits_card_rewards: "Achievements",
    benefits_card_rewards_sub_some: "achievements unlocked",
    benefits_card_rewards_sub_none: "none yet",
    benefits_card_rewards_positive_years_one: "{{n}} year +",
    benefits_card_rewards_positive_years_many: "{{n}} years +",
    // ── Strategy — Support benefits panel ──
    support_benefits_title: "Benefits of your support staff",
    support_benefits_count_one: "{{n}} hire",
    support_benefits_count_many: "{{n}} hires",
    support_benefits_empty_title: "No support staff hired yet.",
    support_benefits_empty_hint: "Each hire unlocks gameplay perks — visit the HR tab to explore.",
    // ── Annual board meeting — avoidable HR cost card ──
    rh_avoidable_cost_title: "Avoidable HR cost",
    rh_avoidable_cost_summary_one: "{{n}} termination this fiscal year.",
    rh_avoidable_cost_summary_many: "{{n}} terminations this fiscal year.",
    rh_avoidable_cost_breakdown_rupture: "Mutual term.: {{amount}}. ",
    rh_avoidable_cost_breakdown_fault: "Dismissal: {{amount}}. ",
    rh_avoidable_cost_breakdown_probation: "Probation: {{amount}}. ",
    rh_avoidable_cost_tip: "Every departure weighs on cash. Better hiring and retention reduce this line.",
    // ── Admin Licences — Hide TEST toggle ──
    admin_hide_test_label: "Hide TEST",
    admin_hide_test_label_with_count: "Hide TEST ({{n}})",
    admin_hide_test_title: "{{n}} TEST license(s) detected",
    admin_expires_modify_title: "Edit expiration",
    admin_expires_save_title: "Save",
    admin_expires_cancel_title: "Cancel",
    admin_expires_date_required: "Date required",
    admin_expires_preset_30: "+30 d",
    admin_expires_preset_90: "+90 d",
    admin_expires_preset_365: "+1 yr",
    admin_expires_days_remaining: "{{n}}d left",

    // ════ Game Over modal (3-act cinematic) — 03/06/2026 hotfix
    gameover_court_header: 'Commercial Court',
    gameover_act1_title: 'Summons to Court',
    gameover_day_label: 'Day {{day}} of operations',
    gameover_reason_default: 'for sustained insolvency',
    gameover_reason_technical: 'due to an exceptional technical failure',
    gameover_salutation: 'Dear Director,',
    gameover_act1_p1_pre: 'You are summoned this day before the Commercial Court ',
    gameover_act1_p1_post: '. Under articles L631-1 and following of the Commercial Code, your company is subject to a **judicial liquidation procedure**.',
    gameover_act1_p2: 'A liquidator will be appointed to **realise assets** (vehicle sale) and **settle creditors** in priority order. Your employees will be covered by the AGS guarantee scheme.',
    gameover_act1_footer: 'Official document — Commercial Court Registry',
    gameover_act1_next: 'Summon the liquidator',

    gameover_act2_label: 'Act II — Liquidation',
    gameover_act2_title: 'Asset realisation',
    gameover_fleet_sold_label: 'Vehicles sold',
    gameover_fleet_sold_value: '{{count}} vehicle{{plural}} auctioned',
    gameover_drivers_dismissed_label: 'Drivers dismissed',
    gameover_drivers_dismissed_value: '{{count}} driver{{plural}} taken over by AGS',
    gameover_residual_debt_label: 'Residual debt after liquidation',
    gameover_plural_s: 's',
    gameover_activity_duration: 'Activity duration',
    gameover_days: 'days',
    gameover_final_equity: 'Final equity',
    gameover_act2_footer: 'The liquidation is now complete. Assets have been realised.',
    gameover_act2_next: 'See the post-mortem',

    gameover_act3_label: 'Act III — Post-mortem',
    gameover_act3_title: 'Lessons learned',
    gameover_act3_summary: 'Over {{days}} days of operations: €{{revenue}} revenue for €{{expenses}} expenses.',
    gameover_three_causes: 'The 3 main causes',
    gameover_tips_label: 'Tips for the next game',
    gameover_wisdom_bonus: '*"Bankruptcy is not a failure, it is a school. Maurice Lebon, former logistics director, who has seen worse."*',
    gameover_restart_btn: 'Start a new game',

    // Contract assignment modal banner — 03/06/2026
    contract_assignment: 'Contract assignment',

    // Assignment conflict modal — 04/06/2026
    assignment_conflict_title: 'Assignment conflict',
    assignment_conflict_intro: 'Taking this contract will **interrupt** the following active contract(s):',
    assignment_conflict_vehicle_busy: 'Vehicle already on:',
    assignment_conflict_driver_busy: 'Driver already on:',
    assignment_conflict_days_remaining: '{{days}}d remaining',
    assignment_conflict_warning: 'Interrupted contracts will cost you -3 reputation points each. The client will be notified and their loyalty will drop by -15 points.',
    assignment_conflict_keep: 'Keep my current contracts',
    assignment_conflict_force: 'Interrupt and take this contract',
    assignment_conflict_notif_title: 'Contract interrupted',
    assignment_conflict_notif_message: 'Contract "{{name}}" was interrupted following the reassignment of its vehicle/driver. Reputation -3.',

    // ============== Phases & Atouts panel (08/02/2026 refonte) =========
    phases_atouts_title: 'Phases & Perks',
    phases_atouts_intro: 'Visualize the 4 game phases and the levers — support functions, infrastructure investments and combined bonuses — as a skill tree. Green nodes are active, blue ones to unlock, gray ones locked.',
    phases_panel_progress_title: 'Game progression — 4 phases',
    phases_panel_current_label: 'Current phase',
    phases_panel_trigger_label: 'Trigger',
    phases_panel_unlocks_label: 'Unlocks',
    phases_panel_aria_current: 'Current phase',
    phases_panel_aria_reached: 'Phase reached',
    phases_panel_aria_locked: 'Phase locked',
    phases_panel_features_title: 'Features unlocked by hiring',
    phases_panel_features_intro: 'Each line shows a game feature and the support role(s) you can hire to unlock it. Green = already active, gray = to unlock.',
    phases_panel_th_state: 'State',
    phases_panel_th_feature: 'Feature',
    phases_panel_th_recruit: 'Hire',
    phases_panel_unlocked: 'Unlocked',
    phases_panel_to_unlock: 'To unlock',
    phases_panel_or: 'or',
    phase_1_label: 'Phase 1 — Local',
    phase_2_label: 'Phase 2 — Regional',
    phase_3_label: 'Phase 3 — National',
    phase_4_label: 'Phase 4 — International',
    phase_1_trigger_1: 'Game start (default, no condition).',
    phase_1_unlock_1: 'Tier 1 and Tier 2 contracts (messaging, light bulk, local refrigerated)',
    phase_1_unlock_2: 'Five FR local cities: Paris, Lyon, Marseille, Bordeaux, Lille',
    phase_1_unlock_3: '3 depots maximum',
    phase_2_trigger_1: 'Buy the "Depot enlargement (x2)" investment for €8,000 (4 vehicle slots).',
    phase_2_unlock_1: 'Tier 3 contracts (inter-regional loads, long-distance refrigerated, semi-heavy construction)',
    phase_2_unlock_2: 'HQ capacity +10% (impactMultiplier)',
    phase_2_unlock_3: 'Still 3 depots max — encourages investing in quality before quantity',
    phase_3_trigger_1: 'Open a new depot in France (excluding HQ)',
    phase_3_trigger_2: 'OR buy out a competitor (M&A finalized)',
    phase_3_trigger_3: 'OR buy the "Logistics extension (+100 km)" investment (€18,000) — or a radiusExtension upgrade on a satellite depot.',
    phase_3_unlock_1: 'Tier 4 and Tier 5 contracts (ADR, exceptional convoy, machine carrier, agricultural)',
    phase_3_unlock_2: 'All FR cities open (Nantes, Toulouse, Nice, Montpellier...)',
    phase_3_unlock_3: '5 depots maximum — national network',
    phase_3_unlock_4: 'Leasing freed (no cap) — access to financial groupings',
    phase_4_trigger_1: 'Open a depot abroad (Barcelona, Madrid, Frankfurt, Milan, Brussels...)',
    phase_4_trigger_2: 'OR buy a Tier 5 vehicle (R 650 V8, FX Electric, Heavyhaul XXL, Machine carrier).',
    phase_4_unlock_1: 'International contracts (EU export, Spain/Germany loads, EU refrigerated)',
    phase_4_unlock_2: 'International tax tab (intra-EU VAT, customs, incoterms)',
    phase_4_unlock_3: 'CEO retirement pension calculable',
    phase_4_unlock_4: 'Exceptional tenders (Heavyhaul, ADR convoy)',
    phase_4_unlock_5: '10 depots maximum (incl. 2 international) + electric transition (☀️ solar, 🔌 charging station)',
    feature_label_fiscal_simulator: 'Tax simulator (CIT/PIT/dividends)',
    feature_label_audit_fiscal: 'Anticipated tax audit',
    feature_label_hr_dashboard: 'Advanced HR dashboard',
    feature_label_market_intel: 'Market intel — competitor analysis',
    feature_label_salons: '"Trade shows & events" Dashboard action',
    feature_label_grands_comptes: 'Key Account contracts (high value)',
    feature_label_contrats_cadres: 'Frame contracts (group purchasing −%)',
    feature_label_crisis_comm: '"Crisis communication" choice (mitigates rep)',
    feature_label_negociation_taux: 'Loan rate negotiation (−1%)',
    feature_label_diag_preventif: 'Preventive diagnosis (−50% breakdowns)',
    feature_label_tax_auto_provisioning: 'Automatic tax provisioning',
    sup_notify_milestones_no_email: 'Set a contact email in Admin → Licenses to enable this option.',
    sup_notify_milestones_active_tip: 'Receive an email on every learner phase upgrade. Click to disable.',
    sup_notify_milestones_off_tip: 'Click to receive an email on every learner phase upgrade.',
    sup_notify_milestones_label: 'Milestone emails {{state}}',
    hr_tab_former: 'Former drivers',
    fisc_tab_urssaf: 'URSSAF',
    hr_filter_title: 'Filters',
    hr_filter_all: 'All',
    hr_filter_available: 'Available',
    hr_filter_mission: 'On mission',
    hr_filter_training: 'In training',
    hr_filter_absent: 'Absent (leave, sick…)',
    hr_filter_license: 'Licence',
    hr_filter_level: 'Level',
    hr_filter_level_short: 'Lvl',
    hr_filter_availability: 'Availability',
    hr_filter_salary: 'Employer cost',
    hr_filter_specialty: 'Specialty',
    hr_filter_reset: 'Reset',
    hr_filter_shown: '{{shown}}/{{total}} shown',
    hr_filter_empty_team: 'No driver matches the filters.',
    hr_filter_empty_recruit: 'No candidate matches the filters.',
    btn_my_profile_pdf: 'My learner profile',
    btn_my_profile_pdf_title: 'Download your learner profile PDF (same document as the trainer\'s)',
    my_profile_pdf_error: 'Could not generate the learner profile.',
    my_profile_pdf_not_started: 'Start a game to generate your learner profile.',
  },
};
